import { gameTypes } from "../../config/const";
import { pageUrlGenerator } from "./SlotGames.data";

export const casinoGamesList = {
  roulette: {
    AutoRouletteEzg: {
      href: "/casino/ezg-auto-roulette",
      code: "1000148",
      casino: "ezugi",
      category: "roulette",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/Autoroulette1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Auto Roulette",
      gameType: gameTypes.popular,
    },
    CasinoMarinaRoulette1Ezg: {
      href: "/casino/ezg-casino-marina-roulette-1",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/CasinoMarinaRoulette11.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Casino Marina Roulette 1",
      gameType: gameTypes.new,
    },
    CasinoMarinaRoulette2Ezg: {
      href: "/casino/ezg-casino-marina-roulette-2",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/CasinoMarinaRoulette21.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Casino Marina Roulette 2",
      gameType: gameTypes.new,
    },
    CricketAutoRouletteEzg: {
      href: "/casino/ezg-cricket-auto-roulette",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/CricketAutoRoulette1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Cricket Auto Roulette",
      gameType: gameTypes.popular,
    },
    DiamondRouletteEzg: {
      href: "/casino/ezg-diamond-roulette",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/DiamondRoulette1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Diamond Roulette",
      gameType: gameTypes.popular,
    },
    FirstPersonAmericanRouletteEzg: {
      href: "/casino/ezg-first-person-american-roulette",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/FirstPersonAmericanRoulette1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "First Person American Roulette",
      gameType: gameTypes.new,
    },
    FootballAutoRouletteEzg: {
      href: "/casino/ezg-football-auto-roulette",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/FootballAutoRoulette1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Football Auto Roulette",
      gameType: gameTypes.new,
    },
    ItalianRouletteEzg: {
      href: "/casino/ezg-italian-roulette",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/ItalianRoulette1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Italian Roulette",
      gameType: gameTypes.popular,
    },
    NamasteRouletteEzg: {
      href: "/casino/ezg-namaste-roulette",
      code: "1000148",
      casino: "ezugi",
      category: "roulette",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/NamasteRoulette1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Namaste Roulette",
      gameType: gameTypes.popular,
    },
    RoletaDaSorteEzg: {
      href: "/casino/ezg-roleta-da-sorte",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/roletadasorte1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Roleta Da Sorte",
      gameType: gameTypes.new,
    },
    // RuletaAEzg: {
    //   href: "/casino/ezg-ruleta-a",
    //   code: "",
    //   casino: "ezugi",
    //   category: "roulette",
    //   provider: "ezugi",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/roulette/ezugi/RuletaA.webp",
    //   plaBtn: "./images/play-btn.png",
    //   alt: "",
    //   name: "Ruleta A",
    //   gameType: gameTypes.new, // },
    RuletaDelSolEzg: {
      href: "/casino/ezg-ruleta-del-sol",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/RuletaDelSol.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Ruleta Del Sol",
      gameType: gameTypes.new,
    },
    RussianRouletteEzg: {
      href: "/casino/ezg-russian-roulette",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/RussianRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Russian Roulette",
      gameType: gameTypes.popular,
    },
    SkylineRouletteEzg: {
      href: "/casino/ezg-skyline-roulette",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/SkylineRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Skyline Roulette",
      gameType: gameTypes.new,
    },
    SpanishRouletteEzg: {
      href: "/casino/ezg-spanish-roulette",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/SpanishRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Spanish Roulette",
      gameType: gameTypes.popular,
    },
    SpeedAutoRouletteEzg: {
      href: "/casino/ezg-speed-auto-roulette",
      code: "221002",
      casino: "ezugi",
      category: "roulette",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/SpeedAutoRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Speed Auto Roulette",
      gameType: gameTypes.popular,
    },
    SpeedRouletteEzg: {
      href: "/casino/ezg-speed-roulette",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/SpeedRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Speed Roulette",
      gameType: gameTypes.popular,
    },
    TurkishRouletteEzg: {
      href: "/casino/ezg-turkish-roulette",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/TurkishRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Turkish Roulette",
      gameType: gameTypes.popular,
    },
    UltimateRouletteEzg: {
      href: "/casino/ezg-ultimate-roulette",
      code: "1000148",
      casino: "ezugi",
      category: "roulette",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/UltimateRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Ultimate Roulette",
      gameType: gameTypes.popular,
    },
    VIPRouletteEzg: {
      href: "/casino/ezg-vip-roulette",
      code: "1000148",
      casino: "ezugi",
      category: "roulette",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/VIPRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "VIP Roulette",
      gameType: gameTypes.popular,
    },

    AmericanRouletteEvo: {
      href: "/casino/ezgevo-american-roulette",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/AmericanRoulette1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "American Roulette",
      gameType: gameTypes.popular,
    },
    AutoRouletteEvo: {
      href: "/casino/ezgevo-auto-roulette",
      code: "1000148",
      casino: "ezugi",
      category: "roulette",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/AutoRoulette1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Auto Roulette",
      gameType: gameTypes.popular,
    },
    DoubleBallRouletteEvo: {
      href: "/casino/ezgevo-double-ball-roulette",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/DoubleBallRoulette1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Double Ball Roulette",
      gameType: gameTypes.new,
    },
    DragonaraRouletteEvo: {
      href: "/casino/ezgevo-dragonara-roulette",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/DragonaraRoulette1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Dragonara Roulette",
      gameType: gameTypes.new,
    },
    FirstPersonAmericanRouletteEvo: {
      href: "/casino/ezgevo-first-person-american-roulette",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/FirstPersonAmericanRoulette1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "First Person American Roulette",
      gameType: gameTypes.new,
    },
    FootballStudioRouletteEvo: {
      href: "/casino/ezgevo-football-studio-roulette",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/FootballStudioRoulette1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Football Studio Roulette",
      gameType: gameTypes.new,
    },
    InstantRouletteEvo: {
      href: "/casino/ezgevo-instant-roulette",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/InstantRoulette1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Instant Roulette",
      gameType: gameTypes.new,
    },
    LightningRouletteEvo: {
      href: "/casino/ezgevo-lightning-roulette",
      code: "1000148",
      casino: "ezugi",
      category: "roulette",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/LightningRoulette1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Lightning Roulette",
      gameType: gameTypes.popular,
    },
    RoulettEvo: {
      href: "/casino/ezgevo-roulette",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/Roulette1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Roulette",
      gameType: gameTypes.popular,
    },
    SpeedAutoRouletteEvo: {
      href: "/casino/ezgevo-speed-auto-roulette",
      code: "1000103",
      casino: "ezugi",
      category: "roulette",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/SpeedAutoRoulette1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Speed Auto Roulette-EVO",
      gameType: gameTypes.popular,
    },
    SpeedRouletteEvo: {
      href: "/casino/ezgevo-speed-roulette",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/SpeedRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Speed Roulette",
      gameType: gameTypes.popular,
    },
    TurkishLightningRouletteEvo: {
      href: "/casino/ezgevo-turkish-lightning-roulette",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/TurkishLightningRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Turkish Lightning Roulette",
      gameType: gameTypes.popular,
    },
    VIPRouletteEvo: {
      href: "/casino/ezgevo-vip-roulette",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/VipRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "VIP Roulette",
      gameType: gameTypes.popular,
    },
    XxxtremeLightningRouletteEvo: {
      href: "/casino/ezgevo-xxxtreme-lightning-roulette",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/XxxtremeLightningRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Xxxtreme Lightning Roulette",
      gameType: gameTypes.popular,
    },

    RouletteAura: {
      href: "/casino/aura-roulette",
      code: "",
      casino: "aura",
      category: "roulette",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/aura/Roulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Roulette",
      gameType: gameTypes.popular,
    },

    EuropeanAutoRouletteVivo: {
      href: "/casino/vivo-european-auto-roulette",
      code: "",
      casino: "vivo",
      category: "roulette",
      provider: "vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/vivo/EuropeanAutoRoulette1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "European Auto Roulette",
      gameType: gameTypes.new,
    },
    FrenchRouletteVivo: {
      href: "/casino/vivo-french-roulette",
      code: "",
      casino: "vivo",
      category: "roulette",
      provider: "vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/vivo/FrenchRoulette1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "French Roulette",
      gameType: gameTypes.new,
    },
    GalaxyRouletteVivo: {
      href: "/casino/vivo-galaxy-roulette",
      code: "",
      casino: "vivo",
      category: "roulette",
      provider: "vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/vivo/GalaxyRoulette1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Galaxy Roulette",
      gameType: gameTypes.popular,
    },
    LasVegasRouletteVivo: {
      href: "/casino/vivo-las-vegas-roulette",
      code: "",
      casino: "vivo",
      category: "roulette",
      provider: "vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/vivo/Lasvegasroulette1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "las vegas roulette",
      name: "Las Vegas Roulette",
      gameType: gameTypes.popular,
    },
    Oracle360RouletteVivo: {
      href: "/casino/vivo-oracle-360-roulette",
      code: "",
      casino: "vivo",
      category: "roulette",
      provider: "vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/vivo/Oracle360Roulette1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Oracle 360 Roulette",
      gameType: gameTypes.popular,
    },
    OracleBlazeRouletteVivo: {
      href: "/casino/vivo-oracle-blaze-roulette",
      code: "",
      casino: "vivo",
      category: "roulette",
      provider: "vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/vivo/OracleBlazeRoulette1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "oracle blaze roulette",
      name: "Oracle Blaze Roulette",
      gameType: gameTypes.popular,
    },
    PortomasoRouletteVivo: {
      href: "/casino/vivo-portomaso-roulette",
      code: "",
      casino: "vivo",
      category: "roulette",
      provider: "vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/vivo/PortomasoRoulette1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "vivo portomaso roulette",
      name: "Vivo Portomaso Roulette",
      gameType: gameTypes.popular,
    },
    VARouletteVivo: {
      href: "/casino/vivo-va-roulette",
      code: "",
      casino: "vivo",
      category: "roulette",
      provider: "vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/vivo/VARoulette1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "VA Roulette",
      gameType: gameTypes.new,
    },

    // RouletteSn: {
    //   href: "/casino/sn-roulette",
    //   code: "",
    //   casino: "wco",
    //   category: "roulette",
    //   provider: "supernowa",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/roulette/supernowa/Roulette.webp",
    //   plaBtn: "./images/play-btn.png",
    //   alt: "",
    //   name: "Roulette",
    //   gameType: gameTypes.popular, // },

    EuropeanRouletteKM: {
      href: "/casino/km-european-roulette",
      code: "",
      casino: "",
      category: "roulette",
      provider: "kingmaker",
      imgUrl: "./images/kingmaker/roulette/EuropeanRoulette1.webp",
      plaBtn: "./images/play-btn.png",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "European Roulette",
      gameType: gameTypes.popular,
    },
    FruitRouletteKM: {
      href: "/casino/km-fruit-roulette",
      code: "",
      casino: "",
      category: "roulette",
      provider: "kingmaker",
      imgUrl: "./images/kingmaker/roulette/FruitRoulette1.webp",
      plaBtn: "./images/play-btn.png",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "FruitRoulette",
      gameType: gameTypes.popular,
    },
    MonkeyKingRouletteKM: {
      href: "/casino/km-monkey-king-roulette",
      code: "",
      casino: "",
      category: "roulette",
      provider: "kingmaker",
      imgUrl: "./images/kingmaker/roulette/MonkeyKingRoulette1.webp",
      plaBtn: "./images/play-btn.png",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Monkey King Roulette",
      gameType: gameTypes.new,
    },
    PokerRouletteKM: {
      href: "/casino/km-poker-roulette",
      code: "",
      casino: "",
      category: "roulette",
      provider: "kingmaker",
      imgUrl: "./images/kingmaker/roulette/PokerRoulette1.webp",
      plaBtn: "./images/play-btn.png",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Poker Roulette",
      gameType: gameTypes.popular,
    },

    // RouletteAes: {
    //   href: "/casino/awc-roulette",
    //   code: "",
    //   casino: "AE Sexy",
    //   category: "roulette",
    //   provider: "Worldcasino",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/aesexy/Roulette.webp",
    //   plaBtn: "./images/play-btn.png",
    //   alt: "Roulette",
    //   name: "Roulette",
    //   gameType: gameTypes.popular,
    // },
  },

  andarbahar: {
    AndarBaharEzg: {
      href: "/casino/ezg-andar-bahar",
      code: "328000",
      casino: "ezugi",
      category: "andarbahar",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/andarbahar/ezugi/AndarBahar.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Andar Bahar",
      name: "Andar Bahar",
      gameType: gameTypes.popular,
    },
    OTTAndarBaharEzg: {
      href: "/casino/ezg-casino-marina-andar-bahar",
      code: "328000",
      casino: "ezugi",
      category: "andarbahar",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/andarbahar/ezugi/OTTAndarBahar.webp",
      plaBtn: "./images/play-btn.png",
      alt: "OTT Andar Bahar",
      name: "OTT Andar Bahar",
      gameType: gameTypes.popular,
    },
    UltimateAndarBaharEzg: {
      href: "/casino/ezg-ultimate-andar-bahar",
      code: "328000",
      casino: "ezugi",
      category: "andarbahar",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/andarbahar/ezugi/UltimateAndarBahar.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Ultimate Andar Bahar",
      name: "Ultimate Andar Bahar",
      gameType: gameTypes.popular,
    },

    AndarBaharAura: {
      href: "/casino/aura-andar-bahar",
      code: "",
      casino: "aura",
      category: "andarbahar",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/andarbahar/aura/AndarBahar.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Andar Bahar",
      name: "Andar Bahar",
      gameType: gameTypes.new,
    },
    AndarBaharVirtualAura: {
      href: "/casino/aura-andar-bahar-virtual",
      code: "",
      casino: "aura",
      category: "andarbahar",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/andarbahar/aura/AndarBaharVirtual.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Andar Bahar (Virtual)",
      name: "Andar Bahar (Virtual)",
      gameType: gameTypes.new,
    },

    AndarBaharVivo: {
      href: "/casino/vivo-andar-bahar",
      code: "",
      casino: "vivo",
      category: "andarbahar",
      provider: "vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/andarbahar/Vivo/AndarBaharVivo.webp",
      plaBtn: "./images/play-btn.png",
      alt: "andar bahar",
      name: "Andar Bahar",
      gameType: gameTypes.popular,
    },

    // RNGAndarBahar2020Sn: {
    //   href: "/casino/sn-rng-andar-bahar-2020",
    //   code: "",
    //   casino: "wco",
    //   category: "andarbahar",
    //   provider: "supernowa",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/andarbahar/supernowa/RNGAndarBahar2020.webp",
    //   plaBtn: "./images/play-btn.png",
    //   alt: "RNG Andar Bahar 2020",
    //   name: "RNG Andar Bahar 2020",
    //   gameType: gameTypes.new,
    // },

    AndarBaharKM: {
      href: "/casino/km-andar-bahar",
      code: "",
      casino: "",
      category: "andarbahar",
      provider: "kingmaker",
      imgUrl: "./images/kingmaker/andar-bahar/AndarBahar1.webp",
      plaBtn: "./images/play-btn.png",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Andar Bahar",
      gameType: gameTypes.popular,
    },

    // ExtraAndarBaharAes: {
    //   href: "/casino/awc-extra-andar-bahar",
    //   code: "",
    //   casino: "AE Sexy",
    //   category: "andarbahar",
    //   provider: "worldcasino",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/aesexy/AndarBahar.webp",
    //   plaBtn: "./images/play-btn.png",
    //   alt: "Extra Andar Bahar",
    //   name: "Extra Andar Bahar",
    //   gameType: gameTypes.new,
    // },
  },

  livecasino: {
    AndarBaharEzgLC: {
      href: "/casino/ezg-andar-bahar",
      code: "328000",
      casino: "ezugi",
      category: "livecasino",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/andarbahar/ezugi/AndarBahar.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Andar Bahar",
      name: "Andar Bahar",
      gameType: gameTypes.popular,
    },
    LightningRouletteEvoLC: {
      href: "/casino/ezgevo-lightning-roulette",
      code: "1000148",
      casino: "ezugi",
      category: "livecasino",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/LightningRoulette1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Lightning Roulette",
      gameType: gameTypes.popular,
    },
    GodOfWealthLC: {
      href: "/casino/ezgrt-god-of-wealth",
      code: "1100001",
      casino: "ezugi",
      category: "livecasino",
      provider: "slots",
      homeUrl: pageUrlGenerator("/slots"),
      imgUrl: "./images/slots/redtiger/GodOfWealth.webp",
      plaBtn: "./images/play-btn.png",
      alt: "God Of Wealth",
      name: "God Of Wealth",
      gameType: gameTypes.new,
    },
    UltimateRouletteEzgLC: {
      href: "/casino/ezg-ultimate-roulette",
      code: "1000148",
      casino: "ezugi",
      category: "livecasino",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/UltimateRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Ultimate Roulette",
      gameType: gameTypes.popular,
    },
    LasVegasRouletteVivoLC: {
      href: "/casino/vivo-las-vegas-roulette",
      code: "",
      casino: "vivo",
      category: "livecasino",
      provider: "vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/vivo/Lasvegasroulette1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "las vegas roulette",
      name: "Las Vegas Roulette",
      gameType: gameTypes.popular,
    },
    LuckyFortuneCatLC: {
      href: "/casino/ezgrt-lucky-fortune-cat",
      code: "1100001",
      casino: "ezugi",
      category: "livecasino",
      provider: "slots",
      homeUrl: pageUrlGenerator("/slots"),
      imgUrl: "./images/slots/redtiger/LuckyFortuneCat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Lucky Fortune Cat",
      name: "Lucky Fortune Cat",
      gameType: gameTypes.popular,
    },
    SuperSicboEvoLC: {
      href: "/casino/ezgevo-super-sic-bo",
      code: "",
      casino: "ezugi",
      category: "livecasino",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/dice/SuperSicBo.jpg",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Super Sic Bo",
      gameType: gameTypes.popular,
    },
    KnockoutBaccaratEzgLC: {
      href: "/casino/ezg-knockout-baccarat",
      code: "",
      casino: "ezugi",
      category: "livecasino",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/KnockoutBaccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Knockout Baccarat",
      name: "Knockout Baccarat",
      gameType: gameTypes.popular,
    },
    LightningBaccaratEvoLC: {
      href: "/casino/ezgevo-lightning-baccarat",
      code: "",
      casino: "ezugi",
      category: "livecasino",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/LightningBaccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Lightning Baccarat",
      name: "Lightning Baccarat",
      gameType: gameTypes.popular,
    },
    GonzosTreasureHuntLC: {
      href: "/casino/ezgne-gonzos-treasure-hunt",
      code: "",
      casino: "ezugi",
      category: "livecasino",
      provider: "slots",
      homeUrl: pageUrlGenerator("/slots"),
      imgUrl: "./images/slots/netent/GonzosTreasureHunt.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Gonzos Treasure Hunt",
      name: "Gonzos Treasure Hunt",
      gameType: gameTypes.popular,
    },
  },

  //   slots: {
  //     Christmas: {
  //       href: "/casino/ezgne-aloha-christmas",
  //       code: "1100032",
  //       casino: "ezugi",
  //       category: "slots",
  //       provider: "slots",
  //       homeUrl: pageUrlGenerator("/slots"),
  //       imgUrl: "./images/slots/netent/AlohaChristmas.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Aloha! Christmas",
  //       name: "Aloha! Christmas",
  //       gameType: gameTypes.new,
  //     },
  //     BloodSuckers: {
  //       href: "/casino/ezgne-blood-suckers",
  //       code: "",
  //       casino: "ezugi",
  //       category: "slots",
  //       provider: "slots",
  //       homeUrl: pageUrlGenerator("/slots"),
  //       imgUrl: "./images/slots/netent/BloodSuckers.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Blood Suckers",
  //       name: "Blood Suckers",
  //       gameType: gameTypes.popular,
  //     },
  //     ButterflyStaxx: {
  //       href: "/casino/ezgne-butterfly-staxx",
  //       code: "",
  //       casino: "ezugi",
  //       category: "slots",
  //       provider: "slots",
  //       homeUrl: pageUrlGenerator("/slots"),
  //       imgUrl: "./images/slots/netent/ButterflyStaxx.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Butterfly Staxx",
  //       name: "Butterfly Staxx",
  //       gameType: gameTypes.new,
  //     },
  //     GonzosTreasureHunt: {
  //       href: "/casino/ezgne-gonzos-treasure-hunt",
  //       code: "",
  //       casino: "ezugi",
  //       category: "slots",
  //       provider: "slots",
  //       homeUrl: pageUrlGenerator("/slots"),
  //       imgUrl: "./images/slots/netent/GonzosTreasureHunt.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Gonzos Treasure Hunt",
  //       name: "Gonzos Treasure Hunt",
  //       gameType: gameTypes.popular,
  //     },
  //     GorillaKingdom: {
  //       href: "/casino/ezgne-gorilla-kingdom",
  //       code: "1100088",
  //       casino: "ezugi",
  //       category: "slots",
  //       provider: "slots",
  //       homeUrl: pageUrlGenerator("/slots"),
  //       imgUrl: "./images/slots/netent/GorillaKingdom.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Gorilla Kingdom",
  //       name: "Gorilla Kingdom",
  //       gameType: gameTypes.popular,
  //     },
  //     PiggyRiches: {
  //       href: "/casino/ezgne-piggy-riches",
  //       code: "1100080",
  //       casino: "ezugi",
  //       category: "slots",
  //       provider: "slots",
  //       homeUrl: pageUrlGenerator("/slots"),
  //       imgUrl: "./images/slots/netent/PiggyRiches.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Piggy Riches",
  //       name: "Piggy Riches",
  //       gameType: gameTypes.new,
  //     },
  //     ReelRush: {
  //       href: "/casino/ezgne-reel-rush",
  //       code: "",
  //       casino: "ezugi",
  //       category: "slots",
  //       provider: "slots",
  //       homeUrl: pageUrlGenerator("/slots"),
  //       imgUrl: "./images/slots/netent/ReelRush.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Reel Rush",
  //       name: "Reel Rush",
  //       gameType: gameTypes.popular,
  //     },
  //     RomeTheGoldenAge: {
  //       href: "/casino/ezgne-rome-the-golden-age",
  //       code: "",
  //       casino: "ezugi",
  //       category: "slots",
  //       provider: "slots",
  //       homeUrl: pageUrlGenerator("/slots"),
  //       imgUrl: "./images/slots/netent/RomeTheGoldenAge.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Rome The Golden Age",
  //       name: "Rome The Golden Age",
  //       gameType: gameTypes.new,
  //     },
  //     SteamTower: {
  //       href: "/casino/ezgne-steam-tower",
  //       code: "1100043",
  //       casino: "ezugi",
  //       category: "slots",
  //       provider: "slots",
  //       homeUrl: pageUrlGenerator("/slots"),
  //       imgUrl: "./images/slots/netent/SteamTower.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Steam Tower",
  //       name: "Steam Tower",
  //       gameType: gameTypes.new,
  //     },
  //     TurnYourFortune: {
  //       href: "/casino/ezgne-turn-your-fortune",
  //       code: "1100041",
  //       casino: "ezugi",
  //       category: "slots",
  //       provider: "slots",
  //       homeUrl: pageUrlGenerator("/slots"),
  //       imgUrl: "./images/slots/netent/TurnYourFortune.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Turn Your Fortune",
  //       name: "Turn Your Fortune",
  //       gameType: gameTypes.popular,
  //     },
  //     TwinSpinMegaways: {
  //       href: "/casino/ezgne-twin-spin-megaways",
  //       code: "1100039",
  //       casino: "ezugi",
  //       category: "slots",
  //       provider: "slots",
  //       homeUrl: pageUrlGenerator("/slots"),
  //       imgUrl: "./images/slots/netent/TwinSpinMegaways.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Twin Spin Megaways",
  //       name: "Twin Spin Megaways",
  //       gameType: gameTypes.popular,
  //     },
  //     Nights10001: {
  //       href: "/casino/ezgrt-10001-nights",
  //       code: "",
  //       casino: "ezugi",
  //       category: "slots",
  //       provider: "slots",
  //       homeUrl: pageUrlGenerator("/slots"),
  //       imgUrl: "./images/slots/redtiger/10,001Nights.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "10,001 Nights",
  //       name: "10,001 Nights",
  //       gameType: gameTypes.popular,
  //     },
  //     AncientsBlessing: {
  //       href: "/casino/ezgrt-ancients-blessing",
  //       code: "",
  //       casino: "ezugi",
  //       category: "slots",
  //       provider: "slots",
  //       homeUrl: pageUrlGenerator("/slots"),
  //       imgUrl: "./images/slots/redtiger/AncientsBlessing.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Ancients Blessing",
  //       name: "Ancients Blessing",
  //       gameType: gameTypes.new,
  //     },
  //     AurumCodex: {
  //       href: "/casino/ezgrt-aurum-codex",
  //       code: "",
  //       casino: "ezugi",
  //       category: "slots",
  //       provider: "slots",
  //       homeUrl: pageUrlGenerator("/slots"),
  //       imgUrl: "./images/slots/redtiger/AurumCodex.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Aurum Codex",
  //       name: "Aurum Codex",
  //       gameType: gameTypes.new,
  //     },
  //     ChineseTreasures: {
  //       href: "/casino/ezgrt-chinese-treasures",
  //       code: "",
  //       casino: "ezugi",
  //       category: "slots",
  //       provider: "slots",
  //       homeUrl: pageUrlGenerator("/slots"),
  //       imgUrl: "./images/slots/redtiger/ChineseTreasures.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Chinese Treasures",
  //       name: "Chinese Treasures",
  //       gameType: gameTypes.popular,
  //     },
  //     DragonLuck: {
  //       href: "/casino/ezgrt-dragons-luck",
  //       code: "1100001",
  //       casino: "ezugi",
  //       category: "slots",
  //       provider: "slots",
  //       homeUrl: pageUrlGenerator("/slots"),
  //       imgUrl: "./images/slots/redtiger/DragonsLuck.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Dragon's Luck",
  //       name: "Dragon's Luck",
  //       gameType: gameTypes.popular,
  //     },
  //     EpicJourney: {
  //       href: "/casino/ezgrt-epic-journey",
  //       code: "1100001",
  //       casino: "ezugi",
  //       category: "slots",
  //       provider: "slots",
  //       homeUrl: pageUrlGenerator("/slots"),
  //       imgUrl: "./images/slots/redtiger/EpicJourney.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Epic Journey",
  //       name: "Epic Journey",
  //       gameType: gameTypes.new,
  //     },
  //     FortuneHouse: {
  //       href: "/casino/ezgrt-fortune-house",
  //       code: "1100001",
  //       casino: "ezugi",
  //       category: "slots",
  //       provider: "slots",
  //       homeUrl: pageUrlGenerator("/slots"),
  //       imgUrl: "./images/slots/redtiger/FortuneHouse.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Fortune House",
  //       name: "Fortune House",
  //       gameType: gameTypes.popular,
  //     },
  //     GodOfWealth: {
  //       href: "/casino/ezgrt-god-of-wealth",
  //       code: "1100001",
  //       casino: "ezugi",
  //       category: "slots",
  //       provider: "slots",
  //       homeUrl: pageUrlGenerator("/slots"),
  //       imgUrl: "./images/slots/redtiger/GodOfWealth.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "God Of Wealth",
  //       name: "God Of Wealth",
  //       gameType: gameTypes.new,
  //     },
  //     LuckyFortuneCat: {
  //       href: "/casino/ezgrt-lucky-fortune-cat",
  //       code: "1100001",
  //       casino: "ezugi",
  //       category: "slots",
  //       provider: "slots",
  //       homeUrl: pageUrlGenerator("/slots"),
  //       imgUrl: "./images/slots/redtiger/LuckyFortuneCat.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Lucky Fortune Cat",
  //       name: "Lucky Fortune Cat",
  //       gameType: gameTypes.popular,
  //     },
  //     MagicGate: {
  //       href: "/casino/ezgrt-magic-gate",
  //       code: "1100001",
  //       casino: "ezugi",
  //       category: "slots",
  //       provider: "slots",
  //       homeUrl: pageUrlGenerator("/slots"),
  //       imgUrl: "./images/slots/redtiger/MagicGate.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Magic Gate",
  //       name: "Magic Gate",
  //       gameType: gameTypes.new,
  //     },
  //     MegaPyramid: {
  //       href: "/casino/ezgrt-mega-pyramid",
  //       code: "1100001",
  //       casino: "ezugi",
  //       category: "slots",
  //       provider: "slots",
  //       homeUrl: pageUrlGenerator("/slots"),
  //       imgUrl: "./images/slots/redtiger/MegaPyramid.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Mega Pyramid",
  //       name: "Mega Pyramid",
  //       gameType: gameTypes.new,
  //     },
  //   },

  baccarat: {
    Baccarat: {
      href: "/casino/ezg-baccarat",
      code: "101",
      casino: "ezugi",
      category: "baccarat",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/Baccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Baccarat",
      gameType: gameTypes.popular,
    },
    BaccaratEEzg: {
      href: "/casino/ezg-baccarat-e",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/BaccaratE.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Baccarat E",
      name: "Baccarat E",
      gameType: gameTypes.popular,
    },
    CasinoMarinaBaccarat1Ezg: {
      href: "/casino/ezg-casino-marina-baccarat-1",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/CasinoMarinaBaccarat1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Casino Marina Baccarat 1",
      name: "Casino Marina Baccarat 1",
      gameType: gameTypes.new,
    },
    CasinoMarinaBaccarat2Ezg: {
      href: "/casino/ezg-casino-marina-baccarat-2",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/CasinoMarinaBaccarat2.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Casino Marina Baccarat 2",
      name: "Casino Marina Baccarat 2",
      gameType: gameTypes.new,
    },
    CasinoMarinaBaccarat3Ezg: {
      href: "/casino/ezg-casino-marina-baccarat-3",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/CasinoMarinaBaccarat3.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Casino Marina Baccarat 3",
      name: "Casino Marina Baccarat 3",
      gameType: gameTypes.new,
    },
    CasinoMarinaBaccarat4Ezg: {
      href: "/casino/ezg-casino-marina-baccarat-4",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/CasinoMarinaBaccarat4.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Casino Marina Baccarat 4",
      name: "Casino Marina Baccarat 4",
      gameType: gameTypes.new,
    },
    FortuneBaccarat: {
      href: "/casino/ezg-fortune-baccarat",
      code: "101",
      casino: "ezugi",
      category: "baccarat",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/FortuneBaccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Fortune Baccarat",
      name: "Fortune Baccarat",
      gameType: gameTypes.popular,
    },
    KnockoutBaccaratEzg: {
      href: "/casino/ezg-knockout-baccarat",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/KnockoutBaccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Knockout Baccarat",
      name: "Knockout Baccarat",
      gameType: gameTypes.popular,
    },
    NoCommissionBaccaratAEzg: {
      href: "/casino/ezg-no-commission-baccarat-a",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/NoCommissionBaccaratA.webp",
      plaBtn: "./images/play-btn.png",
      alt: "No Commission Baccarat A",
      name: "No Commission Baccarat A",
      gameType: gameTypes.popular,
    },
    NoCommissionBaccaratBEzg: {
      href: "/casino/ezg-no-commission-baccarat-b",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/NoCommissionBaccaratB.webp",
      plaBtn: "./images/play-btn.png",
      alt: "No Commission Baccarat B",
      name: "No Commission Baccarat B",
      gameType: gameTypes.popular,
    },
    NoCommissionBaccaratCEzg: {
      href: "/casino/ezg-no-commission-baccarat-c",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/NoCommissionBaccaratC.webp",
      plaBtn: "./images/play-btn.png",
      alt: "No Commission Baccarat C",
      name: "No Commission Baccarat C",
      gameType: gameTypes.popular,
    },
    NoCommissionBaccaratDEzg: {
      href: "/casino/ezg-no-commission-baccarat-d",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/NoCommissionBaccaratD.webp",
      plaBtn: "./images/play-btn.png",
      alt: "No Commission Baccarat D",
      name: "No Commission Baccarat D",
      gameType: gameTypes.popular,
    },
    NoCommissionBaccaratEEzg: {
      href: "/casino/ezg-no-commission-baccarat",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/NoCommissionBaccaratE.webp",
      plaBtn: "./images/play-btn.png",
      alt: "No Commission Baccarat E",
      name: "No Commission Baccarat E",
      gameType: gameTypes.popular,
    },
    NoCommissionOverUnderBaccaratEzg: {
      href: "/casino/ezg-no-commission-over-under-baccarat",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/NoCommissionOverUnderBaccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "No Commission Over Under Baccarat",
      name: "No Commission Over Under Baccarat",
      gameType: gameTypes.new,
    },
    OverUnderBaccaratEzg: {
      href: "/casino/ezg-over-under-baccarat",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/OverUnderBaccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Over Under Baccarat",
      name: "Over Under Baccarat",
      gameType: gameTypes.new,
    },
    // SpeedCricketBaccarat: {
    //   href: "/casino/ezg-speed-cricket-baccarat",
    //   code: "101",
    //   casino: "ezugi",
    //   category: "baccarat",
    //   provider: "ezugi",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/baccarat/Speedcricketbaccarat.jpg",
    //   plaBtn: "./images/play-btn.png",
    //   alt: "Speed Cricket Baccarat",
    //   name: "Speed Cricket Baccarat",
    //   gameType: gameTypes.popular,
    // },
    SpeedFortuneBaccaratEzg: {
      href: "/casino/ezg-speed-fortune-baccarat",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/SpeedFortuneBaccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Speed Fortune Baccarat",
      name: "Speed Fortune Baccarat",
      gameType: gameTypes.popular,
    },
    Super6BaccaratEzg: {
      href: "/casino/ezg-super-6-baccarat",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/Super6Baccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Super 6 Baccarat",
      name: "Super 6 Baccarat",
      gameType: gameTypes.popular,
    },
    VIPFortuneBaccaratEzg: {
      href: "/casino/ezg-vip-fortune-baccarat",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/VIPFortuneBaccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "VIP Fortune Baccarat",
      name: "VIP Fortune Baccarat",
      gameType: gameTypes.popular,
    },
    // VIPNoCommissionSpeedCricketBaccaratEzg: {
    //   href: "/casino/ezg-vip-no-commission-speed-cricket-baccarat",
    //   code: "",
    //   casino: "ezugi",
    //   category: "baccarat",
    //   provider: "ezugi",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/baccarat/ezugi/VIPNoCommissionSpeedCricketBaccarat.webp",
    //   plaBtn: "./images/play-btn.png",
    //   alt: "VIP No Commission Speed Cricket Baccarat",
    //   name: "VIP No Commission Speed Cricket Baccarat",
    //   gameType: gameTypes.popular,
    // },

    BaccaratBEvo: {
      href: "/casino/ezgevo-baccarat-b",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/BaccaratB.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Baccarat B",
      name: "Baccarat B",
      gameType: gameTypes.popular,
    },
    // BaccaratCEvo: {
    //   href: "/casino/ezgevo-baccarat-c",
    //   code: "",
    //   casino: "ezugi",
    //   category: "baccarat",
    //   provider: "evolution",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/baccarat/evolution/BaccaratC.webp",
    //   plaBtn: "./images/play-btn.png",
    //   alt: "Baccarat C",
    //   name: "Baccarat C",
    //   gameType: gameTypes.popular,
    // },
    BaccaratSqueezeEvo: {
      href: "/casino/ezgevo-baccarat-squeeze",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/BaccaratSqueeze.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Baccarat Squeeze",
      name: "Baccarat Squeeze",
      gameType: gameTypes.new,
    },
    FirstPersonBaccaratEvo: {
      href: "/casino/ezgevo-first-person-baccarat",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/FirstPersonBaccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "First Person Baccarat",
      name: "First Person Baccarat",
      gameType: gameTypes.popular,
    },
    FirstPersonGoldenWealthBaccaratEvo: {
      href: "/casino/ezgevo-first-person-golden-wealth-baccarat",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl:
        "./images/baccarat/evolution/FirstPersonGoldenWealthBaccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "First Person Golden Wealth Baccarat",
      name: "First Person Golden Wealth Baccarat",
      gameType: gameTypes.new,
    },
    FirstPersonLightningBaccaratEvo: {
      href: "/casino/ezgevo-first-person-lightning-baccarat",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/FirstPersonLightningBaccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "First Person Lightning Baccarat",
      name: "First Person Lightning Baccarat",
      gameType: gameTypes.popular,
    },
    GoldenWealthBaccaratEvo: {
      href: "/casino/ezgevo-golden-wealth-baccarat",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/GoldenWealthBaccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Golden Wealth Baccarat",
      name: "Golden Wealth Baccarat",
      gameType: gameTypes.new,
    },
    LightningBaccaratEvo: {
      href: "/casino/ezgevo-lightning-baccarat",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/LightningBaccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Lightning Baccarat",
      name: "Lightning Baccarat",
      gameType: gameTypes.popular,
    },
    NoCommissionBaccaratEvo: {
      href: "/casino/ezgevo-no-commission-baccarat-evo",
      code: "1000018",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/NoCommissionBaccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "No Commission Baccarat",
      name: "No Commission Baccarat",
      gameType: gameTypes.popular,
    },
    SpeedBaccaratAEvo: {
      href: "/casino/ezgevo-speed-baccarat-a",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/SpeedBaccaratA.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Speed Baccarat A",
      name: "Speed Baccarat A",
      gameType: gameTypes.popular,
    },
    SpeedBaccaratBEvo: {
      href: "/casino/ezgevo-speed-baccarat-b",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/SpeedBaccaratB.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Speed Baccarat B",
      name: "Speed Baccarat B",
      gameType: gameTypes.popular,
    },
    SpeedBaccaratCEvo: {
      href: "/casino/ezgevo-speed-baccarat-c",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/SpeedBaccaratC.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Speed Baccarat C",
      name: "Speed Baccarat C",
      gameType: gameTypes.popular,
    },
    SpeedBaccaratDEvo: {
      href: "/casino/ezgevo-speed-baccarat-d",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/SpeedBaccaratD.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Speed Baccarat D",
      name: "Speed Baccarat D",
      gameType: gameTypes.popular,
    },
    SpeedBaccaratEEvo: {
      href: "/casino/ezgevo-speed-baccarat-e",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/SpeedBaccaratE.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Speed Baccarat E",
      name: "Speed Baccarat E",
      gameType: gameTypes.popular,
    },
    SpeedBaccaratFEvo: {
      href: "/casino/ezgevo-speed-baccarat-f",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/SpeedBaccaratF.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Speed Baccarat F",
      name: "Speed Baccarat F",
      gameType: gameTypes.popular,
    },
    SpeedBaccaratGEvo: {
      href: "/casino/ezgevo-speed-baccarat-g",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/SpeedBaccaratG.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Speed Baccarat G",
      name: "Speed Baccarat G",
      gameType: gameTypes.popular,
    },
    SpeedBaccaratHEvo: {
      href: "/casino/ezgevo-speed-baccarat-h",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/SpeedBaccaratH.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Speed Baccarat H",
      name: "Speed Baccarat H",
      gameType: gameTypes.popular,
    },
    SpeedBaccaratIEvo: {
      href: "/casino/ezgevo-speed-baccarat-i",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/SpeedBaccaratI.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Speed Baccarat I",
      name: "Speed Baccarat I",
      gameType: gameTypes.popular,
    },
    SpeedBaccaratJEvo: {
      href: "/casino/ezgevo-speed-baccarat-j",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/SpeedBaccaratJ.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Speed Baccarat J",
      name: "Speed Baccarat J",
      gameType: gameTypes.popular,
    },
    SpeedBaccaratREvo: {
      href: "/casino/ezgevo-speed-baccarat-r",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/SpeedBaccaratR.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Speed Baccarat R",
      name: "Speed Baccarat R",
      gameType: gameTypes.popular,
    },
    SpeedBaccaratVEvo: {
      href: "/casino/ezgevo-speed-baccarat-v",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/SpeedBaccaratV.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Speed Baccarat V",
      name: "Speed Baccarat V",
      gameType: gameTypes.popular,
    },
    SpeedBaccaratWEvo: {
      href: "/casino/ezgevo-speed-baccarat-w",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/SpeedBaccaratW.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Speed Baccarat W",
      name: "Speed Baccarat W",
      gameType: gameTypes.popular,
    },
    SpeedBaccaratXEvo: {
      href: "/casino/ezgevo-speed-baccarat-x",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/SpeedBaccaratX.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Speed Baccarat X",
      name: "Speed Baccarat X",
      gameType: gameTypes.popular,
    },

    BaccaratAura: {
      href: "/casino/aura-baccarat",
      code: "",
      casino: "aura",
      category: "baccarat",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/aura/Baccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Baccarat",
      name: "Baccarat",
      gameType: gameTypes.new,
    },
    Card29BaccaratAura: {
      href: "/casino/aura-29-card-baccarat",
      code: "",
      casino: "aura",
      category: "baccarat",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/aura/29CardBaccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "29 Card Baccarat",
      name: "29 Card Baccarat",
      gameType: gameTypes.new,
    },

    GalaxyBaccarat1Vivo: {
      href: "/casino/vivo-galaxy-baccarat-1",
      code: "",
      casino: "vivo",
      category: "baccarat",
      provider: "vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/vivo/GalaxyBaccarat1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Galaxy Baccarat 1",
      name: "Galaxy Baccarat 1",
      gameType: gameTypes.new,
    },
    GalaxyBaccarat2Vivo: {
      href: "/casino/vivo-galaxy-baccarat-2",
      code: "",
      casino: "vivo",
      category: "baccarat",
      provider: "vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/vivo/GalaxyBaccarat2.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Galaxy Baccarat 2",
      name: "Galaxy Baccarat 2",
      gameType: gameTypes.new,
    },
    GalaxyBaccarat3Vivo: {
      href: "/casino/vivo-galaxy-baccarat-3",
      code: "",
      casino: "vivo",
      category: "baccarat",
      provider: "vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/vivo/GalaxyBaccarat3.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Galaxy Baccarat 3",
      name: "Galaxy Baccarat 3",
      gameType: gameTypes.new,
    },
    MacauBaccaratVivo: {
      href: "/casino/vivo-macau-baccarat",
      code: "",
      casino: "vivo",
      category: "baccarat",
      provider: "vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/vivo/MacauBaccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Macau Baccarat",
      name: "Macau Baccarat",
      gameType: gameTypes.new,
    },
    VABacarat1Vivo: {
      href: "/casino/vivo-va-bacarat-1",
      code: "",
      casino: "vivo",
      category: "baccarat",
      provider: "vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/vivo/MacauBaccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "VA Bacarat 1",
      name: "VA Bacarat 1",
      gameType: gameTypes.popular,
    },
    VABacarat2Vivo: {
      href: "/casino/vivo-va-bacarat-2",
      code: "",
      casino: "vivo",
      category: "baccarat",
      provider: "vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/vivo/MacauBaccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "VA Bacarat 2",
      name: "VA Bacarat 2",
      gameType: gameTypes.popular,
    },
    VABacarat3Vivo: {
      href: "/casino/vivo-va-bacarat-3",
      code: "",
      casino: "vivo",
      category: "baccarat",
      provider: "vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/vivo/MacauBaccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "VA Bacarat 3",
      name: "VA Bacarat 3",
      gameType: gameTypes.popular,
    },
    VABacarat4Vivo: {
      href: "/casino/vivo-va-bacarat-4",
      code: "",
      casino: "vivo",
      category: "baccarat",
      provider: "vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/vivo/MacauBaccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "VA Bacarat 4",
      name: "VA Bacarat 4",
      gameType: gameTypes.popular,
    },
    VABacarat5Vivo: {
      href: "/casino/vivo-va-bacarat-5",
      code: "",
      casino: "vivo",
      category: "baccarat",
      provider: "vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/vivo/MacauBaccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "VA Bacarat 5",
      name: "VA Bacarat 5",
      gameType: gameTypes.popular,
    },

    BaccaratSn: {
      href: "/casino/sn-baccarat",
      code: "",
      casino: "wco",
      category: "baccarat",
      provider: "supernowa",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/supernowa/Baccarat1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Baccarat",
      name: "Baccarat",
      gameType: gameTypes.new,
    },
    RNGBaccaratSn: {
      href: "/casino/sn-rng-baccarat",
      code: "",
      casino: "wco",
      category: "baccarat",
      provider: "supernowa",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/supernowa/RNGBaccarat1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "RNG Baccarat",
      name: "RNG Baccarat",
      gameType: gameTypes.new,
    },
    // RNGBaccarat2020Sn: {
    //   href: "/casino/sn-rng-baccarat-2020",
    //   code: "",
    //   casino: "wco",
    //   category: "baccarat",
    //   provider: "supernowa",
    //   homeUrl: "http://localhost:3000/Casino",
    //   plaBtn: "./images/play-btn.png",  imgUrl: "./images/baccarat/supernowa/RNGBaccarat2020.webp",
    //   alt: "RNG Baccarat 2020",
    //   name: "RNG Baccarat 2020",
    //   gameType: gameTypes.new,
    // },

    BaccaratKM: {
      href: "/casino/km-baccarat",
      code: "",
      casino: "",
      category: "baccarat",
      provider: "kingmaker",
      imgUrl: "./images/kingmaker/baccarat/Baccarat1.webp",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Baccarat",
      plaBtn: "./images/play-btn.png",
      gameType: gameTypes.new,
    },

    // BaccaratAes: {
    //   href: "/casino/awc-baccarat",
    //   code: "",
    //   casino: "AE Sexy",
    //   category: "baccarat",
    //   provider: "worldcasino",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/aesexy/Baccarat.webp",
    //   plaBtn: "./images/play-btn.png",
    //   alt: "Baccarat",
    //   name: "Baccarat",
    //   gameType: gameTypes.popular,
    // },
    // BaccaratClassicAes: {
    //   href: "/casino/awc-baccarat-classic",
    //   code: "",
    //   casino: "AE Sexy",
    //   category: "baccarat",
    //   provider: "worldcasino",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/aesexy/BaccaratClassic.webp",
    //   plaBtn: "./images/play-btn.png",
    //   alt: "Baccarat Classic",
    //   name: "Baccarat Classic",
    //   gameType: gameTypes.new,
    // },
  },

  blackjack: {
    // BlackjackAEzg: {
    //   href: "/casino/ezg-blackjack-a",
    //   code: "",
    //   casino: "ezugi",
    //   category: "blackjack",
    //   provider: "ezugi",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/blackjack/ezugi/BlackjackA.webp",
    //   plaBtn: "./images/play-btn.png",
    //   alt: "Blackjack A",
    //   name: "Blackjack A",
    //   gameType: gameTypes.popular,
    // },
    BlackjackDaSorteEzg: {
      href: "/casino/ezg-blackjack-da-sorte",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/ezugi/BlackjackDaSorte.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Blackjack Da Sorte",
      name: "Blackjack Da Sorte",
      gameType: gameTypes.new,
    },
    GoldBlackjack1Ezg: {
      href: "/casino/ezg-gold-blackjack-1",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/ezugi/GoldBlackjack1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Gold Blackjack 1",
      name: "Gold Blackjack 1",
      gameType: gameTypes.popular,
    },
    GoldBlackjack3Ezg: {
      href: "/casino/ezg-gold-blackjack-3",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/ezugi/GoldBlackjack3.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Gold Blackjack 3",
      name: "Gold Blackjack 3",
      gameType: gameTypes.popular,
    },
    Rumbablackjack1Ezg: {
      href: "/casino/ezg-rumba-blackjack-1",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/ezugi/RumbaBlackjack1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Rumba Blackjack 1",
      name: "Rumba Blackjack 1",
      gameType: gameTypes.new,
    },
    Rumbablackjack4Ezg: {
      href: "/casino/ezg-rumba-blackjack-4",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/ezugi/RumbaBlackjack4.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Rumba Blackjack 4",
      name: "Rumba Blackjack 4",
      gameType: gameTypes.new,
    },
    SpanishUnlimitedBlackjackEzg: {
      href: "/casino/ezg-spanish-unlimited-blackjack",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/ezugi/SpanishUnlimitedBlackjack.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Spanish Unlimited Blackjack",
      name: "Spanish Unlimited Blackjack",
      gameType: gameTypes.new,
    },
    UnlimitedBlackjackEzg: {
      href: "/casino/ezg-unlimited-blackjack",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/ezugi/UnlimitedBlackjack.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Unlimited Blackjack",
      name: "Unlimited Blackjack",
      gameType: gameTypes.popular,
    },
    VIPDiamondBlackjackEzg: {
      href: "/casino/ezg-vip-diamond-blackjack",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/ezugi/VIPDiamondBlackjack.webp",
      plaBtn: "./images/play-btn.png",
      alt: "VIP Diamond Blackjack",
      name: "VIP Diamond Blackjack",
      gameType: gameTypes.popular,
    },
    VipSurrenderBlackjackEzg: {
      href: "/casino/ezg-vip-surrender-blackjack",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/ezugi/VipSurrenderBlackjack.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Vip Surrender Blackjack",
      name: "Vip Surrender Blackjack",
      gameType: gameTypes.popular,
    },

    BlackjackAEvo: {
      href: "/casino/ezgevo-blackjack-a",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/BlackjackA.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Blackjack A",
      name: "Blackjack A",
      gameType: gameTypes.popular,
    },
    BlackjackPartyEvo: {
      href: "/casino/ezgevo-blackjack-party",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/BlackjackParty.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Blackjack Party",
      name: "Blackjack Party",
      gameType: gameTypes.new,
    },
    BlackjackSilverAEvo: {
      href: "/casino/ezgevo-blackjack-silver-a",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/BlackjackSilverA.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Blackjack Silver A",
      name: "Blackjack Silver A",
      gameType: gameTypes.new,
    },
    BlackjackVIP10Evo: {
      href: "/casino/ezgevo-blackjack-vip-10",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/BlackjackVIP10.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Blackjack VIP 10",
      name: "Blackjack VIP 10",
      gameType: gameTypes.popular,
    },
    BlackjackVIPAlphaEvo: {
      href: "/casino/ezgevo-blackjack-vip-alpha",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/BlackjackVIPAlpha.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Blackjack VIP Alpha",
      name: "Blackjack VIP Alpha",
      gameType: gameTypes.popular,
    },
    BlackjackVIPBetaEvo: {
      href: "/casino/ezgevo-blackjack-vip-beta",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/BlackjackVIPBeta.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Blackjack VIP Beta",
      name: "Blackjack VIP Beta",
      gameType: gameTypes.popular,
    },
    BlackjackVIPEEvo: {
      href: "/casino/ezgevo-blackjack-vip-e",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/BlackjackVIPE.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Blackjack VIP E",
      name: "Blackjack VIP E",
      gameType: gameTypes.popular,
    },
    BlackjackVIPGammaEvo: {
      href: "/casino/ezgevo-blackjack-vip-gamma",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/BlackjackVIPGamma.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Blackjack VIP Gamma",
      name: "Blackjack VIP Gamma",
      gameType: gameTypes.popular,
    },
    BlackjackVIPLEvo: {
      href: "/casino/ezgevo-blackjack-vip-l",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/BlackjackVIPL.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Blackjack VIP L",
      name: "Blackjack VIP L",
      gameType: gameTypes.popular,
    },
    ClassicSpeedBlackjack10Evo: {
      href: "/casino/ezgevo-classic-speed-blackjack-10",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/ClassicSpeedBlackjack10.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Classic Speed Blackjack 10",
      name: "Classic Speed Blackjack 10",
      gameType: gameTypes.popular,
    },
    FirstPersonBlackjackEvo: {
      href: "/casino/ezgevo-first-person-blackjack",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/FirstPersonBlackjack.webp",
      plaBtn: "./images/play-btn.png",
      alt: "First Person Blackjack",
      name: "First Person Blackjack",
      gameType: gameTypes.new,
    },
    FirstPersonLightningBlackjackEvo: {
      href: "/casino/ezgevo-first-person-lightning-blackjack",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/FirstPersonLightningBlackjack.webp",
      plaBtn: "./images/play-btn.png",
      alt: "First Person Lightning Blackjack",
      name: "First Person Lightning Blackjack",
      gameType: gameTypes.popular,
    },
    InfiniteBlackjackEvo: {
      href: "/casino/ezgevo-infinite-blackjack",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/InfiniteBlackjack.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Infinite Blackjack",
      name: "Infinite Blackjack",
      gameType: gameTypes.popular,
    },
    LightningBlackjackEvo: {
      href: "/casino/ezgevo-lightning-blackjack",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/LightningBlackjack.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Lightning Blackjack",
      name: "Lightning Blackjack",
      gameType: gameTypes.popular,
    },
    PowerBlackjackEvo: {
      href: "/casino/ezgevo-power-blackjack",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/PowerBlackjack.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Power Blackjack",
      name: "Power Blackjack",
      gameType: gameTypes.new,
    },
    SpeedBlackjackDEvo: {
      href: "/casino/ezgevo-speed-blackjack-d",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/SpeedBlackjackD.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Speed Blackjack D",
      name: "Speed Blackjack D",
      gameType: gameTypes.popular,
    },
    SpeedVIPBlackjackAEvo: {
      href: "/casino/ezgevo-speed-vip-blackjack-a",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/SpeedVIPBlackjackA.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Speed VIP Blackjack A",
      name: "Speed VIP Blackjack A",
      gameType: gameTypes.new,
    },

    LasVegasBlackjackVivo: {
      href: "/casino/vivo-las-vegas-blackjack",
      code: "",
      casino: "vivo",
      category: "blackjack",
      provider: "vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/vivo/LasVegasBlackjack.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Las Vegas Blackjack",
      name: "Las Vegas Blackjack",
      gameType: gameTypes.popular,
    },
    LimitlessBlackjackVivo: {
      href: "/casino/vivo-limitless-blackjack",
      code: "",
      casino: "vivo",
      category: "blackjack",
      provider: "vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/vivo/LimitlessBlackjack.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Limitless Blackjack",
      name: "Limitless Blackjack",
      gameType: gameTypes.new,
    },

    BlackjackKM: {
      href: "/casino/km-blackjack",
      code: "",
      casino: "",
      category: "blackjack",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/blackjack/Blackjack1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Blackjack",
      name: "Blackjack",
      gameType: gameTypes.new,
    },
  },

  //   other: {
  //     CardPoker5: {
  //       href: "/casino/km-5-card-poker",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/5-card-poker.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Card Poker",
  //       name: "Card Poker",
  //       gameType: gameTypes.popular,
  //     },
  //     BaiBuu: {
  //       href: "/casino/km-bai-buu",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/bai-buu.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Bai Buu",
  //       name: "Bai Buu",
  //       gameType: gameTypes.new,
  //     },
  //     BaiCao: {
  //       href: "/casino/km-bai-cao",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/bai-cao.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Bai Cao",
  //       name: "Bai Cao",
  //       gameType: gameTypes.new,
  //     },
  //     Belangkai2: {
  //       href: "/casino/km-belangkai-2",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/belangkai-2.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Belangkai 2",
  //       name: "Belangkai 2",
  //       gameType: gameTypes.new,
  //     },
  //     BolaGolek: {
  //       href: "/casino/km-bola-golek",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/bola-golek.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Bola Golek",
  //       name: "Bola Golek",
  //       gameType: gameTypes.popular,
  //     },
  //     BolaTangkas: {
  //       href: "/casino/km-bola-tangkas",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/bola-tangkas.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Bola Tangkas",
  //       name: "Bola Tangkas",
  //       gameType: gameTypes.popular,
  //     },
  //     BonusDice: {
  //       href: "/casino/km-bonus-dice",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/bonus-dice.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Bonus Dice",
  //       name: "Bonus Dice",
  //       gameType: gameTypes.new,
  //     },
  //     CashRocket: {
  //       href: "/casino/km-cash-rocket",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/cash-rocket.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Cash Rocket",
  //       name: "Cash Rocket",
  //       gameType: gameTypes.popular,
  //     },
  //     CleopatrasTreasure: {
  //       href: "/casino/km-cleopatras-treasure",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/cleopatras-treasure.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Cleopatras Treasure",
  //       name: "Cleopatras Treasure",
  //       gameType: gameTypes.new,
  //     },
  //     CockfightingArena: {
  //       href: "/casino/km-cockfighting-arena",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/cockfighting-arena.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Cockfighting Arena",
  //       name: "Cockfighting Arena",
  //       gameType: gameTypes.new,
  //     },
  //     CoinPusher: {
  //       href: "/casino/km-coin-pusher",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/coin-pusher.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Coin Pusher",
  //       name: "Coin Pusher",
  //       gameType: gameTypes.popular,
  //     },
  //     ColorGame: {
  //       href: "/casino/km-color-game",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/color-game.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Color Game",
  //       name: "Color Game",
  //       gameType: gameTypes.new,
  //     },
  //     DotaHiLo: {
  //       href: "/casino/km-dota-hi-lo",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/dota-hi-lo.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Dota Hi Lo",
  //       name: "Dota Hi Lo",
  //       gameType: gameTypes.popular,
  //     },
  //     EliteAviatorClub: {
  //       href: "/casino/km-elite-aviator-club",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/elite-aviator-club.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Elite Aviator Club",
  //       name: "Elite Aviator Club",
  //       gameType: gameTypes.popular,
  //     },
  //     FanTvanClassic: {
  //       href: "/casino/km-fan-tvan-classic",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/fan-tvan-classic.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Fan Tan Classic",
  //       name: "Fan Tan Classic",
  //       gameType: gameTypes.new,
  //     },
  //     FishPrawnCrab2: {
  //       href: "/casino/km-fish-prawn-crab-2",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/fish-prawn-crab-2.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Fish Prawn Crab 2",
  //       name: "Fish Prawn Crab 2",
  //       gameType: gameTypes.popular,
  //     },
  //     GemsOfValhalla: {
  //       href: "/casino/km-gems-of-valhalla",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/gems-of-valhalla.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Gems Of Valhalla",
  //       name: "Gems Of Valhalla",
  //       gameType: gameTypes.new,
  //     },
  //     GoldMines: {
  //       href: "/casino/km-gold-mines",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/gold-mines.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Gold Mines",
  //       name: "Gold Mines",
  //       gameType: gameTypes.popular,
  //     },
  //     Heist: {
  //       href: "/casino/km-heist",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/heist.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "heist",
  //       name: "heist",
  //       gameType: gameTypes.popular,
  //     },
  //     InterstellarRun: {
  //       href: "/casino/km-interstellar-run",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/interstellar-run.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "InterstellarRun",
  //       name: "InterstellarRun",
  //       gameType: gameTypes.new,
  //     },
  //     JackpotJump: {
  //       href: "/casino/km-jackpot-jump",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/jackpot-jump.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Jackpot Jump",
  //       name: "Jackpot Jump",
  //       gameType: gameTypes.popular,
  //     },
  //     KMPokDeng: {
  //       href: "/casino/km-km-pok-deng",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/km-pok-deng.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "KM Pok Deng",
  //       name: "KM Pok Deng",
  //       gameType: gameTypes.new,
  //     },
  //     KMPowerBall: {
  //       href: "/casino/km-km-power-ball",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/km-power-ball.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "KM Power Ball",
  //       name: "KM Power Ball",
  //       gameType: gameTypes.popular,
  //     },
  //     KMVirtualHorseRacing: {
  //       href: "/casino/km-km-virtual-horse-racing",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/km-virtual-horse-racing.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "KM Virtual Horse Racing",
  //       name: "KM Virtual Horse Racing",
  //       gameType: gameTypes.new,
  //     },
  //     Ludo: {
  //       href: "/casino/km-ludo",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/ludo.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Ludo",
  //       name: "Ludo",
  //       gameType: gameTypes.popular,
  //     },
  //     MarbleRacing: {
  //       href: "/casino/km-marble-racing",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/marble-racing.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Marble Racing",
  //       name: "Marble Racing",
  //       gameType: gameTypes.popular,
  //     },
  //     MaxKeno: {
  //       href: "/casino/km-max-keno",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/max-keno.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Max Keno",
  //       name: "Max Keno",
  //       gameType: gameTypes.new,
  //     },
  //     Minesweeper: {
  //       href: "/casino/km-minesweeper",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/minesweeper.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Minesweeper",
  //       name: "Minesweeper",
  //       gameType: gameTypes.new,
  //     },
  //     OlympusGlory: {
  //       href: "/casino/km-olympus-glory",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/olympus-glory.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Olympus Glory",
  //       name: "Olympus Glory",
  //       gameType: gameTypes.new,
  //     },
  //     PaiKang: {
  //       href: "/casino/km-pai-kang",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/pai-kang.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Pai Kang",
  //       name: "Pai Kang",
  //       gameType: gameTypes.new,
  //     },
  //     PenguinPanic: {
  //       href: "/casino/km-penguin-panic",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/penguin-panic.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Penguin Panic",
  //       name: "Penguin Panic",
  //       gameType: gameTypes.new,
  //     },
  //     Plinko: {
  //       href: "/casino/km-plinko",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/plinko.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Plinko",
  //       name: "Plinko",
  //       gameType: gameTypes.popular,
  //     },
  //     Pusoy: {
  //       href: "/casino/km-pusoy",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/pusoy.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Pusoy",
  //       name: "Pusoy",
  //       gameType: gameTypes.new,
  //     },
  //     RoosterBlitz: {
  //       href: "/casino/km-rooster-blitz",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/rooster-blitz.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Rooster Blitz",
  //       name: "Rooster Blitz",
  //       gameType: gameTypes.new,
  //     },
  //     SugarBlast: {
  //       href: "/casino/km-sugar-blast",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/sugar-blast.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Sugar Blast",
  //       name: "Sugar Blast",
  //       gameType: gameTypes.popular,
  //     },
  //     SugarBlastFrenzy: {
  //       href: "/casino/km-sugar-blast-frenzy",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/sugar-blast-frenzy.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Sugar Blast Frenzy",
  //       name: "Sugar Blast Frenzy",
  //       gameType: gameTypes.popular,
  //     },
  //     TaiXiu: {
  //       href: "/casino/km-tai-xiu",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/tai-xiu.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Tai Xiu",
  //       name: "Tai Xiu",
  //       gameType: gameTypes.new,
  //     },
  //     TeenPatti: {
  //       href: "/casino/km-teen-patti",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/teen-patti.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Teen Patti",
  //       name: "Teen Patti",
  //       gameType: gameTypes.popular,
  //     },
  //     ThaiFishPrawnCrab: {
  //       href: "/casino/km-thai-fish-prawn-crab",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/thai-fish-prawn-crab.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Thai Fish Prawn Crab",
  //       name: "Thai Fish Prawn Crab",
  //       gameType: gameTypes.new,
  //     },
  //     ThaiHiLo2: {
  //       href: "/casino/km-thai-hi-lo-2",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/thai-hi-lo-2.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Thai Hi Lo 2",
  //       name: "Thai Hi Lo 2",
  //       gameType: gameTypes.popular,
  //     },
  //     Tongits: {
  //       href: "/casino/km-tongits",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/tongits.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Tongits",
  //       name: "Tongits",
  //       gameType: gameTypes.new,
  //     },
  //     TripleChance: {
  //       href: "/casino/km-triple-chance",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/triple-chance.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Triple Chance",
  //       name: "Triple Chance",
  //       gameType: gameTypes.new,
  //     },
  //     VideoPoker: {
  //       href: "/casino/km-video-poker",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/video-poker.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Video Poker",
  //       name: "Video Poker",
  //       gameType: gameTypes.popular,
  //     },
  //     VietFishPrawnCrab: {
  //       href: "/casino/km-viet-fish-prawn-crab",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/viet-fish-prawn-crab.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Viet Fish Prawn Crab",
  //       name: "Viet Fish Prawn Crab",
  //       gameType: gameTypes.new,
  //     },
  //     VirtualAnimalRace: {
  //       href: "/casino/km-virtual-animal-race",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/virtual-animal-race.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Virtual Animal Race",
  //       name: "Virtual Animal Race",
  //       gameType: gameTypes.popular,
  //     },
  //     VirtualGreyhoundRacing: {
  //       href: "/casino/km-virtual-greyhound-racing",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/virtual-greyhound-racing.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Virtual Greyhound Racing",
  //       name: "Virtual Greyhound Racing",
  //       gameType: gameTypes.popular,
  //     },
  //     VirtualTreadmillRacing: {
  //       href: "/casino/km-virtual-treadmill-racing",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/virtual-treadmill-racing.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Virtual Treadmill Racing",
  //       name: "Virtual Treadmill Racing",
  //       gameType: gameTypes.new,
  //     },
  //     XocLightning: {
  //       href: "/casino/km-xoc-lightning",
  //       code: "",
  //       casino: "",
  //       category: "other",
  //       provider: "kingmaker",
  //       homeUrl: pageUrlGenerator("/kingmaker"),
  //       imgUrl: "./images/kingmaker/others/xoc-lightning.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "Xoc Lightning",
  //       name: "Xoc Lightning",
  //       gameType: gameTypes.popular,
  //     },

  //     RedBlueDuelAes: {
  //       href: "/casino/awc-red-blue-duel",
  //       code: "",
  //       casino: "AE Sexy",
  //       category: "other",
  //       provider: "worldcasino",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "./images/aesexy/RedBlueDuel.webp",
  //       plaBtn: "./images/play-btn.png",
  //       alt: "./images/aesexy/RedBlueDuel.webp",
  //       name: "Red Blue Duel",
  //       gameType: gameTypes.new,
  //     },
  //   },

  spribe: {
    aviatorCr: {
      href: "/casino/spribe/aviator",
      code: "aviator",
      casino: "spribe",
      category: "crash",
      provider: "spribe",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/aviator/Aviator1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Aviator",
      gameType: gameTypes.new,
    },
    Keno: {
      href: "/casino/spribe/keno",
      code: "keno",
      casino: "spribe",
      category: "crash",
      provider: "spribe",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/crash/Keno1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Keno",
      gameType: gameTypes.new,
    },
    MiniRoulette: {
      href: "/casino/spribe/miniroulette",
      code: "mini-roulette",
      casino: "spribe",
      category: "crash",
      provider: "spribe",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/crash/MiniRoulette1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Mini Roulette",
      gameType: gameTypes.popular,
    },
    hilo: {
      href: "/casino/spribe/hilo",
      code: "hi-lo",
      casino: "spribe",
      category: "crash",
      provider: "spribe",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/crash/Hilo1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "hilo",
      gameType: gameTypes.new,
    },
    dice: {
      href: "/casino/spribe/dice",
      code: "dice",
      casino: "spribe",
      category: "crash",
      provider: "spribe",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/crash/Dice1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "dice",
      gameType: gameTypes.popular,
    },
    mines: {
      href: "/casino/spribe/mines",
      code: "mines",
      casino: "spribe",
      category: "crash",
      provider: "spribe",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/crash/Mines1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "mines",
      gameType: gameTypes.new,
    },
    plinko: {
      href: "/casino/spribe/plinko",
      code: "plinko",
      casino: "spribe",
      category: "crash",
      provider: "spribe",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/crash/Plinko1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "plinko",
      gameType: gameTypes.popular,
    },
    goal: {
      href: "/casino/spribe/goal",
      code: "goal",
      casino: "spribe",
      category: "crash",
      provider: "spribe",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/crash/Goal1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "goal",
      gameType: gameTypes.popular,
    },
    hotline: {
      href: "/casino/spribe/hotline",
      code: "hotline",
      casino: "spribe",
      category: "crash",
      provider: "spribe",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/crash/Hotline1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "hotline",
      gameType: gameTypes.new,
    },
  },

  slots: {
    asgardianstones: {
      href: "/casino/ezgne-asgardian-stones",
      code: "1100096",
      casino: "ezugi",
      category: "slots",
      provider: "NetEnt",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/netent/AsgardianStones1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Asgardian Stones",
      name: "Asgardian Stones",
      gameType: gameTypes.new,
    },
    secrets: {
      href: "/casino/ezgne-secrets-of-atlantis",
      code: "1100106",
      casino: "ezugi",
      category: "slots",
      provider: "NetEnt",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/netent/SecretsofAtlantis1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Secrets of Atlantis",
      name: "Secrets of Atlantis",
      gameType: gameTypes.new,
    },
    SteamTower: {
      href: "/casino/ezgne-steam-tower",
      code: "1100043",
      casino: "ezugi",
      category: "slots",
      provider: "NetEnt",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/netent/SteamTower1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Steam Tower",
      name: "Steam Tower",
      gameType: gameTypes.new,
    },
    DivinieFortuneMegaways: {
      href: "/casino/ezgne-divine-fortune-megaways",
      code: "1100089",
      casino: "ezugi",
      category: "slots",
      provider: "NetEnt",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/netent/DivineFortuneMegaways1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Divine Fortune Megaways",
      name: "Divine Fortune Megaways",
      gameType: gameTypes.new,
    },
    FruitShopMegaways: {
      href: "/casino/ezgne-fruit-shop-megaways",
      code: "1100094",
      casino: "ezugi",
      category: "slots",
      provider: "NetEnt",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/netent/FruitShopMegaways1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Fruit Shop Megaways",
      name: "Fruit Shop Megaways",
      gameType: gameTypes.new,
    },
    GorillaKingdom: {
      href: "/casino/ezgne-gorilla-kingdom",
      code: "1100088",
      casino: "ezugi",
      category: "slots",
      provider: "NetEnt",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/netent/GorillaKingdom1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Gorilla Kingdom",
      name: "Gorilla Kingdom",
      gameType: gameTypes.new,
    },
    ReelKingMegaways: {
      href: "/casino/ezgrt-reel-king-mega",
      code: "1100052",
      casino: "ezugi",
      category: "slots",
      provider: "NetEnt",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/netent/ReelKingMega1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Reel King Mega",
      name: "Reel King Mega",
      gameType: gameTypes.new,
    },
    Christmas: {
      href: "/casino/ezgne-aloha-christmas",
      code: "1100032",
      casino: "ezugi",
      category: "slots",
      provider: "NetEnt",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/netent/AlohaChristmas1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Aloha! Christmas",
      name: "Aloha! Christmas",
      gameType: gameTypes.new,
    },
    ClusterPays: {
      href: "/casino/ezgne-aloha-cluster-pays",
      code: "1100033",
      casino: "ezugi",
      category: "slots",
      provider: "NetEnt",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/netent/AlohaClusterPays1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Aloha! Cluster Pays",
      name: "Aloha! Cluster Pays",
      gameType: gameTypes.new,
    },
    WildWest: {
      href: "/casino/ezgne-wild-wild-west-the-great-train-heist",
      code: "1100038",
      casino: "ezugi",
      category: "slots",
      provider: "NetEnt",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/netent/WildWildWest1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Wild Wild West: The Great Train Heist",
      name: "Wild Wild West: The Great Train Heist",
      gameType: gameTypes.new,
    },
    TwinSpinMegaways: {
      href: "/casino/ezgne-twin-spin-megaways",
      code: "1100039",
      casino: "ezugi",
      category: "slots",
      provider: "NetEnt",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/netent/TwinSpinMegaways.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Twin Spin Megaways",
      name: "Twin Spin Megaways",
      gameType: gameTypes.new,
    },
    TurnFortune: {
      href: "/casino/ezgne-turn-your-fortune",
      code: "1100041",
      casino: "ezugi",
      category: "slots",
      provider: "NetEnt",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/netent/TurnYourFortune.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Turn Your Fortune",
      name: "Turn Your Fortune",
      gameType: gameTypes.new,
    },
    Pyramid: {
      href: "/casino/ezgne-pyramid-quest-for-immortality",
      code: "1100078",
      casino: "ezugi",
      category: "slots",
      provider: "NetEnt",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/netent/PyramidQuestforimmortility.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Pyramid: Quest for Immortality",
      name: "Pyramid: Quest for Immortality",
      gameType: gameTypes.new,
    },
    PiggyRiches: {
      href: "/casino/ezgne-piggy-riches",
      code: "1100080",
      casino: "ezugi",
      category: "slots",
      provider: "NetEnt",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/netent/PiggyRiches.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Piggy Riches",
      name: "Piggy Riches",
      gameType: gameTypes.new,
    },
    DarkKing: {
      href: "/casino/ezgne-dark-king-forbidden-riches",
      code: "1100081",
      casino: "ezugi",
      category: "slots",
      provider: "NetEnt",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/netent/DarkKingForbiddenRiches.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Dark King: Forbidden Riches",
      name: "Dark King: Forbidden Riches",
      gameType: gameTypes.new,
    },
    JingleSpin: {
      href: "/casino/ezgne-jingle-spin",
      code: "1100082",
      casino: "ezugi",
      category: "slots",
      provider: "NetEnt",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/netent/JingleSpin.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Jingle Spin",
      name: "Jingle Spin",
      gameType: gameTypes.new,
    },
    JackHammer: {
      href: "/casino/ezgne-jack-hammer",
      code: "1100084",
      casino: "ezugi",
      category: "slots",
      provider: "NetEnt",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/netent/Jackhammer.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Jack Hammer",
      name: "Jack Hammer",
      gameType: gameTypes.new,
    },
    DeadorAlive: {
      href: "/casino/ezgne-dead-or-alive",
      code: "1100085",
      casino: "ezugi",
      category: "slots",
      provider: "NetEnt",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/netent/DeadorAlive.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Dead or Alive",
      name: "Dead or Alive",
      gameType: gameTypes.new,
    },
    DeadorAlive2: {
      href: "/casino/ezgne-dead-or-alive-2",
      code: "1100087",
      casino: "ezugi",
      category: "slots",
      provider: "NetEnt",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/netent/DeadorAlive2.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Dead or Alive 2",
      name: "Dead or Alive 2",
      gameType: gameTypes.new,
    },
    JackandtheBeanstalk: {
      href: "/casino/ezgne-jack-and-the-beanstalk",
      code: "1100086",
      casino: "ezugi",
      category: "slots",
      provider: "NetEnt",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/netent/Jackandthebeansstalk.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Jack and the Beanstalk",
      name: "Jack and the Beanstalk",
      gameType: gameTypes.new,
    },
    Elements: {
      href: "/casino/ezgne-elements-the-awakening",
      code: "1100091",
      casino: "ezugi",
      category: "slots",
      provider: "NetEnt",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/netent/ElementsTheAwakening.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Elements: The Awakening",
      name: "Elements: The Awakening",
      gameType: gameTypes.new,
    },
    FinnandtheSwirlySpin: {
      href: "/casino/ezgne-finn-and-the-swirly-spin",
      code: "1100093",
      casino: "ezugi",
      category: "slots",
      provider: "NetEnt",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/netent/finnandtheswirlyspin.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Finn and the Swirly Spin",
      name: "Finn and the Swirly Spin",
      gameType: gameTypes.new,
    },
    FruitShop: {
      href: "/casino/ezgne-fruit-shop",
      code: "1100095",
      casino: "ezugi",
      category: "slots",
      provider: "NetEnt",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/netent/FruitShop.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Fruit Shop",
      name: "Fruit Shop",
      gameType: gameTypes.new,
    },
    DeadorAlive2FeatureBuy: {
      href: "/casino/ezgne-dead-or-alive-2-feature-buy",
      code: "1100100",
      casino: "ezugi",
      category: "slots",
      provider: "NetEnt",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/netent/deadoralive2featurebuy.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Dead or Alive 2 Feature Buy",
      name: "Dead or Alive 2 Feature Buy",
      gameType: gameTypes.new,
    },
    NinjaWays: {
      href: "/casino/ezgrt-ninja-ways",
      code: "1100166",
      casino: "ezugi",
      category: "slots",
      provider: "RedTiger",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/redtiger/NinjaWays1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Ninja Ways",
      name: "Ninja Ways",
      gameType: gameTypes.new,
    },
    PathofDestiny: {
      href: "/casino/ezgrt-path-of-destiny",
      code: "1100167",
      casino: "ezugi",
      category: "slots",
      provider: "RedTiger",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/redtiger/PathofDestiny1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Path of Destiny",
      name: "Path of Destiny",
      gameType: gameTypes.new,
    },
    PersianFortune: {
      href: "/casino/ezgrt-persian-fortune",
      code: "1100168",
      casino: "ezugi",
      category: "slots",
      provider: "RedTiger",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/redtiger/PersianFortune1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Persian Fortune",
      name: "Persian Fortune",
      gameType: gameTypes.new,
    },
    ReelHeist: {
      href: "/casino/ezgrt-reel-heist",
      code: "1100169",
      casino: "ezugi",
      category: "slots",
      provider: "RedTiger",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/redtiger/ReelHeist1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Reel Heist",
      name: "Reel Heist",
      gameType: gameTypes.new,
    },
    RobinHoodWildForest: {
      href: "/casino/ezgrt-robin-hoods-wild-forest",
      code: "1100170",
      casino: "ezugi",
      category: "slots",
      provider: "RedTiger",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/redtiger/RobinHoodsWildForest1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Robin Hood`s Wild Forest",
      name: "Robin Hood`s Wild Forest",
      gameType: gameTypes.new,
    },
    SnowWild: {
      href: "/casino/ezgrt-snow-wild-and-the-7-features",
      code: "1100171",
      casino: "ezugi",
      category: "slots",
      provider: "RedTiger",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/redtiger/SnowWildAndThe7Features1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Snow Wild And The 7 Features",
      name: "Snow Wild And The 7 Features",
      gameType: gameTypes.new,
    },
    SylvanSpirits: {
      href: "/casino/ezgrt-sylvan-spirits",
      code: "1100172",
      casino: "ezugi",
      category: "slots",
      provider: "RedTiger",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/redtiger/SylvanSpirits1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Sylvan Spirits",
      name: "Sylvan Spirits",
      gameType: gameTypes.new,
    },
    TheGreatestTrainRobbery: {
      href: "/casino/ezgrt-the-greatest-train-robbery",
      code: "1100173",
      casino: "ezugi",
      category: "slots",
      provider: "RedTiger",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/redtiger/TheGreatestTrainRobbery1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "The Greatest Train Robbery",
      name: "The Greatest Train Robbery",
      gameType: gameTypes.new,
    },
    TheWildHatter: {
      href: "/casino/ezgrt-the-wild-hatter",
      code: "1100174",
      casino: "ezugi",
      category: "slots",
      provider: "RedTiger",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/redtiger/TheWildHatter1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "The Wild Hatter",
      name: "The Wild Hatter",
      gameType: gameTypes.new,
    },
    ThorLightning: {
      href: "/casino/ezgrt-thors-lightning",
      code: "1100175",
      casino: "ezugi",
      category: "slots",
      provider: "RedTiger",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/redtiger/Thorslightning1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Thor`s Lightning",
      name: "Thor`s Lightning",
      gameType: gameTypes.new,
    },
    DragonLuck: {
      href: "/casino/ezgrt-dragons-luck",
      code: "1100001",
      casino: "ezugi",
      category: "slots",
      provider: "RedTiger",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/redtiger/DragonsLuck.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Dragon's Luck",
      name: "Dragon's Luck",
      gameType: gameTypes.new,
    },
    DragonLuckReel: {
      href: "/casino/ezgrt-dragons-luck-power-reels",
      code: "1100002",
      casino: "ezugi",
      category: "slots",
      provider: "RedTiger",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/redtiger/DragonsLuckPowerReels.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Dragon's Luck Power Reels",
      name: "Dragon's Luck Power Reels",
      gameType: gameTypes.new,
    },
    TikiFruits: {
      href: "/casino/ezgrt-tiki-fruits",
      code: "1100176",
      casino: "ezugi",
      category: "slots",
      provider: "RedTiger",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/redtiger/TikiFruits.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Tiki Fruits",
      name: "Tiki Fruits",
      gameType: gameTypes.new,
    },
    TotemLightning: {
      href: "/casino/ezgrt-totem-lightning",
      code: "1100177",
      casino: "ezugi",
      category: "slots",
      provider: "RedTiger",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/redtiger/TotemLightning.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Totem Lightning",
      name: "Totem Lightning",
      gameType: gameTypes.new,
    },
    VaultCracker: {
      href: "/casino/ezgrt-vault-cracker",
      code: "1100178",
      casino: "ezugi",
      category: "slots",
      provider: "RedTiger",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/redtiger/VaultCracker.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Vault Cracker",
      name: "Vault Cracker",
      gameType: gameTypes.new,
    },
    VaultofAnubis: {
      href: "/casino/ezgrt-vault-of-anubis",
      code: "1100179",
      casino: "ezugi",
      category: "slots",
      provider: "RedTiger",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/redtiger/VaultofAnubis.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Vault of Anubis",
      name: "Vault of Anubis",
      gameType: gameTypes.new,
    },
    WellofWishes: {
      href: "/casino/ezgrt-well-of-wishes",
      code: "1100180",
      casino: "ezugi",
      category: "slots",
      provider: "RedTiger",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/redtiger/WellofWishes.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Well of Wishes",
      name: "Well of Wishes",
      gameType: gameTypes.new,
    },
    WildCatsMultiline: {
      href: "/casino/ezgrt-wild-cats-multiline",
      code: "1100181",
      casino: "ezugi",
      category: "slots",
      provider: "RedTiger",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/redtiger/WildCatsMultiline.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Wild Cats Multiline",
      name: "Wild Cats Multiline",
      gameType: gameTypes.new,
    },
    WildOClock: {
      href: "/casino/ezgrt-wild-oclock",
      code: "1100182",
      casino: "ezugi",
      category: "slots",
      provider: "RedTiger",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/redtiger/wildOclock.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Wild O`Clock",
      name: "Wild O`Clock",
      gameType: gameTypes.new,
    },
    WildChest: {
      href: "/casino/ezgrt-wild-wild-chest",
      code: "1100183",
      casino: "ezugi",
      category: "slots",
      provider: "RedTiger",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/redtiger/wildwildchest.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Wild Wild Chest",
      name: "Wild Wild Chest",
      gameType: gameTypes.new,
    },
    WinEscalator: {
      href: "/casino/ezgrt-win-escalator",
      code: "1100184",
      casino: "ezugi",
      category: "slots",
      provider: "RedTiger",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/redtiger/winescalator.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Win Escalator",
      name: "Win Escalator",
      gameType: gameTypes.new,
    },
    YucatanMystery: {
      href: "/casino/ezgrt-yucatans-mystery",
      code: "1100185",
      casino: "ezugi",
      category: "slots",
      provider: "RedTiger",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/redtiger/yucantanmystery.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Yucatan`s Mystery",
      name: "Yucatan`s Mystery",
      gameType: gameTypes.new,
    },
    DragonFire: {
      href: "/casino/ezgrt-dragons-fire",
      code: "1100008",
      casino: "ezugi",
      category: "slots",
      provider: "RedTiger",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/redtiger/dragonfire.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Dragon's Fire",
      name: "Dragon's Fire",
      gameType: gameTypes.new,
    },
    DragonLuckDeluxe: {
      href: "/casino/ezgrt-dragons-luck-deluxe",
      code: "1100011",
      casino: "ezugi",
      category: "slots",
      provider: "RedTiger",
      homeUrl: "http://localhost:3000/Slots",
      imgUrl: "./images/slots/redtiger/dragonluckdeluxe.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Dragon's Luck Deluxe",
      name: "Dragon's Luck Deluxe",
      gameType: gameTypes.new,
    },
  },

  // venum: {
  //   dragong2: {
  //     href: "/casino/venumegtjackpot-2-dragons",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/2Dragons.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "2 Dragons",
  //     name: "2 Dragons",
  //     // gameType: gameTypes.new,
  //   },
  //   BurningHeart10: {
  //     href: "/casino/venumegtjackpot-10-burning-heart",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/10BurningHeart.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "10 Burning Heart",
  //     name: "10 Burning Heart",
  //     gameType: gameTypes.popular,
  //   },
  //   BurningDice20: {
  //     href: "/casino/venumegtjackpot-20-burning-dice",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/20BurningDice.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "20 Burning Dice",
  //     name: "20 Burning Dice",
  //     gameType: gameTypes.new,
  //   },
  //   BurningHot20: {
  //     href: "/casino/venumegtjackpot-20-burning-hot",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/20BurningHot.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "20 Burning Hot",
  //     name: "20 Burning Hot",
  //     gameType: gameTypes.popular,
  //   },
  //   DazzlingHot20: {
  //     href: "/casino/venumegtjackpot-20-dazzling-hot",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/20DazzlingHot.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "20 Dazzling Hot",
  //     name: "20 Dazzling Hot",
  //     gameType: gameTypes.new,
  //   },
  //   Diamonds20: {
  //     href: "/casino/venumegtjackpot-20-diamonds",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/20Diamonds.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "20 Diamonds",
  //     name: "20 Diamonds",
  //     gameType: gameTypes.popular,
  //   },
  //   FlaringFruits20: {
  //     href: "/casino/venumgamomat-20-flaring-fruits",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/20FlaringFruits.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "20 Flaring Fruits",
  //     name: "20 Flaring Fruits",
  //     gameType: gameTypes.new,
  //   },
  //   HotBlast20: {
  //     href: "/casino/venumegtjackpot-20-hot-blast",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/20HotBlast.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "20 Hot Blast",
  //     name: "20 Hot Blast",
  //     gameType: gameTypes.popular,
  //   },
  //   JokerDice20: {
  //     href: "/casino/venumegtjackpot-20-joker-dice",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/20JokerDice.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "20 Joker Dice",
  //     name: "20 Joker Dice",
  //     gameType: gameTypes.new,
  //   },
  //   JokerReels20: {
  //     href: "/casino/venumegtjackpot-20-joker-reels",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/20JokerReels.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "20 Joker Reels",
  //     name: "20 Joker Reels",
  //     gameType: gameTypes.popular,
  //   },
  //   SuperDice20: {
  //     href: "/casino/venumegtjackpot-20-super-dice",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/20SuperDice.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "20 Super Dice",
  //     name: "20 Super Dice",
  //     gameType: gameTypes.new,
  //   },
  //   SuperHot20: {
  //     href: "/casino/venumegtjackpot-20-super-hot",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/20SuperHot.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "20 Super Hot",
  //     name: "20 Super Hot",
  //     gameType: gameTypes.popular,
  //   },
  //   SpicyDice30: {
  //     href: "/casino/venumegtjackpot-30-spicy-dice",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/30SpicyDice.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "30 Spicy Dice",
  //     name: "30 Spicy Dice",
  //     gameType: gameTypes.new,
  //   },
  //   SpicyFruits30: {
  //     href: "/casino/venumegtjackpot-30-spicy-fruits",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/30SpicyFruits.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "30 Spicy Fruits",
  //     name: "30 Spicy Fruits",
  //     gameType: gameTypes.popular,
  //   },
  //   AlmightyRamsesII40: {
  //     href: "/casino/venumegtjackpot-40-almighty-ramses-ii",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/40AlmightyRamsesII.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "40 Almighty Ramses II",
  //     name: "40 Almighty Ramses II",
  //     gameType: gameTypes.new,
  //   },
  //   BurningDice40: {
  //     href: "/casino/venumegtjackpot-40-burning-dice",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/40BurningDice.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "40 Burning Dice",
  //     name: "40 Burning Dice",
  //     gameType: gameTypes.popular,
  //   },
  //   BurningHot40: {
  //     href: "/casino/venumegtjackpot-40-burning-hot",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/40BurningHot.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "40 Burning Dice",
  //     name: "40 Burning Dice",
  //     gameType: gameTypes.new,
  //   },
  //   FortuneFruits40: {
  //     href: "/casino/venumnovomatic-40-fortune-fruits-6",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/40FortuneFruits6.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "40 Fortune Fruits 6",
  //     name: "40 Fortune Fruits 6",
  //     gameType: gameTypes.popular,
  //   },
  //   HotCash40: {
  //     href: "/casino/venumegtjackpot-40-hot-and-cash",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/40Hot&Cash.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "40 Hot & Cash",
  //     name: "40 Hot & Cash",
  //     gameType: gameTypes.new,
  //   },
  //   king40: {
  //     href: "/casino/venumegtjackpot-40-king",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/40King.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "40 King",
  //     name: "40 King",
  //     gameType: gameTypes.popular,
  //   },
  //   Luckyking40: {
  //     href: "/casino/venumegtjackpot-40-lucky-king",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/40LuckyKing.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "40 Lucky King",
  //     name: "40 Lucky King",
  //     gameType: gameTypes.new,
  //   },
  //   MegaClover40: {
  //     href: "/casino/venumegtjackpot-40-mega-clover",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/40MegaClover.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "40 Mega Clove",
  //     name: "40 Mega Clove",
  //     gameType: gameTypes.popular,
  //   },
  //   SuperDice40: {
  //     href: "/casino/venumegtjackpot-40-super-dice",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/40SuperDice.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "40 Super Dice",
  //     name: "40 Super Dice",
  //     gameType: gameTypes.new,
  //   },
  //   SuperHot40: {
  //     href: "/casino/venumegtjackpot-40-super-hot",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/40SuperHot.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "40 Super Hot",
  //     name: "40 Super Hot",
  //     gameType: gameTypes.popular,
  //   },
  //   BurningHot100: {
  //     href: "/casino/venumegtjackpot-100-burning-hot",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/100BurningHot.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "100 Burning Hot",
  //     name: "100 Burning Hot",
  //     gameType: gameTypes.new,
  //   },
  //   Cats100: {
  //     href: "/casino/venumegtjackpot-100-cats",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/100Cats.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "100 Cats",
  //     name: "100 Cats",
  //     gameType: gameTypes.popular,
  //   },
  //   Dice100: {
  //     href: "/casino/venumegtjackpot-100-dice",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/100Dice.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "100 Dice",
  //     name: "100 Dice",
  //     gameType: gameTypes.new,
  //   },
  //   SuperDice100: {
  //     href: "/casino/venumegtjackpot-100-super-dice",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/100SuperDice.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "100 Super Dice",
  //     name: "100 Super Dice",
  //     gameType: gameTypes.popular,
  //   },
  //   SuperHot100: {
  //     href: "/casino/venumegtjackpot-100-super-hot",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/100SuperHot.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "100 Super Hot",
  //     name: "100 Super Hot",
  //     gameType: gameTypes.new,
  //   },
  //   urning5Heart: {
  //     href: "/casino/venumegtjackpot-5-burning-heart",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/5BurningHeart.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "5 Burning Heart",
  //     name: "5 Burning Heart",
  //     gameType: gameTypes.popular,
  //   },
  //   Dazzling5Hot: {
  //     href: "/casino/venumegtjackpot-5-dazzling-hot",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/5DazzlingHot.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "5 Dazzling Hot",
  //     name: "5 Dazzling Hot",
  //     gameType: gameTypes.new,
  //   },
  //   Flaring5Fruits: {
  //     href: "/casino/venumgamomat-5-flaring-fruits",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/5FlaringFruits.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "5 Flaring Fruits",
  //     name: "5 Flaring Fruits",
  //     gameType: gameTypes.popular,
  //   },
  //   Great5Star: {
  //     href: "/casino/venumegtjackpot-5-great-star",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/5GreatStar.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "5 Great Star",
  //     name: "5 Great Star",
  //     gameType: gameTypes.new,
  //   },
  //   Hot5Dice: {
  //     href: "/casino/venumegtjackpot-5-hot-dice",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/5HotDice.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "5 Hot Dice",
  //     name: "5 Hot Dice",
  //     gameType: gameTypes.popular,
  //   },
  //   Juggle5Fruits: {
  //     href: "/casino/venumegtjackpot-5-juggle-fruits",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/5JuggleFruits.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "5 Juggle Fruits",
  //     name: "5 Juggle Fruits",
  //     gameType: gameTypes.new,
  //   },
  //   Line5Jokers: {
  //     href: "/casino/venumnovomatic-5-line-jokers",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/5LineJokers.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "5 Line Jokers",
  //     name: "5 Line Jokers",
  //     gameType: gameTypes.popular,
  //   },
  //   Lions5: {
  //     href: "/casino/venumpragmaticplay-5-lions",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/5Lions.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "5 Lions",
  //     name: "5 Lions",
  //     gameType: gameTypes.new,
  //   },
  //   Lions5Gold: {
  //     href: "/casino/venumpragmaticplay-5-lions-gold",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/5LionsGold.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "5 Lions Gold",
  //     name: "5 Lions Gold",
  //     gameType: gameTypes.popular,
  //   },
  //   Reel5Drive: {
  //     href: "/casino/venummicrogaming-5-reel-drive",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/5ReelDrive.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "5 Reel Drive",
  //     name: "5 Reel Drive",
  //     gameType: gameTypes.new,
  //   },
  //   x5Magic: {
  //     href: "/casino/venumplayngo-5x-magic",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/5xMagic.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "5x Magic",
  //     name: "5x Magic",
  //     gameType: gameTypes.popular,
  //   },
  //   Monkeys7: {
  //     href: "/casino/venumpragmaticplay-7-monkeys",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/7Monkeys.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "7 Monkeys",
  //     name: "7 Monkeys",
  //     gameType: gameTypes.new,
  //   },
  //   Ultra40Respin: {
  //     href: "/casino/venumegtjackpot-40-ultra-respin",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/40UltraRespin.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "40 Ultra Respin",
  //     name: "40 Ultra Respin",
  //     gameType: gameTypes.popular,
  //   },
  //   Fortune50Dice: {
  //     href: "/casino/venumnovomatic-50-fortune-dice",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/50FortuneDice.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "50 Fortune Dice",
  //     name: "50 Fortune Dice",
  //     gameType: gameTypes.new,
  //   },
  //   Fortune50Fruits: {
  //     href: "/casino/venumnovomatic-50-fortune-fruits",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/50FortuneFruits.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "50 Fortune Fruits",
  //     name: "50 Fortune Fruits",
  //     gameType: gameTypes.popular,
  //   },
  //   Horses50: {
  //     href: "/casino/venumegtjackpot-50-horses",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/50Horses.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "50 Horses",
  //     name: "50 Horses",
  //     gameType: gameTypes.new,
  //   },
  //   Wins81: {
  //     href: "/casino/venumegtjackpot-81-wins",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/81Wins.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "81 Wins",
  //     name: "81 Wins",
  //     gameType: gameTypes.popular,
  //   },
  //   Dragons888: {
  //     href: "/casino/venumpragmaticplay-888-dragons",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/888dragons.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "888 Dragons",
  //     name: "888 Dragons",
  //     gameType: gameTypes.new,
  //   },
  //   Gold888: {
  //     href: "/casino/venumpragmaticplay-888-gold",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/888Gold.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "888 Gold",
  //     name: "888 Gold",
  //     gameType: gameTypes.popular,
  //   },
  //   ActionJoker: {
  //     href: "/casino/venumnovomatic-action-joker",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/ActionJoker.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Action Joker",
  //     name: "Action Joker",
  //     gameType: gameTypes.new,
  //   },
  //   AdmiralNelson: {
  //     href: "/casino/venumamatic-admiral-nelson",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/AdmiralNelson.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Admiral Nelson",
  //     name: "Admiral Nelson",
  //     gameType: gameTypes.popular,
  //   },

  //   AdventurePalace: {
  //     href: "/casino/venummicrogaming-adventure-palace",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/AdventurePalace.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Adventure Palace",
  //     name: "Adventure Palace",
  //     gameType: gameTypes.new,
  //   },
  //   AfricanSimba: {
  //     href: "/casino/venumnovomatic-african-simba",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/AfricanSimba.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "African Simba",
  //     name: "African Simba",
  //     gameType: gameTypes.popular,
  //   },
  //   AfricanStampede: {
  //     href: "/casino/venumnovomatic-african-stampede",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/AfricanStampede.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "African Stampede",
  //     name: "African Stampede",
  //     gameType: gameTypes.new,
  //   },
  //   AgentJaneBlonde: {
  //     href: "/casino/venummicrogaming-agent-jane-blonde",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/AgentJaneBlonde.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Agent Jane Blonde",
  //     name: "Agent Jane Blonde",
  //     gameType: gameTypes.popular,
  //   },
  //   AgeofTroy: {
  //     href: "/casino/venumegtjackpot-age-of-troy",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/AgeofTroy.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Age of Troy",
  //     name: "Age of Troy",
  //     gameType: gameTypes.new,
  //   },
  //   AllwaysFruits: {
  //     href: "/casino/venumamatic-allways-fruits",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/AllwaysFruits.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Allways Fruits",
  //     name: "Allways Fruits",
  //     gameType: gameTypes.popular,
  //   },
  //   AllWaysJoker: {
  //     href: "/casino/venumamatic-all-ways-joker",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/AllWaysJoker.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "All Ways Joker",
  //     name: "All Ways Joker",
  //     gameType: gameTypes.popular,
  //   },
  //   AllwaysWin: {
  //     href: "/casino/venumamatic-allways-win",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/AllwaysWin.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Allways Win",
  //     name: "Allways Win",
  //     gameType: gameTypes.new,
  //   },
  //   ALMIGHTYREELSGardenOfPersephone: {
  //     href: "/casino/venumnovomatic-almighty-reels-garden-of-persephone",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/ALMIGHTYREELSGardenofPersephone.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "ALMIGHTY REELS: Garden of Persephone",
  //     name: "ALMIGHTY REELS: Garden of Persephone",
  //     gameType: gameTypes.popular,
  //   },
  //   ALMIGHTYREELSPowerOfZeus: {
  //     href: "/casino/venumnovomatic-almighty-reels-power-of-zeus",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/ALMIGHTYREELSPowerofZeus.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "ALMIGHTY REELS: Power of Zeus",
  //     name: "ALMIGHTY REELS: Power of Zeus",
  //     gameType: gameTypes.new,
  //   },
  //   ALMIGHTYREELSRealmOfPoseidon: {
  //     href: "/casino/venumnovomatic-almighty-reels-realm-of-poseidon",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/ALMIGHTYREELSRealmofPoseidon.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "ALMIGHTY REELS: Realm of Poseidon",
  //     name: "ALMIGHTY REELS: Realm of Poseidon",
  //     gameType: gameTypes.popular,
  //   },
  //   AlohaClusterPays: {
  //     href: "/casino/venumnetent-aloha-cluster-pays",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/AlohaClusterPays.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Aloha! Cluster Pays",
  //     name: "Aloha! Cluster Pays",
  //     gameType: gameTypes.new,
  //   },
  //   AlwaysHotCubes: {
  //     href: "/casino/venumnovomatic-always-hot-cubes",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/AlwaysHotCubes.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Always Hot Cubes",
  //     name: "Always Hot Cubes",
  //     gameType: gameTypes.popular,
  //   },
  //   AlwaysHotDeluxe: {
  //     href: "/casino/venumnovomatic-always-hot-deluxe",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/AlwaysHotDeluxe.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Always Hot Deluxe",
  //     name: "Always Hot Deluxe",
  //     gameType: gameTypes.new,
  //   },
  //   AmazingAmazonia: {
  //     href: "/casino/venumegtjackpot-amazing-amazonia",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/AmazingAmazonia.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Amazing Amazonia",
  //     name: "Amazing Amazonia",
  //     gameType: gameTypes.popular,
  //   },
  //   AmazonsBattle: {
  //     href: "/casino/venumegtjackpot-amazons-battle",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/AmazonsBattle.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Amazon's Battle",
  //     name: "Amazon's Battle",
  //     gameType: gameTypes.new,
  //   },
  //   AmazonsStory: {
  //     href: "/casino/venumegtjackpot-amazons-story",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/AmazonsStory.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Amazon's Story",
  //     name: "Amazon's Story",
  //     gameType: gameTypes.popular,
  //   },
  //   AmericanGangster: {
  //     href: "/casino/venumnovomatic-american-gangster",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/AmericanGangster.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "American Gangster",
  //     name: "American Gangster",
  //     gameType: gameTypes.new,
  //   },
  //   AmuletofthePharaoh: {
  //     href: "/casino/venummerkur-amulet-of-the-pharaoh",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/AmuletofthePharaoh.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Amulet of the Pharaoh",
  //     name: "Amulet of the Pharaoh",
  //     gameType: gameTypes.popular,
  //   },
  //   AncientGoddess: {
  //     href: "/casino/venumnovomatic-ancient-goddess",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/AncientGoddess.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Ancient Goddess",
  //     name: "Ancient Goddess",
  //     gameType: gameTypes.new,
  //   },
  //   AncientWorldDeluxe: {
  //     href: "/casino/venummerkur-ancient-world-deluxe",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/AncientWorldDeluxe.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Ancient World Deluxe",
  //     name: "Ancient World Deluxe",
  //     gameType: gameTypes.popular,
  //   },
  //   AnkaasDawn: {
  //     href: "/casino/venummerkur-ankaas-dawn",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/AnkaasDawn.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Ankaa's Dawn",
  //     name: "Ankaa's Dawn",
  //     gameType: gameTypes.new,
  //   },
  //   ArcaneReelChaos: {
  //     href: "/casino/venumnetent-arcane-reel-chaos",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/ArcaneReelChaos.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Arcane Reel Chaos",
  //     name: "Arcane Reel Chaos",
  //     gameType: gameTypes.popular,
  //   },
  //   ArchangelsSalvation: {
  //     href: "/casino/venumnetent-archangels-salvation",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/ArchangelsSalvation.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Archangels: Salvation",
  //     name: "Archangels: Salvation",
  //     gameType: gameTypes.new,
  //   },
  //   ArcticRace: {
  //     href: "/casino/venumnovomatic-arctic-race",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/ArcticRace.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Arctic Race",
  //     name: "Arctic Race",
  //     gameType: gameTypes.popular,
  //   },
  //   Ariana: {
  //     href: "/casino/venummicrogaming-ariana",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Ariana.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Ariana",
  //     name: "Ariana",
  //     gameType: gameTypes.new,
  //   },
  //   ArisingPhoenix: {
  //     href: "/casino/venumamatic-arising-phoenix",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/ArisingPhoenix.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Arising Phoenix",
  //     name: "Arising Phoenix",
  //     gameType: gameTypes.popular,
  //   },
  //   ArkofMystery: {
  //     href: "/casino/venumquickspin-ark-of-mystery",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/ArkofMystery.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Ark of Mystery",
  //     name: "Ark of Mystery",
  //     gameType: gameTypes.new,
  //   },
  //   ArrivaArriva: {
  //     href: "/casino/venumnovomatic-arriva-arriva",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/ArrivaArriva.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Arriva Arriva",
  //     name: "Arriva Arriva",
  //     gameType: gameTypes.popular,
  //   },
  //   AsgardianStones: {
  //     href: "/casino/venumnetent-asgardian-stones",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/AsgardianStones.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Asgardian Stones",
  //     name: "Asgardian Stones",
  //     gameType: gameTypes.new,
  //   },
  //   AsgardsThunder: {
  //     href: "/casino/venumnovomatic-asgards-thunder",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/AsgardsThunder.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Asgard's Thunder",
  //     name: "Asgard's Thunder",
  //     gameType: gameTypes.popular,
  //   },
  //   AuraofJupiter: {
  //     href: "/casino/venumgamomat-aura-of-jupiter",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/AuraofJupiter.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Aura of Jupiter",
  //     name: "Aura of Jupiter",
  //     gameType: gameTypes.new,
  //   },
  //   Autodromo: {
  //     href: "/casino/venumnovomatic-autodromo",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Autodromo.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Autodromo",
  //     name: "Autodromo",
  //     gameType: gameTypes.popular,
  //   },
  //   AutumnQueen: {
  //     href: "/casino/venumnovomatic-autumn-queen",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/AutumnQueen.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Autumn Queen",
  //     name: "Autumn Queen",
  //     gameType: gameTypes.new,
  //   },
  //   Avalon: {
  //     href: "/casino/venummicrogaming-avalon",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Avalon.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Avalon",
  //     name: "Avalon",
  //     gameType: gameTypes.popular,
  //   },
  //   AztecBonanza: {
  //     href: "/casino/venumpragmaticplay-aztec-bonanza",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/AztecBonanza.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Aztec Bonanza",
  //     name: "Aztec Bonanza",
  //     gameType: gameTypes.new,
  //   },
  //   AztecEmerald: {
  //     href: "/casino/venumamatic-aztec-emerald",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/AztecEmerald.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Aztec Emerald",
  //     name: "Aztec Emerald",
  //     gameType: gameTypes.popular,
  //   },
  //   AztecGems: {
  //     href: "/casino/venumpragmaticplay-aztec-gems",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/AztecGems.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Aztec Gems",
  //     name: "Aztec Gems",
  //     gameType: gameTypes.new,
  //   },
  //   AztecGlory: {
  //     href: "/casino/venumegtjackpot-aztec-glory",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/AztecGlory.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Aztec Glory",
  //     name: "Aztec Glory",
  //     gameType: gameTypes.popular,
  //   },
  //   AztecPower: {
  //     href: "/casino/venumnovomatic-aztec-power",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/AztecPower.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Aztec Power",
  //     name: "Aztec Power",
  //     gameType: gameTypes.new,
  //   },
  //   AztecSecret: {
  //     href: "/casino/venumamatic-aztec-secret",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/AztecSecret.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Aztec Secret",
  //     name: "Aztec Secret",
  //     gameType: gameTypes.popular,
  //   },
  //   AztecWarriorPrincess: {
  //     href: "/casino/venumplayngo-aztec-warrior-princess",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/AztecWarriorPrincess.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Aztec Warrior Princess",
  //     name: "Aztec Warrior Princess",
  //     gameType: gameTypes.new,
  //   },
  //   Backtothe70s: {
  //     href: "/casino/venumwazdan-back-to-the-70s",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Backtothe70s.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Back to the 70's",
  //     name: "Back to the 70's",
  //     gameType: gameTypes.popular,
  //   },
  //   BankRaid: {
  //     href: "/casino/venumnovomatic-bank-raid",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BankRaid.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Bank Raid",
  //     name: "Bank Raid",
  //     gameType: gameTypes.new,
  //   },
  //   BarsAndSevens: {
  //     href: "/casino/venumnovomatic-bars-and-sevens",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Bars&Sevens.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Bars & Sevens",
  //     name: "Bars & Sevens",
  //     gameType: gameTypes.popular,
  //   },
  //   BasketballStar: {
  //     href: "/casino/venummicrogaming-basketball-star",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BasketballStar.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Basketball Star",
  //     name: "Basketball Star",
  //     gameType: gameTypes.new,
  //   },
  //   BeachPartyHot: {
  //     href: "/casino/venumwazdan-beach-party-hot",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BeachPartyHot.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Beach Party Hot",
  //     name: "Beach Party Hot",
  //     gameType: gameTypes.popular,
  //   },
  //   BeautyFairy: {
  //     href: "/casino/venumamatic-beauty-fairy",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BeautyFairy.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Beauty Fairy",
  //     name: "Beauty Fairy",
  //     gameType: gameTypes.new,
  //   },
  //   BeautyWarrior: {
  //     href: "/casino/venumamatic-beauty-warrior",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BeautyWarrior.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Beauty Warrior",
  //     name: "Beauty Warrior",
  //     gameType: gameTypes.popular,
  //   },
  //   BeetleManiaDeluxe: {
  //     href: "/casino/venumnovomatic-beetle-mania-deluxe",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BeetleManiaDeluxe.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Beetle Mania Deluxe",
  //     name: "Beetle Mania Deluxe",
  //     gameType: gameTypes.new,
  //   },
  //   BellsOnFire: {
  //     href: "/casino/venumamatic-bells-on-fire",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BellsOnFire.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Bells On Fire",
  //     name: "Bells On Fire",
  //     gameType: gameTypes.popular,
  //   },
  //   BellsOnFireHot: {
  //     href: "/casino/venumamatic-bells-on-fire-hot",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BellsonFireHot.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Bells On Fire Hot",
  //     name: "Bells On Fire Hot",
  //     gameType: gameTypes.new,
  //   },
  //   BellsOnFireRombo: {
  //     href: "/casino/venumamatic-bells-on-fire-rombo",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BellsonFireRombo.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Bells on Fire Rombo",
  //     name: "Bells on Fire Rombo",
  //     gameType: gameTypes.popular,
  //   },
  //   BerryBurst: {
  //     href: "/casino/venumnetent-berry-burst",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BerryBurst.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Berry Burst",
  //     name: "Berry Burst",
  //     gameType: gameTypes.new,
  //   },
  //   BerryBurstMax: {
  //     href: "/casino/venumnetent-berry-burst-max",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BerryBurstMax.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Berry Burst Max",
  //     name: "Berry Burst Max",
  //     gameType: gameTypes.popular,
  //   },
  //   BigBadWolf: {
  //     href: "/casino/venumquickspin-big-bad-wolf",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BigBadWolf.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Big Bad Wolf",
  //     name: "Big Bad Wolf",
  //     gameType: gameTypes.new,
  //   },
  //   BigBassBonanza: {
  //     href: "/casino/venumpragmaticplay-big-bass-bonanza",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BigBassBonanza.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Big Bass Bonanza",
  //     name: "Big Bass Bonanza",
  //     gameType: gameTypes.popular,
  //   },
  //   BigbotCrew: {
  //     href: "/casino/venumquickspin-bigbot-crew",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BigbotCrew.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Bigbot Crew",
  //     name: "Bigbot Crew",
  //     gameType: gameTypes.new,
  //   },
  //   BigBuckBunny: {
  //     href: "/casino/venummerkur-big-buck-bunny",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BigBuckBunny.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Big Buck Bunny",
  //     name: "Big Buck Bunny",
  //     gameType: gameTypes.popular,
  //   },
  //   BigPanda: {
  //     href: "/casino/venumamatic-big-panda",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BigPanda.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Big Panda",
  //     name: "Big Panda",
  //     gameType: gameTypes.new,
  //   },
  //   BigRunner: {
  //     href: "/casino/venumnovomatic-big-runner",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BigRunner.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Big Runner",
  //     name: "Big Runner",
  //     gameType: gameTypes.popular,
  //   },
  //   BigTop: {
  //     href: "/casino/venummicrogaming-big-top",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BigTop.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Big Top",
  //     name: "Big Top",
  //     gameType: gameTypes.new,
  //   },
  //   BigWinCat: {
  //     href: "/casino/venumplayngo-big-win-cat",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BigWinCat.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Big Win Cat",
  //     name: "Big Win Cat",
  //     gameType: gameTypes.popular,
  //   },
  //   Billyonaire: {
  //     href: "/casino/venumamatic-billyonaire",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Billyonaire.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Billyonaire",
  //     name: "Billyonaire",
  //     gameType: gameTypes.new,
  //   },
  //   BillyonaireBonusBuy: {
  //     href: "/casino/venumamatic-billyonaire-bonus-buy",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BillyonaireBonusBuy.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Billyonaire Bonus Buy",
  //     name: "Billyonaire Bonus Buy",
  //     gameType: gameTypes.popular,
  //   },
  //   BillysGame: {
  //     href: "/casino/venumamatic-billys-game",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BillysGame.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Billy's Game",
  //     name: "Billy's Game",
  //     gameType: gameTypes.new,
  //   },
  //   BlackHawk: {
  //     href: "/casino/venumwazdan-black-hawk",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BlackHawk.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Black Hawk",
  //     name: "Black Hawk",
  //     gameType: gameTypes.popular,
  //   },
  //   BlackHawkDeluxe: {
  //     href: "/casino/venumwazdan-black-hawk-deluxe",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BlackHawkDeluxe.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Black Hawk Deluxe",
  //     name: "Black Hawk Deluxe",
  //     gameType: gameTypes.new,
  //   },
  //   BlazingStar: {
  //     href: "/casino/venummerkur-blazing-star",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BlazingStar.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Blazing Star",
  //     name: "Blazing Star",
  //     gameType: gameTypes.popular,
  //   },
  //   BloodSuckers: {
  //     href: "/casino/venumnetent-blood-suckers",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BloodSuckers.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Blood Suckers",
  //     name: "Blood Suckers",
  //     gameType: gameTypes.new,
  //   },
  //   BloodSuckers2: {
  //     href: "/casino/venumnetent-blood-suckers-2",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BloodSuckers2.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Blood Suckers 2",
  //     name: "Blood Suckers 2",
  //     gameType: gameTypes.popular,
  //   },
  //   BlueDolphin: {
  //     href: "/casino/venumamatic-blue-dolphin",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BlueDolphin.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Blue Dolphin",
  //     name: "Blue Dolphin",
  //     gameType: gameTypes.new,
  //   },
  //   BlueHeart: {
  //     href: "/casino/venumegtjackpot-blue-heart",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BlueHeart.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Blue Heart",
  //     name: "Blue Heart",
  //     gameType: gameTypes.popular,
  //   },
  //   BollywoodStory: {
  //     href: "/casino/venumnetent-bollywood-story",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BollywoodStory.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Bollywood Story",
  //     name: "Bollywood Story",
  //     gameType: gameTypes.popular,
  //   },
  //   BookOfAdmiral: {
  //     href: "/casino/venumamatic-book-of-admiral",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BookofAdmiral.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Book of Admiral",
  //     name: "Book of Admiral",
  //     gameType: gameTypes.new,
  //   },
  //   BookOfAztec: {
  //     href: "/casino/venumamatic-book-of-aztec",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BookofAztec.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Book of Aztec",
  //     name: "Book of Aztec",
  //     gameType: gameTypes.popular,
  //   },
  //   BookOfAztecBonusBuy: {
  //     href: "/casino/venumamatic-book-of-aztec-bonus-buy",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BookofAztecBonusBuy.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Book of Aztec Bonus Buy",
  //     name: "Book of Aztec Bonus Buy",
  //     gameType: gameTypes.new,
  //   },
  //   BookOfAztecSelect: {
  //     href: "/casino/venumamatic-book-of-aztec-select",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BookofAztecSelect.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Book of Aztec Select",
  //     name: "Book of Aztec Select",
  //     gameType: gameTypes.popular,
  //   },
  //   BookOfCrazyChicken: {
  //     href: "/casino/venumgamomat-book-of-crazy-chicken",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BookofCrazyChicken.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Book of Crazy Chicken",
  //     name: "Book of Crazy Chicken",
  //     gameType: gameTypes.new,
  //   },
  //   BookOfDead: {
  //     href: "/casino/venumplayngo-book-of-dead",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BookofDead.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Book of Dead",
  //     name: "Book of Dead",
  //     gameType: gameTypes.popular,
  //   },
  //   BookOfFate: {
  //     href: "/casino/venumnovomatic-book-of-fate",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BookofFate.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Book of Fate",
  //     name: "Book of Fate",
  //     gameType: gameTypes.new,
  //   },
  //   BookOfFire: {
  //     href: "/casino/venummerkur-book-of-fire",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BookofFire.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Book of Fire",
  //     name: "Book of Fire",
  //     gameType: gameTypes.popular,
  //   },
  //   BookOfFortune: {
  //     href: "/casino/venumamatic-book-of-fortune",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BookofFortune.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Book of Fortune",
  //     name: "Book of Fortune",
  //     gameType: gameTypes.new,
  //   },
  //   BookOfFruits: {
  //     href: "/casino/venumamatic-book-of-fruits",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BookofFruits.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Book of Fruits",
  //     name: "Book of Fruits",
  //     gameType: gameTypes.popular,
  //   },
  //   BookOfFruits10: {
  //     href: "/casino/venumamatic-book-of-fruits-10",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BookofFruits10.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Book of Fruits 10",
  //     name: "Book of Fruits 10",
  //     gameType: gameTypes.new,
  //   },
  //   BookOfFruitsHalloween: {
  //     href: "/casino/venumamatic-book-of-fruits-halloween",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BookofFruitsHalloween.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Book of Fruits Halloween",
  //     name: "Book of Fruits Halloween",
  //     gameType: gameTypes.popular,
  //   },
  //   BookOfJuno: {
  //     href: "/casino/venumgamomat-book-of-juno",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BookofJuno.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Book of Juno",
  //     name: "Book of Juno",
  //     gameType: gameTypes.new,
  //   },
  //   BookOfLords: {
  //     href: "/casino/venumamatic-book-of-lords",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BookofLords.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Book of Lords",
  //     name: "Book of Lords",
  //     gameType: gameTypes.popular,
  //   },
  //   BookOfMadness: {
  //     href: "/casino/venumgamomat-book-of-madness",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BookofMadness.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Book of Madness",
  //     name: "Book of Madness",
  //     gameType: gameTypes.new,
  //   },
  //   BookOfMagic: {
  //     href: "/casino/venumegtjackpot-book-of-magic",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BookofMagic.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Book of Magic",
  //     name: "Book of Magic",
  //     gameType: gameTypes.popular,
  //   },
  //   BookOfMaya: {
  //     href: "/casino/venumnovomatic-book-of-maya",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BookofMaya.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Book of Maya",
  //     name: "Book of Maya",
  //     gameType: gameTypes.new,
  //   },
  //   BookOfOasis: {
  //     href: "/casino/venumgamomat-book-of-oasis",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BookofOasis.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Book of Oasis",
  //     name: "Book of Oasis",
  //     gameType: gameTypes.popular,
  //   },
  //   BookOfPharao: {
  //     href: "/casino/venumamatic-book-of-pharao",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BookofPharao.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Book of Pharao",
  //     name: "Book of Pharao",
  //     gameType: gameTypes.new,
  //   },
  //   BookOfQueen: {
  //     href: "/casino/venumamatic-book-of-queen",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BookofQueen.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Book of Queen",
  //     name: "Book of Queen",
  //     gameType: gameTypes.popular,
  //   },
  //   BookOfRa: {
  //     href: "/casino/venumnovomatic-book-of-ra",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BookofRa.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Book of Ra",
  //     name: "Book of Ra",
  //     gameType: gameTypes.new,
  //   },
  //   BookOfRaDeluxe: {
  //     href: "/casino/venumnovomatic-book-of-ra-deluxe",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BookofRaDeluxe.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Book of Ra Deluxe",
  //     name: "Book of Ra Deluxe",
  //     gameType: gameTypes.popular,
  //   },
  //   BookOfRaDeluxe6: {
  //     href: "/casino/venumnovomatic-book-of-ra-deluxe-6",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BookofRaDeluxe6.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Book of Ra Deluxe 6",
  //     name: "Book of Ra Deluxe 6",
  //     gameType: gameTypes.new,
  //   },
  //   BookOfRaMagic: {
  //     href: "/casino/venumnovomatic-book-of-ra-magic",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BookofRaMagic.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Book of Ra Magic",
  //     name: "Book of Ra Magic",
  //     gameType: gameTypes.popular,
  //   },
  //   BookOfStars: {
  //     href: "/casino/venumnovomatic-book-of-stars",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BookofStars.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Book of Stars",
  //     name: "Book of Stars",
  //     gameType: gameTypes.new,
  //   },
  //   BreakAway: {
  //     href: "/casino/venummicrogaming-break-away",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BreakAway.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Break Away",
  //     name: "Break Away",
  //     gameType: gameTypes.popular,
  //   },
  //   BreakDaBank: {
  //     href: "/casino/venummicrogaming-break-da-bank",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BreakdaBank.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Break da Bank",
  //     name: "Break da Bank",
  //     gameType: gameTypes.new,
  //   },
  //   BreakDaBankAgain: {
  //     href: "/casino/venummicrogaming-break-da-bank-again",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BreakdaBankAgain.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Break da Bank Again",
  //     name: "Break da Bank Again",
  //     gameType: gameTypes.popular,
  //   },
  //   BrilliantSparkle: {
  //     href: "/casino/venummerkur-brilliant-sparkle",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BrilliantSparkle.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Brilliant Sparkle",
  //     name: "Brilliant Sparkle",
  //     gameType: gameTypes.new,
  //   },
  //   BuffaloKing: {
  //     href: "/casino/venumpragmaticplay-buffalo-king",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BuffaloKing.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Buffalo King",
  //     name: "Buffalo King",
  //     gameType: gameTypes.popular,
  //   },
  //   BuffaloKingMegaways: {
  //     href: "/casino/venumpragmaticplay-buffalo-king-megaways",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BuffaloKingMegaways.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Buffalo King Megaways",
  //     name: "Buffalo King Megaways",
  //     gameType: gameTypes.new,
  //   },
  //   BuffaloMagic: {
  //     href: "/casino/venumnovomatic-buffalo-magic",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BuffaloMagic.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Buffalo Magic",
  //     name: "Buffalo Magic",
  //     gameType: gameTypes.popular,
  //   },
  //   BullRush: {
  //     href: "/casino/venumnovomatic-bull-rush",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BullRush.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Bull Rush",
  //     name: "Bull Rush",
  //     gameType: gameTypes.new,
  //   },
  //   BurningBells10: {
  //     href: "/casino/venumamatic-burning-bells-10",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BurningBells10.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Burning Bells 10",
  //     name: "Burning Bells 10",
  //     gameType: gameTypes.popular,
  //   },
  //   BurningBells20: {
  //     href: "/casino/venumamatic-burning-bells-20",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BurningBells20.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Burning Bells 20",
  //     name: "Burning Bells 20",
  //     gameType: gameTypes.new,
  //   },
  //   BurningBells40: {
  //     href: "/casino/venumamatic-burning-bells-40",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BurningBells40.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Burning Bells 40",
  //     name: "Burning Bells 40",
  //     gameType: gameTypes.popular,
  //   },
  //   BurningDesire: {
  //     href: "/casino/venummicrogaming-burning-desire",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BurningDesire.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Burning Desire",
  //     name: "Burning Desire",
  //     gameType: gameTypes.new,
  //   },
  //   BurningDice: {
  //     href: "/casino/venumegtjackpot-burning-dice",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BurningDice.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Burning Dice",
  //     name: "Burning Dice",
  //     gameType: gameTypes.popular,
  //   },
  //   BurningHot: {
  //     href: "/casino/venumegtjackpot-burning-hot",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BurningHot.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Burning Hot",
  //     name: "Burning Hot",
  //     gameType: gameTypes.new,
  //   },
  //   BurningHot7s: {
  //     href: "/casino/venumnovomatic-burning-hot-7s",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BurningHot7s.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Burning Hot 7's",
  //     name: "Burning Hot 7's",
  //     gameType: gameTypes.popular,
  //   },
  //   BurningReels: {
  //     href: "/casino/venumwazdan-burning-reels",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BurningReels.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Burning Reels",
  //     name: "Burning Reels",
  //     gameType: gameTypes.new,
  //   },
  //   BurningStars: {
  //     href: "/casino/venumwazdan-burning-stars",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BurningStars.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Burning Stars",
  //     name: "Burning Stars",
  //     gameType: gameTypes.popular,
  //   },
  //   BurningWild: {
  //     href: "/casino/venumnovomatic-burning-wild",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/BurningWild.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Burning Wild",
  //     name: "Burning Wild",
  //     gameType: gameTypes.new,
  //   },
  //   ButterflyStaxx: {
  //     href: "/casino/venumnetent-butterfly-staxx",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/ButterflyStaxx.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Butterfly Staxx",
  //     name: "Butterfly Staxx",
  //     gameType: gameTypes.popular,
  //   },
  //   ButterflyStaxx2: {
  //     href: "/casino/venumnetent-butterfly-staxx-2",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/ButterflyStaxx2.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Butterfly Staxx 2",
  //     name: "Butterfly Staxx 2",
  //     gameType: gameTypes.new,
  //   },
  //   CaishensCash: {
  //     href: "/casino/venumpragmaticplay-caishens-cash",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/CaishensCash.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Caishen's Cash",
  //     name: "Caishen's Cash",
  //     gameType: gameTypes.popular,
  //   },
  //   CaishensGold: {
  //     href: "/casino/venumpragmaticplay-caishens-gold",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/CaishensGold.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Caishen's Gold",
  //     name: "Caishen's Gold",
  //     gameType: gameTypes.new,
  //   },
  //   CandyAndFruits: {
  //     href: "/casino/venummerkur-candy-and-fruits",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Candy&Fruits.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Candy & Fruits",
  //     name: "Candy & Fruits",
  //     gameType: gameTypes.popular,
  //   },
  //   CannonThunder: {
  //     href: "/casino/venummerkur-cannon-thunder",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/CannonThunder.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Cannon Thunder",
  //     name: "Cannon Thunder",
  //     gameType: gameTypes.new,
  //   },
  //   CaptainsBooty: {
  //     href: "/casino/venumnovomatic-captains-booty",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/CaptainsBooty.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Captain's Booty",
  //     name: "Captain's Booty",
  //     gameType: gameTypes.popular,
  //   },
  //   CaptainStack: {
  //     href: "/casino/venummerkur-captain-stack",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/CaptainStack.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Captain Stack",
  //     name: "Captain Stack",
  //     gameType: gameTypes.new,
  //   },
  //   CaptainVenture: {
  //     href: "/casino/venumnovomatic-captain-venture",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/CaptainVenture.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Captain Venture",
  //     name: "Captain Venture",
  //     gameType: gameTypes.popular,
  //   },
  //   CaramelHot: {
  //     href: "/casino/venumegtjackpot-caramel-hot",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/CaramelHot.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Caramel Hot",
  //     name: "Caramel Hot",
  //     gameType: gameTypes.new,
  //   },
  //   Carnaval: {
  //     href: "/casino/venummicrogaming-carnaval",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Carnaval.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Carnaval",
  //     name: "Carnaval",
  //     gameType: gameTypes.popular,
  //   },
  //   Casanova: {
  //     href: "/casino/venumamatic-casanova",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Casanova.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Casanova",
  //     name: "Casanova",
  //     gameType: gameTypes.new,
  //   },
  //   CasanovasLadies: {
  //     href: "/casino/venumamatic-casanovas-ladies",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/CasanovasLadies.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Casanova's Ladies",
  //     name: "Casanova's Ladies",
  //     gameType: gameTypes.popular,
  //   },
  //   Cashapillar: {
  //     href: "/casino/venummicrogaming-cashapillar",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Cashapillar.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Cashapillar",
  //     name: "Cashapillar",
  //     gameType: gameTypes.new,
  //   },
  //   CashFruitsPlus: {
  //     href: "/casino/venummerkur-cash-fruits-plus",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/CashFruitsPlus.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Cash Fruits Plus",
  //     name: "Cash Fruits Plus",
  //     gameType: gameTypes.popular,
  //   },
  //   CashRunner: {
  //     href: "/casino/venumnovomatic-cash-runner",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/CashRunner.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Cash Runner",
  //     name: "Cash Runner",
  //     gameType: gameTypes.new,
  //   },
  //   CasinoMania: {
  //     href: "/casino/venumegtjackpot-casino-mania",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/CasinoMania.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Casino Mania",
  //     name: "Casino Mania",
  //     gameType: gameTypes.popular,
  //   },
  //   Casinova: {
  //     href: "/casino/venumamatic-casinova",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/casinova.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Casinova",
  //     name: "Casinova",
  //     gameType: gameTypes.new,
  //   },
  //   CatsRoyal: {
  //     href: "/casino/venumegtjackpot-cats-royal",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/CatsRoyal.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Cats Royal",
  //     name: "Cats Royal",
  //     gameType: gameTypes.popular,
  //   },
  //   CelebrationaleFlameLines: {
  //     href: "/casino/venummerkur-celebrationale-flame-lines",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/CelebrationaleFlameLines.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Celebrationale Flame Lines",
  //     name: "Celebrationale Flame Lines",
  //     gameType: gameTypes.new,
  //   },
  //   Centurio: {
  //     href: "/casino/venummerkur-centurio",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Centurio.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Centurio",
  //     name: "Centurio",
  //     gameType: gameTypes.popular,
  //   },
  //   ChangingFate40: {
  //     href: "/casino/venumnovomatic-changing-fate-40",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/ChangingFate40.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Changing Fate 40",
  //     name: "Changing Fate 40",
  //     gameType: gameTypes.new,
  //   },
  //   Chicago: {
  //     href: "/casino/venumnovomatic-chicago",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Chicago.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Chicago",
  //     name: "Chicago",
  //     gameType: gameTypes.popular,
  //   },
  //   ChilliHeat: {
  //     href: "/casino/venumpragmaticplay-chilli-heat",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/ChilliHeat.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Chilli Heat",
  //     name: "Chilli Heat",
  //     gameType: gameTypes.new,
  //   },
  //   Cindereela: {
  //     href: "/casino/venumnovomatic-cindereela",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Cindereela.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Cindereela",
  //     name: "Cindereela",
  //     gameType: gameTypes.popular,
  //   },
  //   CircusBrilliant: {
  //     href: "/casino/venumegtjackpot-circus-brilliant",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/CircusBrilliant.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Circus Brilliant",
  //     name: "Circus Brilliant",
  //     gameType: gameTypes.new,
  //   },
  //   CoinOfApollo: {
  //     href: "/casino/venumnovomatic-coin-of-apollo",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/CoinofApollo.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Coin of Apollo",
  //     name: "Coin of Apollo",
  //     gameType: gameTypes.popular,
  //   },
  //   ColinTheCat: {
  //     href: "/casino/venumwazdan-colin-the-cat",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/ColintheCat.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Colin the Cat",
  //     name: "Colin the Cat",
  //     gameType: gameTypes.new,
  //   },
  //   ColumbusDeluxe: {
  //     href: "/casino/venumnovomatic-columbus-deluxe",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/ColumbusDeluxe.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Columbus Deluxe",
  //     name: "Columbus Deluxe",
  //     gameType: gameTypes.popular,
  //   },
  //   Conan: {
  //     href: "/casino/venumnetent-conan",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Conan.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Conan",
  //     name: "Conan",
  //     gameType: gameTypes.new,
  //   },
  //   CongoCash: {
  //     href: "/casino/venumpragmaticplay-congo-cash",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/CongoCash.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Congo Cash",
  //     name: "Congo Cash",
  //     gameType: gameTypes.popular,
  //   },
  //   CoolDiamondsII: {
  //     href: "/casino/venumamatic-cool-diamonds-ii",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/CoolDiamondsII.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Cool Diamonds II",
  //     name: "Cool Diamonds II",
  //     gameType: gameTypes.new,
  //   },
  //   CopsNRobbers: {
  //     href: "/casino/venumnovomatic-cops-n-robbers",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/CopsnRobbers.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Cops 'n' Robbers",
  //     name: "Cops 'n' Robbers",
  //     gameType: gameTypes.popular,
  //   },
  //   CopyCats: {
  //     href: "/casino/venumnetent-copy-cats",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/CopyCats.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Copy Cats",
  //     name: "Copy Cats",
  //     gameType: gameTypes.new,
  //   },
  //   CoralIsland: {
  //     href: "/casino/venumegtjackpot-coral-island",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/CoralIsland.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Coral Island",
  //     name: "Coral Island",
  //     gameType: gameTypes.popular,
  //   },
  //   CorridaRomance: {
  //     href: "/casino/venumwazdan-corrida-romance",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/CorridaRomance.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Corrida Romance",
  //     name: "Corrida Romance",
  //     gameType: gameTypes.new,
  //   },
  //   CrazyBee: {
  //     href: "/casino/venumamatic-crazy-bee",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/CrazyBee.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Crazy Bee",
  //     name: "Crazy Bee",
  //     gameType: gameTypes.popular,
  //   },
  //   CrystalBall: {
  //     href: "/casino/venumgamomat-crystal-ball",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/CrystalBall.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Crystal Ball",
  //     name: "Crystal Ball",
  //     gameType: gameTypes.new,
  //   },
  //   CrystalFruits: {
  //     href: "/casino/venumamatic-crystal-fruits",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/CrystalFruits.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Crystal Fruits",
  //     name: "Crystal Fruits",
  //     gameType: gameTypes.popular,
  //   },
  //   CrystalQueen: {
  //     href: "/casino/venumquickspin-crystal-queen",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/CrystalQueen.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Crystal Queen",
  //     name: "Crystal Queen",
  //     gameType: gameTypes.new,
  //   },
  //   CurseOfTheWerewolfMegaways: {
  //     href: "/casino/venumpragmaticplay-curse-of-the-werewolf-megaways",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/CurseoftheWerewolfMegaways.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Curse of the Werewolf Megaways",
  //     name: "Curse of the Werewolf Megaways",
  //     gameType: gameTypes.popular,
  //   },
  //   DarkQueen: {
  //     href: "/casino/venumegtjackpot-dark-queen",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/DarkQueen.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Dark Queen",
  //     name: "Dark Queen",
  //     gameType: gameTypes.new,
  //   },
  //   DaVincisTreasure: {
  //     href: "/casino/venumpragmaticplay-da-vincis-treasure",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/DaVincisTreasure.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Da Vinci's Treasure",
  //     name: "Da Vinci's Treasure",
  //     gameType: gameTypes.popular,
  //   },
  //   DazzleMe: {
  //     href: "/casino/venumnetent-dazzle-me",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/DazzleMe.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Dazzle Me",
  //     name: "Dazzle Me",
  //     gameType: gameTypes.new,
  //   },
  //   DazzlingDiamonds: {
  //     href: "/casino/venumnovomatic-dazzling-diamonds",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/DazzlingDiamonds.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Dazzling Diamonds",
  //     name: "Dazzling Diamonds",
  //     gameType: gameTypes.popular,
  //   },
  //   DeadOrAlive: {
  //     href: "/casino/venumnetent-dead-or-alive",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/DeadorAlive.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Dead or Alive",
  //     name: "Dead or Alive",
  //     gameType: gameTypes.new,
  //   },
  //   DeadOrAlive2: {
  //     href: "/casino/venumnetent-dead-or-alive-2",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/DeadorAlive2.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Dead or Alive 2",
  //     name: "Dead or Alive 2",
  //     gameType: gameTypes.popular,
  //   },
  //   DemonJack27: {
  //     href: "/casino/venumwazdan-demon-jack-27",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/DemonJack27.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Demon Jack 27",
  //     name: "Demon Jack 27",
  //     gameType: gameTypes.new,
  //   },
  //   DiamondAndGold: {
  //     href: "/casino/venummerkur-diamond-and-gold",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Diamond&Gold.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Diamond & Gold",
  //     name: "Diamond & Gold",
  //     gameType: gameTypes.popular,
  //   },
  //   Diamond7: {
  //     href: "/casino/venumnovomatic-diamond-7",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Diamond7.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Diamond 7",
  //     name: "Diamond 7",
  //     gameType: gameTypes.new,
  //   },
  //   DiamondCats: {
  //     href: "/casino/venumamatic-diamond-cats",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/DiamondCats.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Diamond Cats",
  //     name: "Diamond Cats",
  //     gameType: gameTypes.popular,
  //   },
  //   DiamondMonkey: {
  //     href: "/casino/venumamatic-diamond-monkey",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/DiamondMonkey.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Diamond Monkey",
  //     name: "Diamond Monkey",
  //     gameType: gameTypes.new,
  //   },
  //   DiamondsAreForever3Lines: {
  //     href: "/casino/venumpragmaticplay-diamonds-are-forever-3-lines",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/DiamondsareForever3Lines.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Diamonds are Forever 3 Lines",
  //     name: "Diamonds are Forever 3 Lines",
  //     gameType: gameTypes.popular,
  //   },
  //   DiamondsOnFire: {
  //     href: "/casino/venumamatic-diamonds-on-fire",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/DiamondsOnFire.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Diamonds On Fire",
  //     name: "Diamonds On Fire",
  //     gameType: gameTypes.new,
  //   },
  //   DiamondStrike: {
  //     href: "/casino/venumpragmaticplay-diamond-strike",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/DiamondStrike.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Diamond Strike",
  //     name: "Diamond Strike",
  //     gameType: gameTypes.popular,
  //   },
  //   DiaMuertos: {
  //     href: "/casino/venumamatic-dia-muertos",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/DiaMuertos.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Dia Muertos",
  //     name: "Dia Muertos",
  //     gameType: gameTypes.new,
  //   },
  //   DiceAndRoll: {
  //     href: "/casino/venumegtjackpot-dice-and-roll",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/DiceandRoll.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Dice and Roll",
  //     name: "Dice and Roll",
  //     gameType: gameTypes.popular,
  //   },
  //   DiceOfRa: {
  //     href: "/casino/venumegtjackpot-dice-of-ra",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/DiceofRa.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Dice of Ra",
  //     name: "Dice of Ra",
  //     gameType: gameTypes.new,
  //   },
  //   DinoReels81: {
  //     href: "/casino/venumwazdan-dino-reels-81",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/DinoReels81.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Dino Reels 81",
  //     name: "Dino Reels 81",
  //     gameType: gameTypes.popular,
  //   },
  //   DivineDreams: {
  //     href: "/casino/venumquickspin-divine-dreams",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/DivineDreams.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Divine Dreams",
  //     name: "Divine Dreams",
  //     gameType: gameTypes.new,
  //   },
  //   DolphinsPearl: {
  //     href: "/casino/venumnovomatic-dolphins-pearl",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/DolphinsPearl.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Dolphins Pearl",
  //     name: "Dolphins Pearl",
  //     gameType: gameTypes.popular,
  //   },
  //   DolphinsPearlDeluxe: {
  //     href: "/casino/venumnovomatic-dolphins-pearl-deluxe",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/DolphinsPearlDeluxe.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Dolphin's Pearl Deluxe",
  //     name: "Dolphin's Pearl Deluxe",
  //     gameType: gameTypes.new,
  //   },
  //   DoomOfEgypt: {
  //     href: "/casino/venumplayngo-doom-of-egypt",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/DoomofEgypt.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Doom of Egypt",
  //     name: "Doom of Egypt",
  //     gameType: gameTypes.popular,
  //   },
  //   DorothysFairyland: {
  //     href: "/casino/venumegtjackpot-dorothys-fairyland",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/DorothysFairyland.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Dorothy's Fairyland",
  //     name: "Dorothy's Fairyland",
  //     gameType: gameTypes.new,
  //   },
  //   DoubleStacks: {
  //     href: "/casino/venumnetent-double-stacks",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/DoubleStacks.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Double Stacks",
  //     name: "Double Stacks",
  //     gameType: gameTypes.popular,
  //   },
  //   DoubleTripleChance: {
  //     href: "/casino/venummerkur-double-triple-chance",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/DoubleTripleChance.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Double Triple Chance",
  //     name: "Double Triple Chance",
  //     gameType: gameTypes.new,
  //   },
  //   Dracula: {
  //     href: "/casino/venumnetent-dracula",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Dracula.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Dracula",
  //     name: "Dracula",
  //     gameType: gameTypes.popular,
  //   },
  //   DraculasCastle: {
  //     href: "/casino/venumwazdan-draculas-castle",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/DraculasCastle.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Dracula's Castle",
  //     name: "Dracula's Castle",
  //     gameType: gameTypes.new,
  //   },
  //   DragonBlitz: {
  //     href: "/casino/venumnovomatic-dragon-blitz",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/DragonBlitz.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Dragon Blitz",
  //     name: "Dragon Blitz",
  //     gameType: gameTypes.popular,
  //   },
  //   DragonPays: {
  //     href: "/casino/venumnovomatic-dragon-pays",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/DragonPays.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Dragon Pays",
  //     name: "Dragon Pays",
  //     gameType: gameTypes.popular,
  //   },
  //   DragonReels: {
  //     href: "/casino/venumegtjackpot-dragon-reels",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/DragonReels.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Dragon Reels",
  //     name: "Dragon Reels",
  //     gameType: gameTypes.new,
  //   },
  //   DragonsMystery: {
  //     href: "/casino/venumamatic-dragons-mystery",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/DragonsMystery.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Dragons Mystery",
  //     name: "Dragons Mystery",
  //     gameType: gameTypes.popular,
  //   },
  //   DreamingIsland: {
  //     href: "/casino/venummerkur-dreaming-island",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/DreamingIsland.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Dreaming Island",
  //     name: "Dreaming Island",
  //     gameType: gameTypes.new,
  //   },
  //   DriveMultiplierMayhem: {
  //     href: "/casino/venumnetent-drive-multiplier-mayhem",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/DriveMultiplierMayhem.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Drive Multiplier Mayhem",
  //     name: "Drive Multiplier Mayhem",
  //     gameType: gameTypes.popular,
  //   },
  //   DuckShooter: {
  //     href: "/casino/venumgamomat-duck-shooter",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/DuckShooter.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Duck Shooter",
  //     name: "Duck Shooter",
  //     gameType: gameTypes.new,
  //   },
  //   DurianDynamite: {
  //     href: "/casino/venumquickspin-durian-dynamite",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/DurianDynamite.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Durian Dynamite",
  //     name: "Durian Dynamite",
  //     gameType: gameTypes.popular,
  //   },
  //   DwarfsGoneWild: {
  //     href: "/casino/venumquickspin-dwarfs-gone-wild",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/DwarfsGoneWild.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Dwarfs Gone Wild",
  //     name: "Dwarfs Gone Wild",
  //     gameType: gameTypes.new,
  //   },
  //   DwarvenGold: {
  //     href: "/casino/venumpragmaticplay-dwarven-gold",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/DwarvenGold.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Dwarven Gold",
  //     name: "Dwarven Gold",
  //     gameType: gameTypes.popular,
  //   },
  //   DwarvenGoldDeluxe: {
  //     href: "/casino/venumpragmaticplay-dwarven-gold-deluxe",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/DwarvenGoldDeluxe.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Dwarven Gold Deluxe",
  //     name: "Dwarven Gold Deluxe",
  //     gameType: gameTypes.new,
  //   },
  //   DynastyOfRa: {
  //     href: "/casino/venumnovomatic-dynasty-of-ra",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/DynastyofRa.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Dynasty of Ra",
  //     name: "Dynasty of Ra",
  //     gameType: gameTypes.popular,
  //   },
  //   EagleBucks: {
  //     href: "/casino/venumnovomatic-eagle-bucks",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/EagleBucks.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Eagle Bucks",
  //     name: "Eagle Bucks",
  //     gameType: gameTypes.new,
  //   },
  //   EasternEmeralds: {
  //     href: "/casino/venumquickspin-eastern-emeralds",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/EasternEmeralds.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Eastern Emeralds",
  //     name: "Eastern Emeralds",
  //     gameType: gameTypes.popular,
  //   },
  //   Eggomatic: {
  //     href: "/casino/venumnetent-eggomatic",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Eggomatic.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Eggomatic",
  //     name: "Eggomatic",
  //     gameType: gameTypes.new,
  //   },
  //   ElectricFruit: {
  //     href: "/casino/venummerkur-electric-fruit",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/ElectricFruit.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Electric Fruit",
  //     name: "Electric Fruit",
  //     gameType: gameTypes.popular,
  //   },
  //   Elements: {
  //     href: "/casino/venumnetent-elements",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Elements.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Elements",
  //     name: "Elements",
  //     gameType: gameTypes.new,
  //   },
  //   ElTorero: {
  //     href: "/casino/venummerkur-el-torero",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/ElTorero.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "El Torero",
  //     name: "El Torero",
  //     gameType: gameTypes.popular,
  //   },
  //   EmeraldKingRainbowRoad: {
  //     href: "/casino/venumpragmaticplay-emerald-king-rainbow-road",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/EmeraldKingRainbowRoad.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Emerald King Rainbow Road",
  //     name: "Emerald King Rainbow Road",
  //     gameType: gameTypes.new,
  //   },
  //   EmojiPlanet: {
  //     href: "/casino/venumnetent-emoji-planet",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/EmojiPlanet.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Emoji Planet",
  //     name: "Emoji Planet",
  //     gameType: gameTypes.popular,
  //   },
  //   EmperorOfTheSea: {
  //     href: "/casino/venummicrogaming-emperor-of-the-sea",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/EmperoroftheSea.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Emperor of the Sea",
  //     name: "Emperor of the Sea",
  //     gameType: gameTypes.new,
  //   },
  //   EnchantedCleopatra: {
  //     href: "/casino/venumamatic-enchanted-cleopatra",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/EnchantedCleopatra.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Enchanted Cleopatra",
  //     name: "Enchanted Cleopatra",
  //     gameType: gameTypes.popular,
  //   },
  //   EndlessSummer: {
  //     href: "/casino/venummerkur-endless-summer",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/EndlessSummer.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Endless Summer",
  //     name: "Endless Summer",
  //     gameType: gameTypes.new,
  //   },

  //   EnergyBurst: {
  //     href: "/casino/venummerkur-energy-burst",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/EnergyBurst.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Energy Burst",
  //     name: "Energy Burst",
  //     gameType: gameTypes.popular,
  //   },
  //   Excalibur: {
  //     href: "/casino/venumnetent-excalibur",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Excalibur.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Excalibur",
  //     name: "Excalibur",
  //     gameType: gameTypes.new,
  //   },
  //   Extra10Liner: {
  //     href: "/casino/venummerkur-extra-10-liner",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Extra10Liner.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Extra 10 Liner",
  //     name: "Extra 10 Liner",
  //     gameType: gameTypes.popular,
  //   },
  //   ExtraJoker: {
  //     href: "/casino/venumegtjackpot-extra-joker",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/ExtraJoker.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Extra Joker",
  //     name: "Extra Joker",
  //     gameType: gameTypes.new,
  //   },
  //   ExtraJuicy: {
  //     href: "/casino/venumpragmaticplay-extra-juicy",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/ExtraJuicy.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Extra Juicy",
  //     name: "Extra Juicy",
  //     gameType: gameTypes.popular,
  //   },
  //   ExtraStars: {
  //     href: "/casino/venumegtjackpot-extra-stars",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/ExtraStars.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Extra Stars",
  //     name: "Extra Stars",
  //     gameType: gameTypes.new,
  //   },
  //   ExtraWild: {
  //     href: "/casino/venummerkur-extra-wild",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/ExtraWild.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Extra Wild",
  //     name: "Extra Wild",
  //     gameType: gameTypes.popular,
  //   },
  //   EyeOfHorus: {
  //     href: "/casino/venummerkur-eye-of-horus",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/EyeOfHorus.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Eye of Horus",
  //     name: "Eye of Horus",
  //     gameType: gameTypes.new,
  //   },
  //   EyeOfRa: {
  //     href: "/casino/venumamatic-eye-of-ra",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/EyeOfRa.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Eye of Ra",
  //     name: "Eye of Ra",
  //     gameType: gameTypes.popular,
  //   },
  //   EyeOfTheDragon: {
  //     href: "/casino/venumnovomatic-eye-of-the-dragon",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/EyeOfTheDragon.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Eye of the Dragon",
  //     name: "Eye of the Dragon",
  //     gameType: gameTypes.new,
  //   },
  //   EyeOfTheQueen: {
  //     href: "/casino/venumnovomatic-eye-of-the-queen",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/EyeOfTheQueen.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Eye of the Queen",
  //     name: "Eye of the Queen",
  //     gameType: gameTypes.popular,
  //   },
  //   FairyGate: {
  //     href: "/casino/venumquickspin-fairy-gate",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FairyGate.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Fairy Gate",
  //     name: "Fairy Gate",
  //     gameType: gameTypes.new,
  //   },
  //   FairyQueen: {
  //     href: "/casino/venumnovomatic-fairy-queen",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FairyQueen.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Fairy Queen",
  //     name: "Fairy Queen",
  //     gameType: gameTypes.popular,
  //   },
  //   FairytaleFortune: {
  //     href: "/casino/venumpragmaticplay-fairytale-fortune",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FairytaleFortune.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Fairytale Fortune",
  //     name: "Fairytale Fortune",
  //     gameType: gameTypes.new,
  //   },
  //   FancyFruits: {
  //     href: "/casino/venumgamomat-fancy-fruits",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FancyFruits.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Fancy Fruits",
  //     name: "Fancy Fruits",
  //     gameType: gameTypes.popular,
  //   },
  //   Fangbaozhu: {
  //     href: "/casino/venumnovomatic-fangbaozhu",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Fangbaozhu.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Fangbaozhu",
  //     name: "Fangbaozhu",
  //     gameType: gameTypes.new,
  //   },
  //   FantasticFruit: {
  //     href: "/casino/venummerkur-fantastic-fruit",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FantasticFruit.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Fantastic Fruit",
  //     name: "Fantastic Fruit",
  //     gameType: gameTypes.popular,
  //   },
  //   FastMoney: {
  //     href: "/casino/venumegtjackpot-fast-money",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FastMoney.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Fast Money",
  //     name: "Fast Money",
  //     gameType: gameTypes.new,
  //   },
  //   Faust: {
  //     href: "/casino/venumnovomatic-faust",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Faust.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Faust",
  //     name: "Faust",
  //     gameType: gameTypes.popular,
  //   },
  //   FeatherFrenzy: {
  //     href: "/casino/venumnovomatic-feather-frenzy",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FeatherFrenzy.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Feather Frenzy",
  //     name: "Feather Frenzy",
  //     gameType: gameTypes.new,
  //   },
  //   FenixPlay: {
  //     href: "/casino/venumwazdan-fenix-play",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FenixPlay.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Fenix Play",
  //     name: "Fenix Play",
  //     gameType: gameTypes.popular,
  //   },
  //   FenixPlay27: {
  //     href: "/casino/venumwazdan-fenix-play-27",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FenixPlay27.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Fenix Play 27",
  //     name: "Fenix Play 27",
  //     gameType: gameTypes.new,
  //   },
  //   FenixPlay27Deluxe: {
  //     href: "/casino/venumwazdan-fenix-play-27-deluxe",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FenixPlay27Deluxe.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Fenix Play 27 Deluxe",
  //     name: "Fenix Play 27 Deluxe",
  //     gameType: gameTypes.popular,
  //   },
  //   FenixPlayDeluxe: {
  //     href: "/casino/venumwazdan-fenix-play-deluxe",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FenixPlayDeluxe.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Fenix Play Deluxe",
  //     name: "Fenix Play Deluxe",
  //     gameType: gameTypes.new,
  //   },
  //   FieryFruits: {
  //     href: "/casino/venumamatic-fiery-fruits",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FieryFruits.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Fiery Fruits",
  //     name: "Fiery Fruits",
  //     gameType: gameTypes.popular,
  //   },
  //   FireAndIce: {
  //     href: "/casino/venumamatic-fire-and-ice",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FireAndIce.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Fire and Ice",
  //     name: "Fire and Ice",
  //     gameType: gameTypes.new,
  //   },
  //   FireBird: {
  //     href: "/casino/venumwazdan-fire-bird",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FireBird.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Fire Bird",
  //     name: "Fire Bird",
  //     gameType: gameTypes.popular,
  //   },
  //   FireJoker: {
  //     href: "/casino/venumplayngo-fire-joker",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FireJoker.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Fire Joker",
  //     name: "Fire Joker",
  //     gameType: gameTypes.new,
  //   },
  //   FireOfEgypt: {
  //     href: "/casino/venummerkur-fire-of-egypt",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FireOfEgypt.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Fire of Egypt",
  //     name: "Fire of Egypt",
  //     gameType: gameTypes.popular,
  //   },
  //   FireQueen: {
  //     href: "/casino/venumamatic-fire-queen",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FireQueen.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Fire Queen",
  //     name: "Fire Queen",
  //     gameType: gameTypes.new,
  //   },
  //   FirstDynasty: {
  //     href: "/casino/venummerkur-first-dynasty",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FirstDynasty.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "First Dynasty",
  //     name: "First Dynasty",
  //     gameType: gameTypes.popular,
  //   },
  //   FishingFrenzy: {
  //     href: "/casino/venummerkur-fishing-frenzy",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FishingFrenzy.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Fishing Frenzy",
  //     name: "Fishing Frenzy",
  //     gameType: gameTypes.new,
  //   },
  //   FlameDancer: {
  //     href: "/casino/venumnovomatic-flame-dancer",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FlameDancer.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Flame Dancer",
  //     name: "Flame Dancer",
  //     gameType: gameTypes.popular,
  //   },
  //   FlamencoRoses: {
  //     href: "/casino/venumnovomatic-flamenco-roses",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FlamencoRoses.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Flamenco Roses",
  //     name: "Flamenco Roses",
  //     gameType: gameTypes.new,
  //   },
  //   FlamingDice: {
  //     href: "/casino/venumegtjackpot-flaming-dice",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FlamingDice.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Flaming Dice",
  //     name: "Flaming Dice",
  //     gameType: gameTypes.popular,
  //   },
  //   FlamingHot: {
  //     href: "/casino/venumegtjackpot-flaming-hot",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FlamingHot.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Flaming Hot",
  //     name: "Flaming Hot",
  //     gameType: gameTypes.new,
  //   },
  //   FlamingHotExtreme: {
  //     href: "/casino/venumegtjackpot-flaming-hot-extreme",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FlamingHotExtreme.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Flaming Hot Extreme",
  //     name: "Flaming Hot Extreme",
  //     gameType: gameTypes.popular,
  //   },
  //   Flowers: {
  //     href: "/casino/venumnetent-flowers",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Flowers.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Flowers",
  //     name: "Flowers",
  //     gameType: gameTypes.new,
  //   },
  //   FlowersChristmasEdition: {
  //     href: "/casino/venumnetent-flowers-christmas-edition",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FlowersChristmasEdition.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Flowers Christmas Edition",
  //     name: "Flowers Christmas Edition",
  //     gameType: gameTypes.popular,
  //   },
  //   FlyingDutchman: {
  //     href: "/casino/venumamatic-flying-dutchman",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FlyingDutchman.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Flying Dutchman",
  //     name: "Flying Dutchman",
  //     gameType: gameTypes.new,
  //   },
  //   FootballSuperSpins: {
  //     href: "/casino/venumgamomat-football-super-spins",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FootballSuperSpins.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Football Super Spins",
  //     name: "Football Super Spins",
  //     gameType: gameTypes.popular,
  //   },
  //   FootballChampionsCup: {
  //     href: "/casino/venumnetent-football-champions-cup",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FootballChampionsCup.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Football: Champions Cup",
  //     name: "Football: Champions Cup",
  //     gameType: gameTypes.new,
  //   },
  //   ForestBand: {
  //     href: "/casino/venumegtjackpot-forest-band",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/ForestBand.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Forest Band",
  //     name: "Forest Band",
  //     gameType: gameTypes.popular,
  //   },
  //   ForestGuardian: {
  //     href: "/casino/venumnovomatic-forest-guardian",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/ForestGuardian.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Forest Guardian",
  //     name: "Forest Guardian",
  //     gameType: gameTypes.new,
  //   },
  //   FortunasFruits: {
  //     href: "/casino/venumamatic-fortunas-fruits",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FortunasFruits.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Fortuna's Fruits",
  //     name: "Fortuna's Fruits",
  //     gameType: gameTypes.popular,
  //   },
  //   FortuneGirl: {
  //     href: "/casino/venumamatic-fortune-girl",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FortuneGirl.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Fortune Girl",
  //     name: "Fortune Girl",
  //     gameType: gameTypes.new,
  //   },
  //   FortuneRangers: {
  //     href: "/casino/venumnetent-fortune-rangers",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FortuneRangers.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Fortune Rangers",
  //     name: "Fortune Rangers",
  //     gameType: gameTypes.popular,
  //   },
  //   FortuneSpells: {
  //     href: "/casino/venumegtjackpot-fortune-spells",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FortuneSpells.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Fortune Spells",
  //     name: "Fortune Spells",
  //     gameType: gameTypes.new,
  //   },
  //   FortuneTeller: {
  //     href: "/casino/venumplayngo-fortune-teller",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FortuneTeller.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Fortune Teller",
  //     name: "Fortune Teller",
  //     gameType: gameTypes.popular,
  //   },
  //   Frankenstein: {
  //     href: "/casino/venumnetent-frankenstein",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Frankenstein.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Frankenstein",
  //     name: "Frankenstein",
  //     gameType: gameTypes.new,
  //   },
  //   frogstory: {
  //     href: "/casino/venumegtjackpot-frog-story",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Frankenstein.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "frog story",
  //     name: "frog story",
  //     // gameType: gameTypes.new,
  //   },
  //   freibier: {
  //     href: "/casino/venumnovomatic-freibier",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Freibier!.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "freibier",
  //     name: "freibier",
  //   },
  //   FruitTumbling: {
  //     href: "/casino/venumnovomatic-fruit-tumbling",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Fruit-==Tumbling.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Fruit Tumbling",
  //     name: "Fruit Tumbling",
  //   },
  //   FruitBox: {
  //     href: "/casino/venumamatic-fruit-box",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FruitBox.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Fruit Box",
  //     name: "Fruit Box",
  //   },
  //   FruitCase: {
  //     href: "/casino/venumnetent-fruit-case",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FruitCase.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Fruit Case",
  //     name: "Fruit Case",
  //   },
  //   FruitExpress: {
  //     href: "/casino/venumamatic-fruit-express",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FruitExpress.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Fruit Express",
  //     name: "Fruit Express",
  //   },
  //   FruitFarm: {
  //     href: "/casino/venumnovomatic-fruit-farm",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FruitFarm.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Fruit Farm",
  //     name: "Fruit Farm",
  //   },
  //   FruitFiesta: {
  //     href: "/casino/venumwazdan-fruit-fiesta",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FruitFiesta.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Fruit Fiesta",
  //     name: "Fruit Fiesta",
  //   },
  //   Fruitilicious: {
  //     href: "/casino/venumnovomatic-fruitilicious",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Fruitilicious.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Fruitilicious",
  //     name: "Fruitilicious",
  //   },
  //   Fruitinator: {
  //     href: "/casino/venummerkur-fruitinator",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Fruitinator.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Fruitinator",
  //     name: "Fruitinator",
  //   },
  //   FruitKing: {
  //     href: "/casino/venumnovomatic-fruit-king",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FruitKing.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Fruit King",
  //     name: "Fruit King",
  //   },
  //   FruitLoop: {
  //     href: "/casino/venumamatic-fruit-loop",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FruitLoop.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Fruit Loop",
  //     name: "Fruit Loop",
  //   },
  //   FruitMania: {
  //     href: "/casino/venumgamomat-fruit-mania",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FruitMania.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Fruit Mania",
  //     name: "Fruit Mania",
  //   },
  //   Fruitopia: {
  //     href: "/casino/venummerkur-fruitopia",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Fruitopia.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Fruitopia",
  //     name: "Fruitopia",
  //   },
  //   FruitRainbow: {
  //     href: "/casino/venumpragmaticplay-fruit-rainbow",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FruitRainbow.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Fruit Rainbow",
  //     name: "Fruit Rainbow",
  //   },
  //   FruitRush: {
  //     href: "/casino/venumgamomat-fruit-rush",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FruitRush.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Fruit Rush",
  //     name: "Fruit Rush",
  //   },
  //   FruitSensation: {
  //     href: "/casino/venumnovomatic-fruit-sensation",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FruitSensation.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Fruit Sensation",
  //     name: "Fruit Sensation",
  //   },
  //   FruitShop: {
  //     href: "/casino/venumnetent-fruit-shop",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FruitShop.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Fruit Shop",
  //     name: "Fruit Shop",
  //   },
  //   FruitshopChristmasEdition: {
  //     href: "/casino/venumnetent-fruitshop-christmas-edition",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FruitshopChristmasEdition.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "FruitshopChristmasEdition",
  //     name: "Fruitshop Christmas Edition",
  //   },
  //   FruitsKingdom: {
  //     href: "/casino/venumegtjackpot-fruits-kingdom",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FruitsKingdom.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "FruitsKingdom",
  //     name: "Fruits Kingdom",
  //   },
  //   FruitsnRoyals: {
  //     href: "/casino/venumnovomatic-fruitsn-royals",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FruitsnRoyals.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "FruitsnRoyals",
  //     name: "Fruits n Royals",
  //   },
  //   FruitSpin: {
  //     href: "/casino/venumnetent-fruit-spin",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FruitSpin.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Fruit Spin",
  //     name: "Fruit Spin",
  //   },
  //   FruitsTastylicious: {
  //     href: "/casino/venummerkur-fruits-tastylicious",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FruitsTastylicious.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Fruits Tasty licious",
  //     name: "Fruits Tastylicious",
  //   },
  //   FuzanglongFireWilds: {
  //     href: "/casino/venumnovomatic-fuzanglong-fire-wilds",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/FuzanglongFireWilds.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "FuzanglongFireWilds",
  //     name: "Fuzang long Fire Wilds",
  //   },
  //   GameofLuck: {
  //     href: "/casino/venumegtjackpot-game-of-luck",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/GameofLuck.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "GameofLuck",
  //     name: "Game of Luck",
  //   },
  //   GameofThrones243Ways: {
  //     href: "/casino/venummicrogaming-game-of-thrones-243-ways",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/GameofThrones243Ways.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "GameofThrones243Ways",
  //     name: "Game of Thrones 243Ways",
  //   },
  //   GangsterParadise: {
  //     href: "/casino/venumnovomatic-gangster-paradise",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/GangsterParadise.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "GangsterParadise",
  //     name: "Gangster Paradise",
  //   },
  //   GatesofOlympus: {
  //     href: "/casino/venumpragmaticplay-gates-of-olympus",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/GatesofOlympus.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "GatesofOlympus",
  //     name: "Gates of Olympus",
  //   },
  //   GemsofGiza: {
  //     href: "/casino/venumnovomatic-gems-of-giza",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/GemsofGiza.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "GemsofGiza",
  //     name: "Gems of Giza",
  //   },
  //   Genies: {
  //     href: "/casino/venumquickspin-genies",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Genies.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Genies",
  //     name: "Genies",
  //   },
  //   GhostPirates: {
  //     href: "/casino/venumnetent-ghost-pirates",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/GhostPirates.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "GhostPirates",
  //     name: "Ghost Pirates",
  //   },
  //   Gladiators: {
  //     href: "/casino/venummerkur-gladiators",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Gladiators.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Gladiators",
  //     name: "Gladiators",
  //   },
  //   GloriousRome: {
  //     href: "/casino/venumpragmaticplay-glorious-rome",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/GloriousRome.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "GloriousRome",
  //     name: "Glorious Rome",
  //   },
  //   GoldBeaver: {
  //     href: "/casino/venummerkur-gold-beaver",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/GoldBeaver.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "GoldBeaver",
  //     name: "Gold Beaver",
  //   },
  //   Goldbird: {
  //     href: "/casino/venummerkur-goldbird",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Goldbird.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Goldbird",
  //     name: "Gold bird",
  //   },
  //   GoldCup: {
  //     href: "/casino/venummerkur-gold-cup",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/GoldCup.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "GoldCup",
  //     name: "Gold Cup",
  //   },
  //   GoldenArk: {
  //     href: "/casino/venumnovomatic-golden-ark",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/GoldenArk.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "GoldenArk",
  //     name: "Golden Ark",
  //   },
  //   GoldenBook: {
  //     href: "/casino/venumamatic-golden-book",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/GoldenBook.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "GoldenBook",
  //     name: "Golden Book",
  //   },
  //   GoldenCobrasdeluxe: {
  //     href: "/casino/venumnovomatic-golden-cobras-deluxe",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/GoldenCobrasdeluxe.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "GoldenCobrasdeluxe",
  //     name: "Golden Cobras deluxe",
  //   },
  //   GoldenEggofCrazyChicken: {
  //     href: "/casino/venumgamomat-golden-egg-of-crazy-chicken",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/GoldenEggofCrazyChicken.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "GoldenEggofCrazyChicken",
  //     name: "Golden Egg of Crazy Chicken",
  //   },
  //   GoldenGate: {
  //     href: "/casino/venummerkur-golden-gate",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/GoldenGate.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "GoldenGate",
  //     name: "Golden Gate",
  //   },
  //   GoldenGrimoire: {
  //     href: "/casino/venumnetent-golden-grimoire",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/GoldenGrimoire.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "GoldenGrimoire",
  //     name: "GoldenGrimoire",
  //   },
  //   GoldenJoker: {
  //     href: "/casino/venumamatic-golden-joker",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/GoldenJoker.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "GoldenJoker",
  //     name: "Golden Joker",
  //   },
  //   GoldenLegend: {
  //     href: "/casino/venumplayngo-golden-legend",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/GoldenLegend.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "GoldenLegend",
  //     name: "Golden Legend",
  //   },
  //   GoldenQuest: {
  //     href: "/casino/venumamatic-golden-quest",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/GoldenQuest.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "GoldenQuest",
  //     name: "Golden Quest",
  //   },
  //   GoldenSphinx: {
  //     href: "/casino/venumwazdan-golden-sphinx",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/GoldenSphinx.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "GoldenSphinx",
  //     name: "Golden Sphinx",
  //   },
  //   GoldFrenzy: {
  //     href: "/casino/venummerkur-gold-frenzy",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/GoldFrenzy.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "GoldFrenzy",
  //     name: "Gold Frenzy",
  //   },
  //   GoldilocksandtheWildBears: {
  //     href: "/casino/venumquickspin-goldilocks-and-the-wild-bears",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/GoldilocksandtheWildBears.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "GoldilocksandtheWildBears",
  //     name: "Gold locks and the Wild Bears",
  //   },
  //   GoldLab: {
  //     href: "/casino/venumquickspin-gold-lab",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/GoldLab.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "GoldLab",
  //     name: "Gold Lab",
  //   },
  //   GoldofPersia: {
  //     href: "/casino/venummerkur-gold-of-persia",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/GoldofPersia.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "GoldofPersia",
  //     name: "Gold of Persia",
  //   },
  //   GoldTrophy2: {
  //     href: "/casino/venumplayngo-gold-trophy-2",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/GoldTrophy2.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "GoldTrophy2",
  //     name: "Gold Trophy2",
  //   },
  //   GonzosQuest: {
  //     href: "/casino/venumnetent-gonzos-quest",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/GonzosQuest.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "GonzosQuest",
  //     name: "Gonzos Quest",
  //   },
  //   Gorilla: {
  //     href: "/casino/venumnovomatic-gorilla",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Gorilla.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Gorilla",
  //     name: "Gorilla",
  //   },
  //   GraceofCleopatra: {
  //     href: "/casino/venumegtjackpot-grace-of-cleopatra",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/GraceofCleopatra.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "GraceofCleopatra",
  //     name: "Grace of Cleopatra",
  //   },
  //   GrandCasanova: {
  //     href: "/casino/venumamatic-grand-casanova",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/GrandCasanova.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "GrandCasanova",
  //     name: "Grand Casanova",
  //   },
  //   GrandFruits: {
  //     href: "/casino/venumamatic-grand-fruits",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/GrandFruits.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "GrandFruits",
  //     name: "Grand Fruits",
  //   },
  //   GrandSpinn: {
  //     href: "/casino/venumnetent-grand-spinn",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/GrandSpinn.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "GrandSpinn",
  //     name: "Grand Spinn",
  //   },
  //   GrandTiger: {
  //     href: "/casino/venumamatic-grand-tiger",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/GrandTiger.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "GrandTiger",
  //     name: "Grand Tiger",
  //   },
  //   GrandWildDragon20: {
  //     href: "/casino/venumamatic-grand-wild-dragon-20",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/GrandWildDragon20.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "GrandWildDragon20",
  //     name: "Grand Wild Dragon20",
  //   },
  //   GrandX: {
  //     href: "/casino/venumamatic-grandx",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/GrandX.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "GrandX",
  //     name: "GrandX",
  //   },
  //   Great27: {
  //     href: "/casino/venumegtjackpot-great-27",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Great27.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Great27",
  //     name: "Great 27",
  //   },
  //   GreatBookofMagic: {
  //     href: "/casino/venumwazdan-great-book-of-magic",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/GreatBookofMagic.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "GreatBookofMagic",
  //     name: "Great Book of Magic",
  //   },
  //   GreatBookofMagicDeluxe: {
  //     href: "/casino/venumwazdan-great-book-of-magic-deluxe",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/GreatBookofMagicDeluxe.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "GreatBookofMagicDeluxe",
  //     name: "Great Book of Magic Deluxe",
  //   },
  //   GreatFortune: {
  //     href: "/casino/venumnovomatic-great-fortune",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/GreatFortune.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "GreatFortune",
  //     name: "Great Fortune",
  //   },
  //   GreatReef: {
  //     href: "/casino/venumpragmaticplay-great-reef",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/GreatReef.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "GreatReef",
  //     name: "Great Reef",
  //   },
  //   GreatRhino: {
  //     href: "/casino/venumpragmaticplay-great-rhino",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/GreatRhino.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "GreatRhino",
  //     name: "Great Rhino",
  //   },
  //   GreatRhinoDeluxe: {
  //     href: "/casino/venumpragmaticplay-great-rhino-deluxe",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/GreatRhinoDeluxe.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "GreatRhinoDeluxe",
  //     name: "Great Rhino Deluxe",
  //   },
  //   GryphonsGoldDeluxe: {
  //     href: "/casino/venumnovomatic-gryphons-gold-deluxe",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/GryphonsGoldDeluxe.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "GryphonsGoldDeluxe",
  //     name: "Gryphons GoldDeluxe",
  //   },
  //   GunsNRoses: {
  //     href: "/casino/venumnetent-guns-n-roses",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/GunsNRoses.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "GunsNRoses",
  //     name: "Guns N Roses",
  //   },
  //   HalloftheMountainKing: {
  //     href: "/casino/venumquickspin-hall-of-the-mountain-king",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/HalloftheMountainKing.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "HalloftheMountainKing",
  //     name: "Hall of the MountainKing",
  //   },
  //   Halloween: {
  //     href: "/casino/venumegtjackpot-halloween",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Halloween.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Halloween",
  //     name: "Halloween",
  //   },
  //   HalloweenJack: {
  //     href: "/casino/venumnetent-halloween-jack",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/HalloweenJack.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "HalloweenJack",
  //     name: "Halloween Jack",
  //   },
  //   HappyHalloween: {
  //     href: "/casino/venumplayngo-happy-halloween",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/HappyHalloween.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "HappyHalloween",
  //     name: "Happy Halloween",
  //   },
  //   Harlequeen: {
  //     href: "/casino/venumamatic-harlequeen",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Harlequeen.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Harlequeen",
  //     name: "Harlequeen",
  //   },
  //   HaulofHades: {
  //     href: "/casino/venumnovomatic-haul-of-hades",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/HaulofHades.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "HaulofHades",
  //     name: "Haul of Hades",
  //   },
  //   Helena: {
  //     href: "/casino/venumnovomatic-helena",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Helena.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "Helena",
  //     name: "Helena",
  //   },
  //   HerculesSonofZeus: {
  //     href: "/casino/		venumpragmaticplay-hercules-son-of-zeus",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/HerculesSonofZeus.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "HerculesSonofZeus",
  //     name: "Hercules Son of Zeus",
  //   },
  //   HiddenValley: {
  //     href: "/casino/venumquickspin-hidden-valley",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/HiddenValley.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "HiddenValley",
  //     name: "Hidden Valley",
  //   },
  //   HighschoolManga: {
  //     href: "/casino/venumwazdan-highschool-manga",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/HighschoolManga.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "HighschoolManga",
  //     name: "High school Manga",
  //   },
  //   HighwaytoHell: {
  //     href: "/casino/venumwazdan-highway-to-hell",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/HighwaytoHell.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "HighwaytoHell",
  //     name: "High way to Hell",
  //   },
  //   HighwaytoHellDeluxe: {
  //     href: "/casino/venumwazdan-highway-to-hell-deluxe",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/HighwaytoHellDeluxe.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "HighwaytoHellDeluxe",
  //     name: "Highway to Hell Deluxe",
  //   },
  //   HockeyLeague: {
  //     href: "/casino/venumpragmaticplay-hockey-league",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/HockeyLeague.webp",
  //     plaBtn: "./images/play.png",
  //     alt: "HockeyLeague",
  //     name: "Hockey League",
  //   },
  //   tmp2F_NicerDice100: {
  //     href: "/casino/venumamatic-nicer-dice-100",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Amatic/tmp2F_NicerDice100.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "tmp2F_NicerDice100",
  //     name: "Nicer Dice 100",
  //   },
  //   AllWaysCandy: {
  //     href: "/casino/venumamatic-all-ways-candy",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Amatic/AllWaysCandy.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "AllWaysCandy",
  //     name: "All Ways Candy",
  //   },
  //   AllWaysFruits: {
  //     href: "/casino/venumamatic-allways-fruits",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Amatic/AllWaysFruits.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "AllWaysFruits",
  //     name: "All Ways Fruits",
  //   },
  //   AllWaysHotFruits: {
  //     href: "/casino/venumamatic-all-ways-hot-fruits",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/Amatic/AllWaysHotFruits.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "AllWayshotFruits",
  //     name: "All Ways Hot Fruits",
  //   },
  //   Hot27: {
  //     href: "/casino/venumamatic-hot-27",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/Hot27.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "Hot27",
  //     name: "Hot 27",
  //   },
  //   Hot40: {
  //     href: "/casino/venumamatic-hot-40",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/Hot40.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "Hot40",
  //     name: "Hot 40",
  //   },
  //   Hot81: {
  //     href: "/casino/venumamatic-hot-81",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/Hot81.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "Hot81",
  //     name: "Hot 81",
  //   },
  //   HotChoice: {
  //     href: "/casino/venumamatic-hot-choice",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/HotChoice.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "HotChoice",
  //     name: "Hot Choice",
  //   },
  //   HotChoiceDeluxe: {
  //     href: "/casino/venumamatic-hot-choice-deluxe",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/HotChoiceDeluxe.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "HotChoiceDeluxe",
  //     name: "Hot Choice Deluxe",
  //   },
  //   HotDiamonds: {
  //     href: "/casino/venumamatic-hot-diamonds",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/HotDiamonds.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "HotDiamonds",
  //     name: "Hot Diamonds",
  //   },
  //   Hotfootball: {
  //     href: "/casino/venumamatic-hot-football",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/HotFootball.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "HotFootball",
  //     name: "Hot Football",
  //   },
  //   HotFruits10: {
  //     href: "/casino/venumamatic-hot-fruits-10",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/HotFruits10.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "HotFruits10",
  //     name: "Hot Fruits10",
  //   },
  //   HotFruits100: {
  //     href: "/casino/venumamatic-hot-fruits-100",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/HotFruits100.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "HotFruits100",
  //     name: "Hot Fruits100",
  //   },
  //   HotFruits20: {
  //     href: "/casino/venumamatic-hot-fruits-20",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/HotFruits20.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "HotFruits20",
  //     name: "Hot Fruits 20",
  //   },
  //   HotFruits27: {
  //     href: "/casino/venumamatic-hot-fruits-27",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/HotFruits27.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "HotFruits27",
  //     name: "Hot Fruits 27",
  //   },

  //   HotFruits40: {
  //     href: "/casino/venumamatic-hot-fruits-40",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/HotFruits40.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "HotFruits40",
  //     name: "Hot Fruits 40",
  //   },
  //   HotFruitsDeluxe: {
  //     href: "/casino/venumamatic-hot-fruits-deluxe",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/HotFruitsDeluxe.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "HotFruitsDeluxe",
  //     name: "Hot Fruit sDeluxe",
  //   },
  //   HotNeon: {
  //     href: "/casino/venumamatic-hot-neon",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/HotNeon.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "HotNeon",
  //     name: "Hot Neon",
  //   },
  //   HotScatterDeluxe: {
  //     href: "/casino/venumamatic-hot-scatter-deluxe",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/HotScatterDeluxe.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "HotScatterDeluxe",
  //     name: "Hot Scatter Deluxe",
  //   },
  //   HotSeven: {
  //     href: "/casino/venumamatic-hot-seven",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/HotSeven.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "HotSeven",
  //     name: "Hot Seven",
  //   },
  //   HotSoccer: {
  //     href: "/casino/venumamatic-hot-soccer",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/HotSoccer.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "HotSoccer",
  //     name: "Hot Soccer",
  //   },
  //   HotStar: {
  //     href: "/casino/venumamatic-hot-star",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/HotStar.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "HotStar",
  //     name: "Hot Star",
  //   },
  //   HottestFruits20: {
  //     href: "/casino/venumamatic-hottest-fruits-20",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/HottestFruits20.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "HottestFruits20",
  //     name: "Hottest Fruits 20",
  //   },
  //   HottestFruits40: {
  //     href: "/casino/venumamatic-hottest-fruits-40",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/HottestFruits40.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "HottestFruits40",
  //     name: "Hottest Fruits 40",
  //   },
  //   HotTwenty: {
  //     href: "/casino/venumamatic-hot-twenty",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/HotTwenty.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "HotTwenty",
  //     name: "HotTwenty",
  //   },
  //   JokerX: {
  //     href: "/casino/venumamatic-joker-x",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/JokerX.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "JokerX",
  //     name: "JokerX",
  //   },
  //   KingsCrown: {
  //     href: "/casino/venumamatic-kings-crown",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/KingsCrown.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "KingsCrown",
  //     name: "King's Crown",
  //   },
  //   LadyFruits20: {
  //     href: "/casino/venumamatic-lady-fruits-20",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/LadyFruits20.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "LadyFruits20",
  //     name: "Lady Fruits 20",
  //   },
  //   LadyFruits40Easter: {
  //     href: "/casino/venumamatic-lady-fruits-40-easter",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/LadyFruits40Easter.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "LadyFruits40Easter",
  //     name: "Lady Fruits 40 Easter",
  //   },
  //   LadyFruits100Easter: {
  //     href: "/casino/venumamatic-lady-fruits-100-easter",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/LadyFruits100Easter.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "LadyFruits100Easter",
  //     name: "Lady Fruits 100 Easter",
  //   },
  //   LadyJoker: {
  //     href: "/casino/venumamatic-lady-joker",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/LadyJoker.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "LadyJoker",
  //     name: "Lady Joker",
  //   },
  //   LaGranAventura: {
  //     href: "/casino/venumamatic-la-gran-aventura",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/LaGranAventura.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "LaGranAventura",
  //     name: "La Gran Aventura",
  //   },
  //   LovelyLady: {
  //     href: "/casino/venumamatic-lovely-lady",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/LovelyLady.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "LovelyLady",
  //     name: "Lovely Lady",
  //   },
  //   LovelyLadyDeluxe: {
  //     href: "/casino/venumamatic-lovely-lady-deluxe",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/LovelyLadyDeluxe.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "LovelyLadyDeluxe",
  //     name: "Lovely Lady Deluxe",
  //   },
  //   LovelyLadyXmas: {
  //     href: "/casino/venumamatic-lovely-lady-xmas",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/LovelyLadyXmas.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "LovelyLadyXmas",
  //     name: "Lovely Lady Xmas",
  //   },
  //   LuckyBells: {
  //     href: "/casino/venumamatic-lucky-bells",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/LuckyBells.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "LuckyBells",
  //     name: "Lucky Bells",
  //   },
  //   LuckyCoin: {
  //     href: "/casino/venumamatic-lucky-coin",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/LuckyCoin.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "LuckyCoin",
  //     name: "Lucky Coin",
  //   },
  //   LuckyDouble: {
  //     href: "/casino/venumamatic-lucky-double",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/LuckyDouble.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "LuckyDouble",
  //     name: "Lucky Double",
  //   },
  //   LuckyGolden7: {
  //     href: "/casino/venumamatic-lucky-golden-7",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/LuckyGolden7.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "LuckyGolden7",
  //     name: "Lucky Golden 7",
  //   },
  //   LuckyJoker5: {
  //     href: "/casino/venumamatic-lucky-joker-5",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/LuckyJoker5.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "LuckyJoker5",
  //     name: "Lucky Joker 5",
  //   },
  //   LuckyJoker10: {
  //     href: "/casino/venumamatic-lucky-joker-10",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/LuckyJoker10.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "LuckyJoker10",
  //     name: "Lucky Joker 10",
  //   },
  //   LuckyJoker20: {
  //     href: "/casino/venumamatic-lucky-joker-20",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/LuckyJoker20.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "LuckyJoker20",
  //     name: "Lucky Joker 20",
  //   },
  //   LuckyJoker40: {
  //     href: "/casino/venumamatic-lucky-joker-40",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/LuckyJoker40.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "LuckyJoker40",
  //     name: "Lucky Joker 40",
  //   },
  //   LuckyJoker100: {
  //     href: "/casino/venumamatic-lucky-joker-100",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/LuckyJoker100.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "LuckyJoker100",
  //     name: "Lucky Joker 100",
  //   },
  //   LuckyJokerXmas: {
  //     href: "/casino/venumamatic-lucky-joker-xmas",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/LuckyJokerXmas.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "LuckyJokerXmas",
  //     name: "Lucky Joker Xmas",
  //   },
  //   LuckyZodiac: {
  //     href: "/casino/venumamatic-lucky-zodiac",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/LuckyZodiac.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "LuckyZodiac",
  //     name: "Lucky Zodiac",
  //   },
  //   MagicForest: {
  //     href: "/casino/venumamatic-magic-forest",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/MagicForest.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "MagicForest",
  //     name: "Magic Forest",
  //   },
  //   MagicIdol: {
  //     href: "/casino/venumamatic-magic-idol",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/MagicIdol.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "MagicIdol",
  //     name: "Magic Idol",
  //   },
  //   MagicOwl: {
  //     href: "/casino/venumamatic-magic-owl",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/MagicOwl.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "MagicOwl",
  //     name: "MagicOwl",
  //   },
  //   MegaShark: {
  //     href: "/casino/venumamatic-mega-shark",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/MegaShark.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "MegaShark",
  //     name: "Mega Shark",
  //   },
  //   MermaidsGold: {
  //     href: "/casino/venumamatic-mermaids-gold",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/MermaidsGold.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "MermaidsGold",
  //     name: "Mermaids Gold",
  //   },
  //   MerryFruits: {
  //     href: "/casino/venumamatic-merry-fruits",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/MerryFruits.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "MerryFruits",
  //     name: "Merry Fruits",
  //   },
  //   NicerDice40: {
  //     href: "/casino/venumamatic-nicer-dice-40",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/NicerDice40.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "NicerDice40",
  //     name: "Nicer Dice 40",
  //   },
  //   NicerDice100: {
  //     href: "/casino/venumamatic-nicer-dice-100",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/NicerDice100.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "NicerDice100",
  //     name: "Nicer Dice 100",
  //   },
  //   Oktoberfest: {
  //     href: "/casino/venumamatic-oktoberfest",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/Oktoberfest.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "Oktoberfest",
  //     name: "Oktoberfest",
  //   },
  //   PartyNight: {
  //     href: "/casino/venumamatic-party-night",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/PartyNight.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "Party Night",
  //     name: "Party Night",
  //   },
  //   PartyTime: {
  //     href: "/casino/venumamatic-party-time",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/PartyTime.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "PartyTime",
  //     name: "Party Time",
  //   },
  //   PharaohsGold20: {
  //     href: "/casino/venumamatic-pharaohs-gold-20",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/PharaohsGold20.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "PharaohsGold20",
  //     name: "Pharaohs Gold20",
  //   },
  //   PlentyDragons: {
  //     href: "/casino/venumamatic-plenty-dragons",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/PlentyDragons.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "PlentyDragons",
  //     name: "Plenty Dragons",
  //   },
  //   RedChilli: {
  //     href: "/casino/venumamatic-red-chilli",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/RedChilli.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "RedChilli",
  //     name: "Red Chilli",
  //   },
  //   RouletteRoyal: {
  //     href: "/casino/venumamatic-roulette-royal",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/RouletteRoyal.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "RouletteRoyal",
  //     name: "Roulette Royal",
  //   },
  //   RoyalUnicorn: {
  //     href: "/casino/venumamatic-royal-unicorn",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/RoyalUnicorn.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "RoyalUnicorn",
  //     name: "Royal Unicorn",
  //   },
  //   SakuraSecret: {
  //     href: "/casino/venumamatic-sakura-secret",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/SakuraSecret.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "SakuraSecret",
  //     name: "Sakura Secret",
  //   },
  //   SantasFruits: {
  //     href: "/casino/venumamatic-santas-fruits",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/SantasFruits.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "SantasFruits",
  //     name: "Santa's Fruits",
  //   },
  //   SunGoddess: {
  //     href: "/casino/venumamatic-sun-goddess",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/SunGoddess.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "SunGoddess",
  //     name: "Sun Goddess",
  //   },
  //   TikiMadness100: {
  //     href: "/casino/venumamatic-tiki-madness-100",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/TikiMadness100.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "TikiMadness100",
  //     name: "Tiki Madness 100",
  //   },
  //   TweetyBirds: {
  //     href: "/casino/venumamatic-tweety-birds",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/TweetyBirds.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "TweetyBirds",
  //     name: "Tweety Birds",
  //   },
  //   UltraSeven: {
  //     href: "/casino/venumamatic-ultra-seven",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/UltraSeven.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "UltraSeven",
  //     name: "Ultra Seven",
  //   },
  //   Vampires: {
  //     href: "/casino/venumamatic-vampires",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/Vampires.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "Vampires",
  //     name: "Vampires",
  //   },
  //   Wild7: {
  //     href: "/casino/venumamatic-wild-7",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/Wild7.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "Wild7",
  //     name: "Wild 7",
  //   },
  //   WildAnubis: {
  //     href: "/casino/venumamatic-wild-anubis",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/WildAnubis.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "WildAnubis",
  //     name: "Wild Anubis",
  //   },
  //   WildDragon: {
  //     href: "/casino/venumamatic-wild-dragon",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/WildDragon.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "WildDragon",
  //     name: "Wild Dragon",
  //   },
  //   WildRespin: {
  //     href: "/casino/venumamatic-wild-respin",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/WildRespin.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "WildRespin",
  //     name: "Wild Respin",
  //   },
  //   WildShark: {
  //     href: "/casino/venumamatic-wild-shark",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/WildShark.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "WildShark",
  //     name: "Wild Shark",
  //   },
  //   WildStars: {
  //     href: "/casino/venumamatic-wild-stars",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/WildStars.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "WildStars",
  //     name: "Wild Stars",
  //   },
  //   WildVolcano: {
  //     href: "/casino/venumamatic-wild-volcano",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/WildVolcano.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "WildVolcano",
  //     name: "Wild Volcano",
  //   },
  //   WildWitches: {
  //     href: "/casino/venumamatic-wild-witches",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/WildWitches.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "WildWitches",
  //     name: "Wild Witches",
  //   },
  //   WolfMoon: {
  //     href: "/casino/venumamatic-wolf-moon",
  //     code: "1100088",
  //     casino: "ezugi",
  //     category: "Venum",
  //     provider: "Venum",
  //     homeUrl: "http://localhost:3000/casino/list",
  //     imgUrl: "./images/venum/amatic/WolfMoon.jpg",
  //     plaBtn: "./images/play.png",
  //     alt: "WolfMoon",
  //     name: "Wolf Moon",
  //   },
  // },

  // improvedExperience: {
  //   DreamCatcher: {
  //     code: "98567",
  //     casino: "aura",
  //     provider: "aura",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Dream Catcher",
  //     name: "Dream Catcher",
  //     provider: "aura",
  //     imgUrl: "./images/aura/aura-dream-catcher.webp",
  //     href: "/casino/aura-dream-catcher",
  //   },
  //   TeenpattiT20: {
  //     code: "56768",
  //     casino: "aura",
  //     provider: "aura",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Teenpatti T20",
  //     name: "Teenpatti T20",
  //     provider: "aura",
  //     imgUrl: "./images/aura/Teenpattit20new.webp",
  //     href: "/casino/aura-teenpatti-t20",
  //   },
  //   DragonTiger: {
  //     code: "98790",
  //     casino: "aura",
  //     provider: "aura",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Dragon Tiger",
  //     name: "Dragon Tiger",
  //     provider: "aura",
  //     imgUrl: "./images/aura/aura-dragon-tiger.webp",
  //     href: "/casino/aura-dragon-tiger",
  //   },
  //   UpDown7: {
  //     code: "98789",
  //     casino: "aura",
  //     provider: "aura",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "7 Up Down",
  //     name: "7 Up Down",
  //     provider: "aura",
  //     imgUrl: "./images/aura/7up7down.webp",
  //     href: "/casino/aura-7-up-down",
  //   },
  //   HiLow: {
  //     code: "56968\n",
  //     casino: "aura",
  //     provider: "aura",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Hi Low",
  //     name: "Hi Low",
  //     provider: "aura",
  //     imgUrl: "./images/aura/HigerLower.webp",
  //     href: "/casino/aura-hi-low",
  //   },
  // },

  kingmaker: {
    CardPoker5: {
      href: "/casino/km-5-card-poker",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/CardPoker1.webp",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Card Poker",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    up7down7: {
      href: "/casino/km-7-up-7-down",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/7up7down1.webp",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "7 up 7 down",
      provider: "Kingmaker",
      gameType: gameTypes.new,
    },
    cards32: {
      href: "/casino/km-32-cards",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/32Cards1.webp",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "32 Cards",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    AndarBahar: {
      href: "/casino/km-andar-bahar",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/AndarBahar1.webp",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Andar Bahar",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    Baccarat: {
      href: "/casino/km-baccarat",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/Baccarat1.webp",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Baccarat",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    BaiBuu: {
      href: "/casino/km-bai-buu",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/bai-buu.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Bai Buu",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    BaiCao: {
      href: "/casino/km-bai-cao",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/bai-cao.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Bai Cao",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    Belangkai2: {
      href: "/casino/km-belangkai-2",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/belangkai-2.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Belangkai 2",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    Blackjack: {
      href: "/casino/km-blackjack",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/Blackjack1.webp",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Blackjack",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    BolaGolek: {
      href: "/casino/km-bola-golek",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/bola-golek.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Bola Golek",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    BolaTangkas: {
      redirectUrl: "/casino/km-bola-tangkas",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/bola-tangkas.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Bola Tangkas",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    BonusDice: {
      redirectUrl: "/casino/km-bonus-dice",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/bonus-dice.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Bonus Dice",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    CardHiLo: {
      redirectUrl: "/casino/km-card-hi-lo",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/card-hi-lo.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Card Hi Lo",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    CashRocket: {
      redirectUrl: "/casino/km-cash-rocket",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/cash-rocket.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Cash Rocket",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    CleopatrasTreasure: {
      redirectUrl: "/casino/km-cleopatras-treasure",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/cleopatras-treasure.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Cleopatras Treasure",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    CockfightingArena: {
      redirectUrl: "/casino/km-cockfighting-arena",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/cockfighting-arena.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Cockfighting Arena",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    CoinPusher: {
      redirectUrl: "/casino/km-coin-pusher",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/coin-pusher.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Coin Pusher",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    CoinToss: {
      redirectUrl: "/casino/km-coin-toss",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/coin-toss.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Coin Toss",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    ColorGame: {
      redirectUrl: "/casino/km-color-game",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/color-game.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Color Game",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    DotaHiLo: {
      redirectUrl: "/casino/km-dota-hi-lo",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/dota-hi-lo.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Dota Hi Lo",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    DragonTiger2: {
      redirectUrl: "/casino/km-dragon-tiger-2",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/dragon-tiger-2.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Dragon Tiger 2",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    EliteAviatorClub: {
      redirectUrl: "/casino/km-elite-aviator-club",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/elite-aviator-club.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Elite Aviator Club",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    EuropeanRoulette: {
      redirectUrl: "/casino/km-european-roulette",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/EuropeanRoulette1.webp",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "European Roulette",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    FanTvanClassic: {
      redirectUrl: "/casino/km-fan-tvan-classic",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/fan-tvan-classic.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Fan Tan Classic",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    FishPrawnCrab2: {
      redirectUrl: "/casino/km-fish-prawn-crab-2",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/fish-prawn-crab-2.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Fish Prawn Crab 2",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    FruitRoulette: {
      redirectUrl: "/casino/km-fruit-roulette",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/FruitRoulette1.webp",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "FruitRoulette",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    GemsOfValhalla: {
      redirectUrl: "/casino/km-gems-of-valhalla",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/gems-of-valhalla.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Gems Of Valhalla",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    GoldMines: {
      redirectUrl: "/casino/km-gold-mines",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/gold-mines.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Gold Mines",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    Heist: {
      redirectUrl: "/casino/km-heist",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/heist.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "heist",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    InterstellarRun: {
      redirectUrl: "/casino/km-interstellar-run",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/interstellar-run.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "InterstellarRun",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    JackpotJump: {
      redirectUrl: "/casino/km-jackpot-jump",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/jackpot-jump.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Jackpot Jump",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    JhandiMunda: {
      redirectUrl: "/casino/km-jhandi-munda",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/jhandi-munda.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Jhandi Munda",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    KMPokDeng: {
      redirectUrl: "/casino/km-km-pok-deng",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/km-pok-deng.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "KM Pok Deng",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    KMPowerBall: {
      redirectUrl: "/casino/km-km-power-ball",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/km-power-ball.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "KM Power Ball",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    KMVirtualHorseRacing: {
      redirectUrl: "/casino/km-km-virtual-horse-racing",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/km-virtual-horse-racing.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "KM Virtual Horse Racing",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    Ludo: {
      redirectUrl: "/casino/km-ludo",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/ludo.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Ludo",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    MarbleRacing: {
      redirectUrl: "/casino/km-marble-racing",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/marble-racing.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Marble Racing",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    MaxKeno: {
      redirectUrl: "/casino/km-max-keno",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/max-keno.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Max Keno",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    Minesweeper: {
      redirectUrl: "/casino/km-minesweeper",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/minesweeper.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Minesweeper",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    MonkeyKingRoulette: {
      redirectUrl: "/casino/km-monkey-king-roulette",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/roulette/MonkeyKingRoulette1.webp",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Monkey King Roulette",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    OlympusGlory: {
      redirectUrl: "/casino/km-olympus-glory",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/olympus-glory.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Olympus Glory",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    PaiKang: {
      redirectUrl: "/casino/km-pai-kang",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/pai-kang.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Pai Kang",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    PenguinPanic: {
      redirectUrl: "/casino/km-penguin-panic",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/penguin-panic.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Penguin Panic",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    Plinko: {
      redirectUrl: "/casino/km-plinko",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/plinko.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Plinko",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    PokerRoulette: {
      redirectUrl: "/casino/km-poker-roulette",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/PokerRoulette1.webp",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Poker Roulette",
      provider: "Kingmaker",
      gameType: gameTypes.popular,
    },
    Pusoy: {
      redirectUrl: "/casino/km-pusoy",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/pusoy.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Pusoy",
      provider: "Kingmaker",
      gameType: gameTypes.new,
    },
    RoosterBlitz: {
      redirectUrl: "/casino/km-rooster-blitz",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/rooster-blitz.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Rooster Blitz",
      provider: "Kingmaker",
      gameType: gameTypes.new,
    },
    SicBo: {
      redirectUrl: "/casino/km-sicbo",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/sicbo.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Rooster Blitz",
      provider: "Kingmaker",
      gameType: gameTypes.new,
    },
    SugarBlast: {
      redirectUrl: "/casino/km-sugar-blast",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/sugar-blast.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Sugar Blast",
      provider: "Kingmaker",
      gameType: gameTypes.new,
    },
    SugarBlastFrenzy: {
      redirectUrl: "/casino/km-sugar-blast-frenzy",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/sugar-blast-frenzy.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Sugar Blast Frenzy",
      provider: "Kingmaker",
      gameType: gameTypes.new,
    },
    TaiXiu: {
      redirectUrl: "/casino/km-tai-xiu",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/tai-xiu.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Tai Xiu",
      provider: "Kingmaker",
      gameType: gameTypes.new,
    },
    TeenPatti: {
      redirectUrl: "/casino/km-teen-patti",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/teen-patti.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Teen Patti",
      provider: "Kingmaker",
      gameType: gameTypes.new,
    },
    ThaiFishPrawnCrab: {
      redirectUrl: "/casino/km-thai-fish-prawn-crab",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/thai-fish-prawn-crab.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Thai Fish Prawn Crab",
      provider: "Kingmaker",
      gameType: gameTypes.new,
    },
    ThaiHiLo2: {
      redirectUrl: "/casino/km-thai-hi-lo-2",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/thai-hi-lo-2.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Thai Hi Lo 2",
      provider: "Kingmaker",
      gameType: gameTypes.new,
    },
    Tongits: {
      redirectUrl: "/casino/km-tongits",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/tongits.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Tongits",
      provider: "Kingmaker",
      gameType: gameTypes.new,
    },
    TripleChance: {
      redirectUrl: "/casino/km-triple-chance",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/triple-chance.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Triple Chance",
      provider: "Kingmaker",
      gameType: gameTypes.new,
    },
    VideoPoker: {
      redirectUrl: "/casino/km-video-poker",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/video-poker.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Video Poker",
      provider: "Kingmaker",
      gameType: gameTypes.new,
    },
    VietFishPrawnCrab: {
      redirectUrl: "/casino/km-viet-fish-prawn-crab",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/viet-fish-prawn-crab.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Viet Fish Prawn Crab",
      provider: "Kingmaker",
      gameType: gameTypes.new,
    },
    VirtualAnimalRace: {
      redirectUrl: "/casino/km-virtual-animal-race",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/virtual-animal-race.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Virtual Animal Race",
      provider: "Kingmaker",
      gameType: gameTypes.new,
    },
    VirtualGreyhoundRacing: {
      redirectUrl: "/casino/km-virtual-greyhound-racing",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/virtual-greyhound-racing.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Virtual Greyhound Racing",
      provider: "Kingmaker",
      gameType: gameTypes.new,
    },
    VirtualTreadmillRacing: {
      redirectUrl: "/casino/km-virtual-treadmill-racing",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/virtual-treadmill-racing.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Virtual Treadmill Racing",
      provider: "Kingmaker",
      gameType: gameTypes.new,
    },
    XocLightning: {
      redirectUrl: "/casino/km-xoc-lightning",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/xoc-lightning.jpg",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Xoc Lightning",
      provider: "Kingmaker",
      gameType: gameTypes.new,
    },
  },

  supernowa: {
    ClassicAndarBaharSn: {
      href: "/casino/sn-classic-andar-bahar",
      code: "",
      casino: "wco",
      category: "supernowa",
      provider: "supernowa",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/andarbahar/supernowa/ClassicAndarBahar1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "ClassicAndarBahar",
      name: "Classic AndarBahar ",
      gameType: gameTypes.new,
    },
    GoasAndarBaharSn: {
      href: "/casino/sn-goas-andar-bahar",
      code: "",
      casino: "wco",
      category: "supernowa",
      provider: "supernowa",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/andarbahar/supernowa/GoasAndarBahar1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Goa's Andar Bahar",
      name: "Goa's Andar Bahar",
      gameType: gameTypes.new,
    },
    Cards32Sn: {
      href: "/casino/sn-32-cards",
      code: "",
      casino: "wco",
      category: "supernowa",
      provider: "supernowa",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/andarbahar/supernowa/32Cards1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "32 Cards",
      name: "32 Cards",
      gameType: gameTypes.new,
    },
    AkbarRomeaoWalter: {
      href: "/casino/sn-akbar-romeo-walter",
      code: "",
      casino: "wco",
      category: "supernowa",
      provider: "supernowa",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/andarbahar/supernowa/AkbarRomeoWalter1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Akbar Romeo Walter",
      name: "Akbar Romeo Walter",
      gameType: gameTypes.new,
    },
    baccaratSn: {
      href: "/casino/sn-baccarat",
      code: "",
      casino: "wco",
      category: "supernowa",
      provider: "supernowa",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/andarbahar/supernowa/Baccarat1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Baccarat",
      name: "Baccarat",
      gameType: gameTypes.new,
    },
    DragonTigerSn: {
      href: "/casino/sn-dragon-tiger",
      code: "",
      casino: "wco",
      category: "supernowa",
      provider: "supernowa",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/andarbahar/supernowa/DragonTiger1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "DragonTiger",
      name: "Dragon Tiger",
      gameType: gameTypes.new,
    },
    Lucky7Sn: {
      href: "/casino/sn-lucky-7",
      code: "",
      casino: "wco",
      category: "supernowa",
      provider: "supernowa",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/andarbahar/supernowa/Lucky71.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Lucky7",
      name: "Lucky 7",
      gameType: gameTypes.new,
    },
    RNGDragonTigerSn: {
      href: "/casino/sn-rng-dragon-tiger",
      code: "",
      casino: "wco",
      category: "supernowa",
      provider: "supernowa",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/andarbahar/supernowa/RNGDragonTiger1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "RNG-Dragon-Tiger",
      name: "RNG Dragon Tiger",
      gameType: gameTypes.new,
    },
    TeenPatti2020Sn: {
      href: "/casino/sn-teen-patti-2020",
      code: "",
      casino: "wco",
      category: "supernowa",
      provider: "supernowa",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/andarbahar/supernowa/TeenPatti2020.webp",
      plaBtn: "./images/play-btn.png",
      alt: "TeenPatti2020",
      name: "Teen Patti 2020",
      gameType: gameTypes.new,
    },
    TeenPattiFaceOffSn: {
      href: "/casino/sn-teen-patti-face-off",
      code: "",
      casino: "wco",
      category: "supernowa",
      provider: "supernowa",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/andarbahar/supernowa/TeenPattiFaceOff.webp",
      plaBtn: "./images/play-btn.png",
      alt: "TeenPattiFaceOff",
      name: "Teen Patti Face Off",
      gameType: gameTypes.new,
    },
  },

  worldcasino: {
    CaribbeanPokerPG: {
      href: "/casino/pg-caribbean-poker",
      code: "",
      casino: "pg",
      category: "worldcasino",
      provider: "worldcasino",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/worldcasino/CaribbeanPoker1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Caribbean Poker",
      name: "Caribbean Poker",
      gameType: gameTypes.new,
    },
    ParisSlotsPG: {
      href: "/casino/pg-paris-slots",
      code: "",
      casino: "pg",
      category: "worldcasino",
      provider: "worldcasino",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/worldcasino/ParisSlots1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Paris Slots",
      name: "Paris Slots",
      gameType: gameTypes.new,
    },
    Cards32Sn: {
      href: "/casino/pg-dice-3d",
      code: "",
      casino: "pg",
      category: "worldcasino",
      provider: "worldcasino",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/worldcasino/Dice3D1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Dice 3D",
      name: "Dice 3D",
      gameType: gameTypes.new,
    },
    EgyptSlotsPG: {
      href: "/casino/pg-egypt-slots",
      code: "",
      casino: "pg",
      category: "worldcasino",
      provider: "worldcasino",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/worldcasino/EgyptSlots1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Egypt Slots",
      name: "Egypt Slots",
      gameType: gameTypes.new,
    },
    FruitSlotsPG: {
      href: "/casino/pg-fruit-slots",
      code: "",
      casino: "pg",
      category: "worldcasino",
      provider: "worldcasino",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/worldcasino/FruitSlots1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "fruitslots",
      name: "Fruit Slots",
      gameType: gameTypes.new,
    },
    HeadsOrTailsPG: {
      href: "/casino/pg-heads-or-tails",
      code: "",
      casino: "pg",
      category: "worldcasino",
      provider: "worldcasino",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/worldcasino/Heads&Tails1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "headortails",
      name: "Heads Or Tails",
      gameType: gameTypes.new,
    },
    KenoPG: {
      href: "/casino/pg-keno",
      code: "",
      casino: "pg",
      category: "worldcasino",
      provider: "worldcasino",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/worldcasino/KenoFeelThrillOfRealKeno1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Keno",
      name: "Keno",
      gameType: gameTypes.new,
    },
    Slots3dPG: {
      href: "/casino/pg-slots-3d",
      code: "",
      casino: "pg",
      category: "worldcasino",
      provider: "worldcasino",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/worldcasino/Slots3D1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Slots 3D",
      name: "Slots 3D",
      gameType: gameTypes.new,
    },
    VideoPokerPG: {
      href: "/casino/pg-video-poker",
      code: "",
      casino: "pg",
      category: "worldcasino",
      provider: "worldcasino",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/worldcasino/VideoPoker1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "videopoker",
      name: "Video Poker",
      gameType: gameTypes.new,
    },
    WheelofFortunePG: {
      href: "/casino/qt-wheel-of-fortune",
      code: "",
      casino: "pg",
      category: "worldcasino",
      provider: "worldcasino",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/worldcasino/WheelOfFortune1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Wheel of Fortune",
      name: "Wheel of Fortune",
      gameType: gameTypes.new,
    },
  },

  XPG: {
    AndarBaharXPG: {
      href: "/casino/xpg-andar-bahar",
      code: "",
      casino: "",
      category: "xpg",
      provider: "xpg",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/xpg/AndarBahar1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Andar Bahar",
      name: "Andar Bahar",
      gameType: gameTypes.new,
    },
    DragonRouletteXPG: {
      href: "/casino/xpg-dragon-roulette",
      code: "",
      casino: "",
      category: "xpg",
      provider: "xpg",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/xpg/DragonRoulette1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Dragon Roulette",
      name: "Dragon Roulette",
      gameType: gameTypes.new,
    },
    FastBaccaratXPG: {
      href: "/casino/xpg-fast-baccarat",
      code: "",
      casino: "",
      category: "xpg",
      provider: "xpg",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/xpg/FastBaccarat1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Fast Baccarat",
      name: "Fast Baccarat",
      gameType: gameTypes.new,
    },
    FastRouletteXPG: {
      href: "/casino/xpg-fast-roulette",
      code: "",
      casino: "",
      category: "xpg",
      provider: "xpg",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/xpg/FastRoulette1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Fast Roulette",
      name: "Fast Roulette",
      gameType: gameTypes.new,
    },
    GalaxyAutoRouletteXPG: {
      href: "/casino/xpg-galaxy-auto-roulette",
      code: "",
      casino: "",
      category: "xpg",
      provider: "xpg",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/xpg/GalaxyAutoRoulette1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Galaxy Auto Roulette",
      name: "Galaxy Auto Roulette",
      gameType: gameTypes.new,
    },
    HighBlackjackXPG: {
      href: "/casino/xpg-high-blackjack",
      code: "",
      casino: "",
      category: "xpg",
      provider: "xpg",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/xpg/HighBlackjack1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "High Blackjack",
      name: "High Blackjack",
      gameType: gameTypes.new,
    },
    LesA1TurkceBlackjackXPG: {
      href: "/casino/xpg-lesa-1-turkce-blackjack",
      code: "",
      casino: "",
      category: "xpg",
      provider: "xpg",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/xpg/LesA1TurkceBlackjack1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "LesA 1 Turkce Blackjack	",
      name: "LesA 1 Turkce Blackjack	",
      gameType: gameTypes.new,
    },
    LesA2TurkceBlackjackXPG: {
      href: "/casino/xpg-lesa-2-turkce-blackjack",
      code: "",
      casino: "",
      category: "xpg",
      provider: "xpg",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/xpg/LesA2TurkceBlackjack1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "LesA 2 Turkce Blackjack",
      name: "LesA 2 Turkce Blackjack",
      gameType: gameTypes.new,
    },
    UnlimitedBlackjackXPG: {
      href: "/casino/xpg-unlimited-blackjack",
      code: "",
      casino: "",
      category: "xpg",
      provider: "xpg",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/xpg/UnlimitedBlackjack1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Unlimited Blackjack",
      name: "Unlimited Blackjack",
      gameType: gameTypes.new,
    },
    VIPGoldBaccaratXPG: {
      href: "/casino/xpg-vip-gold-baccarat",
      code: "",
      casino: "",
      category: "xpg",
      provider: "xpg",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/xpg/VIPGoldBaccarat1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "VIP Gold Baccarat",
      name: "VIP Gold Baccarat",
      gameType: gameTypes.new,
    },
  },

  qtech: {
    Tap1Mines: {
      href: "/casino/aggapturbogames-1tap-mines",
      code: "",
      casino: "qtech",
      provider: "qtech",
      category: "qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/1tapmines1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "1Tap Mines",
      name: "1Tap Mines",
      gameType: gameTypes.new,
    },
    TripleSevens777: {
      href: "/casino/aggappopok-777-triple-sevens",
      code: "",
      casino: "qtech",
      provider: "qtech",
      category: "qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/777triplesevens1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "777 Triple Sevens",
      name: "777 Triple Sevens",
      gameType: gameTypes.new,
    },
    ApocalypseSuperxNudge1: {
      href: "/casino/aggapnolimitcity-apocalypse-super-xnudge",
      code: "",
      casino: "qtech",
      provider: "qtech",
      category: "qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/ApocalypseSuperxNudge1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Apocalypse Superx Nudge",
      name: "Apocalypse Superx Nudge",
      gameType: gameTypes.new,
    },
    BarbarianFury1: {
      href: "/casino/aggapnolimitcity-barbarian-fury",
      code: "",
      casino: "qtech",
      provider: "qtech",
      category: "qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/BarbarianFury1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Barbarian Fury",
      name: "Barbarian Fury",
      gameType: gameTypes.new,
    },
    arcadebomb1: {
      href: "/casino/ezgrt-arcade-bomb",
      code: "",
      casino: "qtech",
      provider: "qtech",
      category: "qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/arcadebomb1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Arcade Bomb",
      name: "Arcade Bomb",
      gameType: gameTypes.new,
    },
    BaronLordOfSaturday1: {
      href: "/casino/aggapplayngo-baron-lord-of-saturday",
      code: "",
      casino: "qtech",
      provider: "qtech",
      category: "qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/BaronLordOfSaturday1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Baron Lord Of Saturday ",
      name: "Baron Lord Of Saturday ",
      gameType: gameTypes.new,
    },
    CoinFlip1: {
      href: "/casino/aggapfungames-coin-flip",
      code: "",
      casino: "qtech",
      provider: "qtech",
      category: "qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/CoinFlip1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Coin Flip",
      name: "Coin Flip",
      gameType: gameTypes.new,
    },
    FeeltheBeat1: {
      href: "/casino/aggaphacksawgaming-feel-the-beat",
      code: "",
      casino: "qtech",
      provider: "qtech",
      category: "qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/FeeltheBeat1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Feel the Beat",
      name: "Feel the Beat",
      gameType: gameTypes.new,
    },
    FirstBallonn1: {
      href: "/casino/aggappopok-first-balloon",
      code: "",
      casino: "qtech",
      provider: "qtech",
      category: "qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/FirstBallonn1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "First Ballonn",
      name: "First Ballonn",
      gameType: gameTypes.new,
    },
    SpinninRecordsIntotheBeat1: {
      href: "/casino/aggapplayngo-spinnin-records-into-the-beat",
      code: "",
      casino: "qtech",
      provider: "qtech",
      category: "qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/SpinninRecordsIntotheBeat1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Spinnin' Records Into the Beat",
      name: "Spinnin' Records Into the Beat",
      gameType: gameTypes.new,
    },
  },
};

